var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 362,
    viewBox: "0 0 1920 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.3803 65.5318C76.9966 58.0956 77.1561 45.8793 69.7365 38.2459C62.3169 30.6126 50.1279 30.4528 42.5116 37.889C34.8953 45.3252 34.7358 57.5414 42.1554 65.1748C49.575 72.8082 61.764 72.968 69.3803 65.5318Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6125 51.605L29.1121 51.3126C28.9662 58.183 31.5916 65.0534 36.6964 70.3158C47.0519 80.8407 63.9707 81.133 74.472 70.7544C79.7227 65.6381 82.4939 58.7677 82.4939 51.8973H79.1393",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5303 38.0105C45.3015 44.15 60.616 51.7513 69.6588 38.3029",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4674 60.9604C45.3015 54.3824 62.0744 51.0203 73.0133 60.8143",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8474 74.9936L74.6177 70.7544",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8886 91.9503L95.6205 70.6082C95.6205 70.6082 92.1201 67.3923 88.3279 71.0468C86.5777 69.2926 84.5358 69.7312 82.6397 71.6315C80.5978 73.5318 76.5139 77.6248 75.2013 78.7942C73.8886 80.1098 72.8676 82.7411 74.6178 84.6414C73.1593 86.3955 71.1174 89.0267 73.8886 91.9503Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.26609 157.522C4.98916 153.619 5.66063 146.617 1.76586 141.883C-2.12892 137.15 -9.11506 136.477 -13.8381 140.38C-18.5612 144.284 -19.2327 151.285 -15.3379 156.019C-11.4431 160.753 -4.45698 161.426 0.26609 157.522Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.1859 148.96L-22.2278 148.814C-22.2278 152.761 -20.7693 156.707 -17.8522 159.777C-11.8723 165.917 -2.10022 166.063 4.02556 160.069C7.08845 157.146 8.69282 153.199 8.69282 149.252H6.79674",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.4977 141.066C-12.8933 144.574 -3.99635 148.96 1.25432 141.212",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.2479 154.222C-12.8933 150.422 -3.1212 148.521 3.15044 154.076",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.505 162.408L4.02551 159.923",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.588 172.202L16.1313 159.923C16.1313 159.923 14.0893 158.023 11.9016 160.216C10.8806 159.192 9.71377 159.485 8.54696 160.654C7.38014 161.824 5.04652 164.016 4.31726 164.893C3.588 165.624 3.00459 167.232 4.02555 168.255C3.15044 168.986 1.98363 170.594 3.588 172.202Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.865 163.578L22.9863 178.196L38.1549 149.545L67.1795 134.927L51.865 163.578Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9287 145.598L76.6598 160.654C76.6598 160.654 77.2432 168.109 66.7418 178.342C56.2405 188.574 48.6562 187.99 48.6562 187.99L33.9252 172.933",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4868 177.026L44.8641 195.883",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.948 196.029C50.1148 197.199 50.1148 199.245 48.948 200.415C47.7812 201.584 45.7393 201.584 44.5724 200.415C43.4056 199.245 43.4056 197.199 44.5724 196.029C45.8851 194.714 47.7812 194.714 48.948 196.029Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1147 203.192C50.1147 203.192 50.844 207.139 53.1776 209.478C54.3445 208.308 58.4283 204.362 58.4283 204.362C58.4283 204.362 54.782 201.438 52.1567 201.146",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5023 77.4825L-14.8251 103.187L20.0839 139.102L46.4113 113.397L11.5023 77.4825Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5688 79.0865L17.5898 77.9171L52.5942 113.877L26.195 139.751L25.0282 138.435",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.151995 94.3583L-9.04169 103.335L-0.289001 112.339L8.90468 103.363L0.151995 94.3583Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44208 91.5117L10.8805 84.2028",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65082 94.7276L14.0893 87.5648",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92157 117.97L25.174 99.2592",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56781 121.771L28.6744 103.06",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2142 125.425L32.3208 106.714",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7095 -16.4122L-13.0452 -16.6158L-13.3218 33.5234L23.4329 33.727L23.7095 -16.4122Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.195 -11.8365H27.7993L27.5076 38.3027L-9.39288 38.1565V36.4023",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91547 -12.385L-8.91949 -12.4561L-8.98881 0.115294L3.84616 0.186375L3.91547 -12.385Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.51776 8.4823L18.1731 8.62848",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.51776 13.7448L18.1731 13.8909",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.66357 18.861L18.1732 19.0071",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.991 84.667L70.0966 111.902L106.837 149.701L134.732 122.466L97.991 84.667Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4139 91.6588L77.3549 111.243L81.7313 115.746L101.79 96.1612L97.4139 91.6588Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.364 102.942L88.0957 122.731L107.026 142.206L127.294 122.418L108.364 102.942Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5376 113.146L117.061 132.149",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2458 122.794L112.102 136.973",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.642 108.03L122.166 127.179",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.141 127.618L112.977 108.176",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9541 132.442L117.79 113.146",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.767 137.412L122.457 118.116",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.375 49.8509L121.582 58.1831L123.478 74.8474L139.522 81.5716L152.794 71.3391L150.461 54.5286L138.647 49.4124",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.48 46.1965C138.501 47.5121 138.209 49.5586 136.896 50.5818C135.584 51.6051 133.542 51.3127 132.521 49.9971C131.5 48.6815 131.792 46.635 133.104 45.6118C134.417 44.5885 136.313 44.7347 137.48 46.1965Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.061 54.3824C117.936 55.4056 117.644 57.0136 116.623 57.8907C115.602 58.7677 113.998 58.4754 113.123 57.4521C112.248 56.4289 112.539 54.8209 113.56 53.9438C114.727 53.0668 116.331 53.2129 117.061 54.3824Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.752 92.2427C144.918 93.8507 144.627 96.0434 143.022 97.2128C141.418 98.3822 139.23 98.0899 138.063 96.4819C136.896 94.8739 137.188 92.6813 138.793 91.5118C140.397 90.3424 142.585 90.6348 143.752 92.2427Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.026 83.3258C171.901 84.4953 171.755 86.1032 170.588 87.1265C169.421 88.0035 167.817 87.8574 166.796 86.6879C165.921 85.5185 166.067 83.9105 167.234 82.8873C168.4 81.8641 170.151 82.1564 171.026 83.3258Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.463 30.1168C165.629 31.5786 165.338 33.7713 163.879 34.7946C162.421 35.964 160.233 35.6716 159.212 34.2098C158.045 32.7481 158.337 30.5554 159.795 29.5321C161.254 28.3627 163.296 28.6551 164.463 30.1168Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.882 65.6382C186.194 67.3924 185.903 69.8774 184.153 71.193C182.402 72.5086 179.923 72.2163 178.61 70.4621C177.297 68.708 177.589 66.2229 179.339 64.9073C181.09 63.5917 183.569 63.8841 184.882 65.6382Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.461 54.5286L163.587 44.5885L179.485 50.8742L180.798 63.7379",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.794 71.3391L168.255 77.9171L178.318 70.1697",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.275 35.5254L163.587 44.5885",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.644 56.7213L121.582 58.1831",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.251 90.9271L139.522 81.5717",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.255 77.9171L168.4 82.0101",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3636 2.05051L39.6133 10.2365L47.1976 17.2531L57.2614 14.1833L59.595 3.95083L51.8649 -2.91956L44.2806 -0.726879",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3845 -1.75011C43.4055 -1.45775 44.1348 -0.434504 43.843 0.588745C43.5513 1.61199 42.5304 2.34289 41.5094 2.05053C40.4885 1.75817 39.7592 0.734923 40.0509 -0.288326C40.3426 -1.31158 41.3636 -1.89629 42.3845 -1.75011Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9671 10.2365C36.8422 10.3826 37.2797 11.2597 37.1339 11.9906C36.988 12.8677 36.1129 13.3062 35.3837 13.16C34.5085 13.0138 34.071 12.1368 34.2168 11.4059C34.3627 10.5288 35.2378 9.94409 35.9671 10.2365Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5331 17.3993C64.6999 17.6916 65.4292 18.8611 65.1375 20.0305C64.8458 21.1999 63.679 21.9308 62.5121 21.6385C61.3453 21.3461 60.6161 20.1767 60.9078 19.0073C61.1995 17.984 62.3663 17.1069 63.5331 17.3993Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8675 2.48901C73.7426 2.63519 74.326 3.51227 74.0343 4.38934C73.8885 5.26641 73.0134 5.85112 72.1383 5.55876C71.2632 5.41258 70.6797 4.53551 70.9714 3.65844C70.9714 2.78137 71.8466 2.19666 72.8675 2.48901Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.595 3.95094L69.3671 1.02737L71.1173 -6.72009",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2798 11.1136L39.6134 10.2366",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3453 18.1302L57.2614 14.1833",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3672 1.02734L71.1174 2.78149",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.95441 187.697L-14.206 183.019L-26.8951 193.106L-24.1239 209.77L-9.10115 215.471L3.44211 204.946L1.69189 192.667",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58797 189.89C3.00457 191.498 1.25434 192.229 -0.350027 191.644C-1.9544 191.059 -2.68365 189.305 -2.10024 187.697C-1.51684 186.089 0.233381 185.358 1.83775 185.943C3.44212 186.674 4.17138 188.428 3.58797 189.89Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5706 203.923C29.9872 205.677 28.0911 206.408 26.3409 205.823C24.5907 205.238 23.8614 203.338 24.4448 201.584C25.0282 199.83 26.9243 199.099 28.6745 199.684C30.4247 200.415 31.154 202.315 30.5706 203.923Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80887 241.172C10.8906 240.942 12.3927 239.065 12.1638 236.979C11.9349 234.892 10.0617 233.387 7.9799 233.616C5.89812 233.846 4.39608 235.723 4.62499 237.809C4.85391 239.896 6.72709 241.401 8.80887 241.172Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4422 204.946L18.3191 210.647L21.2361 226.873L11.464 234.62",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.10107 215.471L-6.47574 231.405L4.9007 235.79",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0282 204.946L18.319 210.647",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.608 -9.35145C157.608 -9.35145 142.585 -9.05909 140.98 -9.05909C139.376 -9.05909 137.48 -9.78999 135.292 -11.398C133.104 -13.0059 126.249 -17.3913 118.811 -17.2451C111.518 -17.0989 97.6625 -8.3282 97.9542 8.77468C98.2459 26.0237 112.102 28.8011 116.477 28.655C120.853 28.655 124.062 26.7546 126.687 28.5088C129.312 30.2629 132.229 33.1865 133.542 33.1865C134.855 33.1865 134.417 28.9473 135.73 28.8011C137.042 28.655 143.168 27.4855 144.918 27.1932C146.669 26.9008 147.544 25.8776 147.544 22.954C147.544 20.0304 148.127 14.3295 150.898 14.3295C153.67 14.3295 158.774 14.1833 158.774 14.1833",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2668 35.964L103.642 29.8245",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1201 28.9473L97.3707 24.7081",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1401 18.5687L92.2659 15.6451",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.39 6.58215L91.6825 6.28979",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.021 16.9607C126.541 17.1069 126.395 20.6152 124.353 20.3228C122.311 20.0305 120.27 22.077 118.665 21.3461C117.061 20.6152 113.56 22.3693 112.394 20.1767C111.227 17.984 108.164 19.8843 107.726 16.6684C107.435 13.4524 104.809 14.1833 104.809 11.1136C104.809 8.04384 102.476 6.58205 104.372 4.68173C106.122 2.78141 103.497 -0.873047 106.559 -1.45776C109.622 -2.04247 107.289 -5.11222 109.331 -5.40458C111.373 -5.69694 113.706 -9.64376 116.769 -8.47433C119.832 -7.3049 121.582 -10.2285 122.895 -8.03579C124.208 -5.84312 127.27 -9.05904 128.729 -5.98929C130.187 -2.91955 133.542 -3.79662 133.105 -0.580692C132.813 2.78141 136.022 4.38938 134.563 6.72823C133.105 9.06709 135.001 11.8445 132.959 13.0139C131.208 14.0372 133.25 16.6684 129.021 16.9607Z",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.187 16.2299C123.332 13.014 122.02 12.1369 119.686 11.8445C117.207 11.5522 116.04 11.2598 115.311 8.62861C114.581 5.85122 114.435 3.22001 112.248 1.9044C110.206 0.588795 107.58 -1.60388 107.58 -1.60388",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.872 8.62864C109.914 8.04392 111.664 3.36621 113.56 3.36621",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.206 13.0139C112.685 13.1601 115.602 9.79797 115.602 9.79797",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.894 16.376C117.936 15.9374 118.228 14.1833 119.686 12.5753",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.75 6.58208C124.937 7.60533 119.54 4.24322 121.582 -1.60392C123.478 -7.45106 117.644 -8.62048 117.644 -8.62048",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.352 10.6751C117.644 8.92094 119.686 4.68176 122.311 4.68176",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.395 6.72815C125.666 8.62847 126.541 11.9906 128.291 14.0371",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.518 -5.98926C112.102 -3.35805 113.998 -0.726832 118.227 0.0040601",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.104 0.296383C130.333 2.1967 127.27 3.07377 126.541 -0.28833",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.194 21.3461C179.194 21.3461 184.007 10.675 184.736 8.92089C185.174 8.04381 186.341 7.60528 187.945 8.48235C189.841 9.35942 189.403 11.5521 189.403 11.5521C189.403 11.5521 223.095 26.7547 225.575 27.9241C228.054 29.0935 229.659 32.3094 227.762 36.5486C225.866 40.6416 222.366 41.3725 220.178 40.3493C217.99 39.326 183.715 23.8311 183.715 23.8311C183.715 23.8311 182.694 25.8776 180.361 24.7082C178.756 23.9773 178.756 22.2231 179.194 21.3461Z",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.632 19.2994L184.59 23.6848",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.237 22.3693L187.07 24.8543",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.175 21.7845L190.133 26.3161",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.925 25.0005L192.758 27.4855",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.863 24.2695L195.821 28.8011",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.467 27.4855L198.3 29.9705",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.7 26.1699C231.7 26.1699 243.369 0.296335 244.535 -2.33488C245.702 -4.96609 243.66 -10.6671 238.264 -10.6671C232.867 -10.6671 204.28 -9.78998 204.28 -9.78998L190.278 -16.0757C190.278 -16.0757 190.57 -18.2683 188.382 -19.2916C186.924 -20.0225 185.611 -19.1454 185.319 -18.4145C185.028 -17.6836 180.069 -6.86641 179.631 -5.69698C179.194 -4.81991 179.777 -3.79666 181.09 -3.21195C183.132 -2.33488 184.444 -4.2352 184.444 -4.2352C184.444 -4.2352 196.258 1.17341 196.842 1.31958C197.425 1.61194 209.385 15.9374 209.385 15.9374",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.074 -9.79004C223.679 -8.47443 227.033 6.58195 222.22 19.4457",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.7265 75.2859C-11.7265 75.2859 -0.933437 60.5219 0.0875263 59.0601C1.10849 57.5984 0.670932 53.6515 -2.68366 52.9206C-6.03826 52.1898 -24.2697 48.9738 -24.2697 48.9738L-32.2916 43.1267C-32.2916 43.1267 -31.854 41.8111 -33.0209 40.934C-33.896 40.3493 -34.7711 40.6416 -35.0628 41.0802C-35.3545 41.5187 -39.8759 47.6582 -40.4593 48.3891C-40.751 48.8276 -40.6052 49.5585 -39.8759 50.1433C-38.7091 51.0203 -37.6881 49.9971 -37.6881 49.9971C-37.6881 49.9971 -30.9789 54.9671 -30.5414 55.2595C-30.2497 55.5519 -24.5614 66.2229 -24.5614 66.2229",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.113 175.564C210.552 183.166 210.406 195.298 202.822 202.753C195.237 210.209 183.132 210.062 175.693 202.461C168.255 194.86 168.401 182.727 175.985 175.272C183.569 167.817 195.675 167.963 203.113 175.564Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.067 188.867L162.567 188.574C162.421 195.445 165.046 202.315 170.151 207.577C180.506 218.102 197.425 218.395 207.927 208.016C213.177 202.9 215.948 196.029 215.948 189.159H212.594",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.985 175.272C178.756 181.411 194.071 189.013 203.114 175.564",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.922 198.222C178.756 191.644 195.529 188.282 206.468 198.076",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.156 212.255L208.072 208.016",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.343 229.212L229.075 207.87C229.075 207.87 225.575 204.654 221.782 208.308C220.032 206.554 217.99 206.993 216.094 208.893C214.052 210.793 209.968 214.886 208.656 216.056C207.343 217.371 206.322 220.003 208.072 221.903C206.468 223.657 204.426 226.288 207.343 229.212Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.286 293.122C139.115 288.335 138.348 281.343 133.571 277.505C128.795 273.667 121.819 274.437 117.99 279.224C114.16 284.011 114.928 291.002 119.704 294.84C124.481 298.678 131.457 297.909 135.286 293.122Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.123 286.222L111.081 286.075C111.081 290.022 112.539 293.969 115.456 297.039C121.436 303.178 131.208 303.324 137.334 297.331C140.397 294.408 142.001 290.461 142.001 286.514H140.105",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.811 278.328C120.415 281.836 129.312 286.222 134.563 278.474",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.061 291.484C120.415 287.683 130.187 285.783 136.459 291.338",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.814 299.67L137.48 297.331",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.042 309.464L149.586 297.185C149.586 297.185 147.544 295.285 145.356 297.477C144.335 296.454 143.168 296.746 142.001 297.916C140.835 299.085 138.501 301.278 137.772 302.155C137.042 303.032 136.459 304.494 137.48 305.517C136.605 306.248 135.438 307.856 137.042 309.464Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.576 43.7113H290.187V-6.28174L239.576 43.7113ZM281.582 34.6482H262.475L281.582 15.7912V34.6482Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.249 4.82788H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.499 9.06702H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.249 12.8677H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.499 17.1069H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.249 21.0537H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.499 25.2928H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.249 29.2396H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.499 33.4789H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.249 37.2794H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.319 300.839L156.295 315.457L171.609 286.806L200.634 272.188L185.319 300.839Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.383 282.859L210.114 297.916C210.114 297.916 210.698 305.371 200.196 315.603C189.695 325.836 182.111 325.251 182.111 325.251L167.38 310.195",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.941 314.288L178.173 333.145",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.402 333.291C183.569 334.46 183.569 336.507 182.402 337.676C181.236 338.846 179.194 338.846 178.027 337.676C176.86 336.507 176.86 334.46 178.027 333.291C179.34 331.975 181.236 331.975 182.402 333.291Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.569 340.454C183.569 340.454 184.298 344.401 186.632 346.739C187.799 345.57 191.883 341.623 191.883 341.623C191.883 341.623 188.236 338.7 185.611 338.407",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7636 239.591L61.4911 269.119L55.2195 237.398L68.492 207.724L74.7636 239.591Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1174 219.272L91.9743 221.611C91.9743 221.611 97.2249 227.019 95.6206 241.637C94.0162 256.255 87.5987 260.494 87.5987 260.494L66.7419 258.155",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5331 266.049L89.6406 268.972",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8493 266.487C94.5995 266.634 95.7663 268.242 95.4746 269.85C95.3288 271.604 93.7244 272.773 92.12 272.481C90.3698 272.335 89.203 270.727 89.4947 269.119C89.6405 267.511 91.2449 266.195 92.8493 266.487Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3916 271.311C98.3916 271.311 101.454 273.942 104.663 274.235C104.809 272.627 105.538 266.926 105.538 266.926C105.538 266.926 100.871 266.926 98.6833 268.388",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.94 214.708L118.613 240.412L153.522 276.327L179.849 250.622L144.94 214.708Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.878 216.348L151.044 215.179L185.903 251.139L159.65 277.012L158.483 275.696",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.59 231.583L124.396 240.56L133.149 249.564L142.342 240.588L133.59 231.583Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.897 228.773L144.335 221.464",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.105 232.135L147.544 224.827",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.376 255.232L158.483 236.521",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.022 259.032L162.129 240.321",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.669 262.687L165.775 243.976",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.615 149.675L150.457 130.571L124.529 163.504L148.687 182.609L174.615 149.675Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.943 154.076L174.964 154.807L149.002 187.843L124.791 168.694L125.666 167.524",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.381 142.135L151.023 135.525L144.519 143.787L152.877 150.397L159.381 142.135Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.129 144.574L168.984 149.983",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.795 147.498L166.65 152.907",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.543 149.545L158.045 163.432",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.772 152.907L155.42 166.794",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.146 156.415L152.649 170.302",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.428 221.892L203.534 249.127L240.275 286.927L268.169 259.692L231.428 221.892Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.849 229.091L210.79 248.675L215.166 253.178L235.225 233.593L230.849 229.091Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.801 240.167L221.533 259.956L240.463 279.431L260.731 259.643L241.801 240.167Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.846 250.408L250.369 269.411",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.555 260.056L245.41 274.235",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.097 245.292L255.62 264.441",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.596 264.879L246.286 245.438",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.263 269.703L251.099 250.408",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.076 274.674L255.912 255.378",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3502 289.31L53.4817 291.732L56.7486 344.402L95.617 341.98L92.3502 289.31Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2338 294.286L59.2834 296.028L59.6726 302.302L87.6229 300.56L87.2338 294.286Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3335 309.938L60.092 311.698L61.7753 338.835L90.0168 337.076L88.3335 309.938Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1804 311.218L75.7847 337.822",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7629 318.381L68.9297 338.261",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4729 310.78L83.0773 337.384",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.762 318.673L88.328 316.919",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1995 325.544L88.7655 323.789",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6371 332.414L89.2031 330.66",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.225 218.248L273.852 223.072L285.082 215.763L284.207 201.877L272.247 195.883L261.163 203.484L261.6 213.863",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.704 215.91C260.287 214.74 261.746 214.156 263.059 214.74C264.225 215.325 264.809 216.787 264.225 218.102C263.642 219.272 262.183 219.856 260.871 219.272C259.558 218.541 259.121 217.079 259.704 215.91Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.685 227.604C273.122 226.581 274.289 226.288 275.31 226.727C276.331 227.166 276.623 228.335 276.185 229.358C275.748 230.381 274.581 230.674 273.56 230.235C272.539 229.651 272.101 228.481 272.685 227.604Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.333 195.152C291.062 193.691 292.812 193.106 294.125 193.837C295.584 194.568 296.167 196.322 295.438 197.637C294.708 199.099 292.958 199.684 291.646 198.953C290.187 198.222 289.749 196.468 290.333 195.152Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.435 178.78C275.018 177.757 276.185 177.319 277.352 177.757C278.373 178.342 278.811 179.511 278.373 180.681C277.79 181.704 276.623 182.142 275.456 181.704C274.289 181.119 273.852 179.804 274.435 178.78Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.701 202.023C239.431 200.707 241.035 200.122 242.348 200.853C243.66 201.584 244.244 203.192 243.514 204.508C242.785 205.823 241.181 206.408 239.868 205.677C238.555 205.092 238.118 203.485 238.701 202.023Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.933 174.98C257.662 173.372 259.558 172.787 261.162 173.518C262.767 174.249 263.35 176.149 262.621 177.757C261.892 179.365 259.996 179.95 258.391 179.219C256.787 178.488 256.204 176.588 256.933 174.98Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.162 203.485L249.348 197.637L248.327 184.043L257.079 178.488",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.247 195.883L271.518 182.581L262.475 178.049",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.368 201.73L249.348 197.637",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.143 226.288L273.852 223.073",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.625 198.076L284.207 201.877",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.518 182.581L274.435 180.973",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.735 119.139L174.818 128.203L182.694 137.119L194.508 134.634L198.3 123.379L190.133 114.608L181.236 116.362",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.339 114.9C180.506 115.339 181.09 116.508 180.798 117.678C180.36 118.847 179.194 119.432 178.027 119.139C176.86 118.701 176.277 117.531 176.568 116.362C176.86 115.193 178.173 114.608 179.339 114.9Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.734 127.764C171.609 128.056 172.193 129.08 171.901 129.957C171.609 130.834 170.588 131.419 169.713 131.126C168.838 130.834 168.255 129.811 168.546 128.933C168.838 128.056 169.859 127.472 170.734 127.764Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.363 139.02C202.676 139.458 203.405 140.92 202.967 142.236C202.53 143.551 201.071 144.282 199.759 143.844C198.446 143.405 197.717 141.943 198.154 140.628C198.592 139.312 200.05 138.581 201.363 139.02Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.469 122.94C214.49 123.232 214.927 124.256 214.636 125.279C214.344 126.302 213.323 126.741 212.302 126.448C211.281 126.156 210.844 125.133 211.135 124.109C211.427 123.232 212.448 122.648 213.469 122.94Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.528 94.8738C189.841 95.3123 190.424 96.6279 189.987 97.7973C189.549 99.1129 188.236 99.6976 187.07 99.2591C185.757 98.8206 185.174 97.505 185.611 96.3355C185.903 95.1661 187.215 94.4352 188.528 94.8738Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.49 107.299C215.948 107.737 216.678 109.345 216.24 110.807C215.803 112.269 214.198 113 212.74 112.561C211.281 112.123 210.552 110.515 210.989 109.053C211.427 107.591 213.031 106.86 214.49 107.299Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.133 114.608L193.779 103.644L205.447 100.867L211.427 107.737",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.3 123.379L209.677 121.04L212.448 112.415",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.403 98.8206L193.779 103.644",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.047 128.933L174.818 128.202",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.738 139.604L194.508 134.634",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.677 121.04L211.427 123.232",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.853 319.258L109.768 322.181L105.684 335.922L116.04 346.447L129.896 342.792L133.542 328.905L125.958 321.012",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.104 318.088C126.541 319.55 125.666 321.012 124.207 321.304C122.749 321.743 121.29 320.866 120.999 319.404C120.561 317.942 121.436 316.48 122.895 316.188C124.207 315.749 125.666 316.627 126.104 318.088Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.58 317.65C107.872 318.819 107.143 319.842 106.122 320.135C104.955 320.427 103.934 319.696 103.642 318.673C103.351 317.65 104.08 316.48 105.101 316.188C106.122 315.896 107.289 316.627 107.58 317.65Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.894 356.241C116.332 357.849 115.311 359.457 113.706 359.895C112.102 360.334 110.497 359.311 110.06 357.703C109.622 356.095 110.643 354.487 112.248 354.048C113.852 353.61 115.456 354.633 115.894 356.241Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.105 358.141C140.397 359.311 139.668 360.626 138.501 360.919C137.334 361.211 136.021 360.48 135.73 359.311C135.438 358.141 136.167 356.826 137.334 356.533C138.647 356.241 139.814 356.972 140.105 358.141Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.503 314.434C152.94 316.042 151.919 317.504 150.461 317.942C148.856 318.381 147.398 317.357 146.96 315.896C146.523 314.288 147.544 312.826 149.002 312.387C150.607 311.949 152.211 312.826 152.503 314.434Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.732 348.932C157.17 350.686 156.149 352.586 154.399 353.025C152.649 353.464 150.753 352.44 150.315 350.686C149.877 348.932 150.898 347.032 152.649 346.593C154.545 346.008 156.295 347.178 156.732 348.932Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.542 328.905L147.106 325.397L157.462 335.63L154.253 346.155",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.896 342.793L139.814 353.025L150.169 350.248",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.148 317.942L147.106 325.397",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.143 319.843L109.768 322.181",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.706 354.048L116.04 346.447",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.814 353.025L138.501 356.241",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.416 125.571C287.416 125.571 273.268 125.717 271.664 125.864C270.06 125.864 268.309 125.133 266.267 123.671C264.225 122.209 257.662 117.97 250.661 118.116C243.66 118.262 230.68 126.448 230.971 142.674C231.263 158.9 244.39 161.531 248.473 161.531C252.557 161.531 255.62 159.631 258.246 161.385C260.725 163.139 263.496 165.77 264.663 165.77C265.83 165.77 265.538 161.823 266.851 161.677C268.163 161.531 273.852 160.362 275.602 160.216C277.206 160.069 278.081 159.046 278.081 156.269C278.081 153.491 278.665 148.083 281.29 148.083C283.915 148.083 288.729 147.937 288.729 147.937",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.284 168.402L236.514 162.554",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.575 161.824L230.534 157.731",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.741 151.883L225.72 149.106",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.282 140.628L224.991 140.335",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.178 129.226L226.304 131.565",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.429 119.14L230.68 123.086",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.451 112.123L236.805 117.093",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.433 150.568C258.1 150.714 257.954 154.076 256.058 153.784C254.162 153.491 252.12 155.392 250.661 154.661C249.203 153.93 245.848 155.684 244.827 153.491C243.806 151.445 240.743 153.199 240.451 150.129C240.16 147.059 237.826 147.79 237.68 144.867C237.68 141.943 235.493 140.628 237.243 138.727C238.993 136.827 236.368 133.465 239.285 132.88C242.202 132.295 240.014 129.372 241.91 129.226C243.806 129.079 245.994 125.279 248.911 126.302C251.828 127.325 253.432 124.694 254.745 126.741C256.058 128.787 258.975 125.717 260.287 128.641C261.6 131.565 264.809 130.687 264.517 133.757C264.225 136.827 267.288 138.435 265.83 140.628C264.371 142.82 266.121 145.451 264.225 146.475C262.475 147.644 264.517 150.129 260.433 150.568Z",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.891 149.691C255.037 146.621 253.87 145.744 251.536 145.452C249.203 145.159 248.182 144.867 247.452 142.382C246.723 139.751 246.577 137.266 244.535 135.95C242.639 134.634 240.16 132.734 240.16 132.734",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.451 142.528C242.347 141.943 243.952 137.558 245.702 137.558",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.639 146.767C244.973 146.913 247.744 143.698 247.744 143.698",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.89 149.983C249.786 149.545 250.078 147.937 251.536 146.329",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.162 140.628C256.641 141.505 251.536 138.435 253.432 132.88C255.328 127.325 249.64 126.156 249.64 126.156",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.348 144.574C249.494 142.967 251.536 138.874 254.016 138.874",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.954 140.774C257.225 142.674 258.1 145.744 259.704 147.644",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.952 128.641C244.39 131.126 246.286 133.611 250.224 134.196",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.225 134.634C261.6 136.388 258.683 137.266 257.954 134.196",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7382 340.892C38.7382 340.892 36.6963 327.005 36.4046 325.397C36.1129 323.936 36.6963 322.035 37.8631 319.843C39.0299 317.65 42.2386 310.633 41.2177 303.763C40.1967 296.893 30.4246 285.198 14.5268 287.537C-1.37108 289.876 -2.2462 303.178 -1.66279 307.125C-1.07938 311.218 1.1084 313.995 -0.204268 316.627C-1.51694 319.258 -3.85057 322.328 -3.70472 323.497C-3.55886 324.666 0.233285 323.789 0.670841 325.105C0.962544 326.274 2.85862 331.829 3.29617 333.437C3.73373 335.045 4.75469 335.63 7.52588 335.337C10.2971 335.045 15.5477 334.753 15.9853 337.384C16.4228 340.015 17.0063 344.693 17.0063 344.693",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.72552 284.76L-0.0582638 289.145",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17133 277.889L7.67177 283.298",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1102 274.82L16.1312 281.544",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4867 275.258L24.8823 281.69",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9881 279.205L33.9252 284.76",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0098 286.075L40.4884 290.022",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8806 317.65C10.4431 315.311 7.08848 315.75 7.23434 313.849C7.38019 311.949 5.1924 310.195 5.62996 308.733C6.06751 307.125 4.02559 304.055 5.92167 302.886C7.81774 301.57 5.62996 298.939 8.54699 298.208C11.464 297.477 10.4431 295.285 13.3601 294.846C16.2771 294.408 17.2981 292.215 19.34 293.531C21.382 294.992 24.299 292.069 25.32 294.846C26.3409 297.624 28.8204 294.992 29.258 296.893C29.6955 298.793 33.7794 300.401 33.0501 303.324C32.3209 306.248 35.2379 307.564 33.3418 309.025C31.4457 310.487 34.8003 312.972 32.175 314.726C29.5497 316.481 30.7165 319.404 27.6536 319.55C24.5907 319.696 23.4239 322.912 21.0903 321.743C18.7566 320.574 16.423 322.766 15.1103 321.012C13.9435 319.112 11.7557 321.451 10.8806 317.65Z",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8806 312.095C13.7976 311.949 14.5269 310.487 14.5269 308.294C14.5269 305.956 14.6727 304.932 17.0063 303.763C19.4858 302.74 21.9653 302.155 22.8404 300.108C23.8614 298.062 25.4657 295.431 25.4657 295.431",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1312 296.893C16.8604 298.647 21.5277 299.67 21.6735 301.424",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1932 299.67C12.3391 302.009 15.8395 304.201 15.8395 304.201",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85962 305.225C10.443 306.979 12.1933 307.125 13.9435 308.295",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5068 316.919C19.0483 312.534 21.5278 307.125 27.0702 308.294C32.6125 309.464 33.1959 303.763 33.1959 303.763",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.256 305.956C16.8604 305.956 21.0901 307.271 21.3818 309.903",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0692 313.849C18.1731 313.411 15.2561 314.58 13.5059 316.48",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1331 298.5C27.7994 299.378 25.6117 301.424 25.4658 305.371",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9243 319.258C24.8824 316.919 23.7156 314.142 26.6326 312.972",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.559 354.925C266.559 354.925 254.745 348.347 253.432 347.616C252.12 346.886 250.369 346.739 248.036 347.032C245.702 347.47 238.264 347.909 232.575 344.693C226.741 341.477 219.595 328.759 227.033 315.311C234.471 301.863 246.577 305.517 250.078 307.417C253.432 309.318 255.328 312.241 258.099 311.949C261.017 311.657 264.517 310.633 265.538 311.218C266.559 311.803 264.517 314.872 265.538 315.603C266.559 316.334 270.789 319.843 272.101 320.72C273.414 321.597 273.56 322.912 272.393 325.105C271.226 327.444 269.184 332.122 271.372 333.437C273.56 334.607 277.644 336.945 277.644 336.945",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.576 294.261L240.451 301.132",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.971 296.893L233.305 302.594",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.782 302.594L225.429 307.564",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.511 311.364L221.053 314.58",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.01 321.743L218.136 322.474",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.865 332.56L217.99 331.683",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.511 342.062L220.47 339.43",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.183 322.035C253.286 320.866 254.745 317.942 252.995 317.358C251.245 316.773 250.369 314.288 248.911 314.142C247.307 314.142 245.265 311.218 243.514 312.387C241.764 313.703 240.014 310.779 238.41 313.265C236.805 315.603 235.055 313.995 233.742 316.48C232.43 318.965 229.95 319.112 230.679 321.451C231.263 323.789 227.616 325.397 229.804 327.298C231.992 329.052 228.783 330.514 230.388 331.537C231.846 332.56 232.138 336.799 234.909 337.092C237.826 337.53 237.972 340.454 240.014 339.284C241.91 338.115 243.077 341.915 245.556 340.161C248.036 338.261 250.224 340.454 251.39 337.676C252.557 334.899 255.766 335.045 255.62 332.56C255.474 330.075 258.1 328.613 256.933 326.859C255.474 325.251 258.391 324.082 255.183 322.035Z",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.078 320.135C248.911 322.766 247.452 322.912 245.41 322.181C243.369 321.304 242.348 321.158 240.597 322.912C238.847 324.666 237.534 326.859 235.347 327.005C233.159 327.151 230.242 327.736 230.242 327.736",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.763 319.696C236.076 321.012 235.492 325.544 236.951 326.274",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.555 317.065C240.597 317.942 241.472 321.889 241.472 321.889",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.389 316.919C245.848 318.088 245.265 319.696 245.848 321.597",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.245 330.514C247.89 327.736 242.202 328.028 241.327 333.583C240.451 338.992 235.201 337.53 235.201 337.53",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.223 322.035C242.639 323.497 242.493 327.736 244.681 328.906",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.619 329.052C248.911 327.151 250.953 324.959 253.141 324.082",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.554 332.853C233.159 330.952 235.784 329.783 239.285 330.952",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.244 336.945C249.932 334.314 247.744 332.268 245.702 334.607",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.14 98.8207C246.14 98.8207 247.306 88.7344 247.598 87.1264C247.744 86.3955 248.619 85.6646 250.078 85.8108C251.974 86.1032 251.974 88.0035 251.974 88.0035C251.974 88.0035 283.915 91.9503 286.249 92.2427C288.583 92.535 290.77 94.8739 290.333 98.8207C289.895 102.768 287.124 104.083 284.936 103.937C282.894 103.645 250.515 99.6978 250.515 99.6978C250.515 99.6978 250.078 101.598 247.89 101.306C246.431 101.16 245.994 99.6978 246.14 98.8207Z",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.682 95.1663L251.245 99.4054",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.87 97.359L253.578 99.6979",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.079 95.8971L256.495 100.136",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.266 98.0898L258.975 100.429",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.329 96.4819L261.892 100.721",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.517 98.6744L264.225 101.013",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.916 89.3191C290.916 89.3191 293.979 64.9073 294.271 62.4222C294.562 59.9372 291.354 55.698 286.978 57.1598C282.457 58.6216 259.12 66.6614 259.12 66.6614L245.848 65.0534C245.848 65.0534 245.556 63.1531 243.514 62.8608C242.202 62.7146 241.327 63.7378 241.181 64.4687C241.035 65.1996 239.868 75.4321 239.722 76.6015C239.576 77.3324 240.306 78.2095 241.618 78.3557C243.514 78.648 244.098 76.7477 244.098 76.7477C244.098 76.7477 255.328 78.0633 255.912 78.2095C256.495 78.2095 270.059 87.1264 270.059 87.1264",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.702 65.0535L245.265 69.2926",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.473 65.3458L248.182 67.6847",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.682 65.7844L251.099 70.0236",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.307 66.0767L254.016 68.4155",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.706 61.9836C275.456 62.5684 282.019 74.2626 281.29 86.1031",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3489 202.461C89.3489 202.461 93.7244 196.468 94.4537 195.445C94.7454 195.006 95.6205 194.86 96.4956 195.591C97.6624 196.468 96.9332 197.783 96.9332 197.783C96.9332 197.783 116.186 211.963 117.644 212.986C119.103 214.009 119.686 216.348 117.936 218.687C116.186 221.026 113.852 221.026 112.685 220.003C111.373 219.125 91.9742 204.8 91.9742 204.8C91.9742 204.8 91.0991 205.969 89.7864 204.946C88.7655 204.069 88.9113 203.046 89.3489 202.461Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3079 202.169L92.4119 204.8",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8914 204.361L93.8704 205.823",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5167 204.508L95.6206 207.139",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1 206.7L97.079 208.162",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.725 206.847L98.8293 209.478",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.309 209.185L100.288 210.501",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.728 212.548C121.728 212.548 132.521 197.784 133.542 196.322C134.563 194.86 134.125 190.913 130.771 190.182C127.416 189.451 109.185 186.235 109.185 186.235L101.163 180.388C101.163 180.388 101.6 179.073 100.434 178.196C99.5586 177.611 98.6835 177.903 98.3918 178.342C98.1 178.78 93.5786 184.92 92.9952 185.651C92.7035 186.089 92.8494 186.82 93.5786 187.405C94.7455 188.282 95.7664 187.259 95.7664 187.259C95.7664 187.259 102.476 192.229 102.913 192.521C103.205 192.813 108.893 203.484 108.893 203.484",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.309 180.535L99.4127 183.02",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.913 181.704L101.892 183.019",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.809 183.166L102.913 185.651",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.414 184.335L105.393 185.651",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.561 188.574C121.436 189.597 121.582 199.538 116.769 206.993",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.22 63.2993L216.823 95.6048L223.97 96.9204L229.513 64.3226L226.741 56.7213L222.22 63.2993Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.513 64.3225C229.513 64.3225 226.304 65.9305 222.074 63.1531",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.699 90.6346L224.699 91.9503",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9279 274.82L36.2589 247.777L30.2789 251.87L48.8021 279.205L56.2406 282.713L54.9279 274.82Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8021 279.205C48.8021 279.205 49.9689 275.843 54.9279 274.82",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1759 252.016L33.3419 255.816",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.479 313.265L287.999 262.979L276.769 263.418L279.102 313.995L285.811 324.52L290.479 313.265Z",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.102 313.995C279.102 313.995 283.332 310.487 290.479 313.265",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.291 270.873L277.498 271.019",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.787 14.6218L279.54 -8.91293L274.435 -14.0292L251.39 9.50556L249.348 17.3992L256.787 14.6218Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.39 9.50549C251.39 9.50549 254.891 9.94403 256.787 14.6217",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.8 65.5318C456.416 58.0956 456.576 45.8793 449.156 38.2459C441.737 30.6126 429.548 30.4528 421.931 37.889C414.315 45.3252 414.156 57.5414 421.575 65.1748C428.995 72.8082 441.184 72.968 448.8 65.5318Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.032 51.605L408.532 51.3126C408.386 58.183 411.011 65.0534 416.116 70.3158C426.472 80.8407 443.391 81.133 453.892 70.7544C459.143 65.6381 461.914 58.7677 461.914 51.8973H458.559",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.95 38.0105C424.721 44.15 440.036 51.7513 449.079 38.3029",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.887 60.9604C424.721 54.3824 441.494 51.0203 452.433 60.8143",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.267 74.9936L454.038 70.7544",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.308 91.9503L475.04 70.6082C475.04 70.6082 471.54 67.3923 467.748 71.0468C465.998 69.2926 463.956 69.7312 462.06 71.6315C460.018 73.5318 455.934 77.6248 454.621 78.7942C453.308 80.1098 452.288 82.7411 454.038 84.6414C452.579 86.3955 450.537 89.0267 453.308 91.9503Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.686 157.522C384.409 153.619 385.08 146.617 381.186 141.883C377.291 137.15 370.305 136.477 365.582 140.38C360.859 144.284 360.187 151.285 364.082 156.019C367.977 160.753 374.963 161.426 379.686 157.522Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.234 148.96L357.192 148.814C357.192 152.761 358.651 156.707 361.568 159.777C367.548 165.917 377.32 166.063 383.445 160.069C386.508 157.146 388.113 153.199 388.113 149.252H386.217",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.922 141.066C366.527 144.574 375.424 148.96 380.674 141.212",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.172 154.222C366.527 150.422 376.299 148.521 382.57 154.076",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.925 162.408L383.445 159.923",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.008 172.202L395.551 159.923C395.551 159.923 393.509 158.023 391.321 160.216C390.3 159.192 389.134 159.485 387.967 160.654C386.8 161.824 384.466 164.016 383.737 164.893C383.008 165.624 382.424 167.232 383.445 168.255C382.57 168.986 381.403 170.594 383.008 172.202Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.809 288.56L296.226 321.45L303.518 321.743L304.248 288.706L300.456 281.544L296.809 288.56Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.248 288.706C304.248 288.706 301.331 290.753 296.809 288.706",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.372 316.334L303.373 316.627",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.748 332.268L337.502 303.178L308.915 273.796L307.748 332.268ZM327.147 302.74L315.916 313.703L316.353 291.63L327.147 302.74Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.853 282.421L313.874 281.544",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.312 285.929L316.208 284.029",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.52 287.245L318.541 286.368",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.979 290.753L320.875 288.853",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.188 292.069L323.063 291.192",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.646 295.577L325.542 293.677",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.855 296.746L327.73 295.869",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.313 300.401L330.209 298.354",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.522 301.57L332.397 300.693",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.285 163.578L402.406 178.196L417.575 149.545L446.599 134.927L431.285 163.578Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.349 145.598L456.08 160.654C456.08 160.654 456.663 168.109 446.162 178.342C435.66 188.574 428.076 187.99 428.076 187.99L413.345 172.933",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.907 177.026L424.284 195.883",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.368 196.029C429.535 197.199 429.535 199.245 428.368 200.415C427.201 201.584 425.159 201.584 423.992 200.415C422.825 199.245 422.825 197.199 423.992 196.029C425.305 194.714 427.201 194.714 428.368 196.029Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.535 203.192C429.535 203.192 430.264 207.139 432.598 209.478C433.764 208.308 437.848 204.362 437.848 204.362C437.848 204.362 434.202 201.438 431.577 201.146",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.729 102.329L307.456 131.857L301.331 99.9901L314.457 70.462L320.729 102.329Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.083 82.0101L337.94 84.349C337.94 84.349 343.19 89.7576 341.586 104.375C339.981 118.993 333.564 123.232 333.564 123.232L312.707 120.894",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.498 128.787L335.606 131.711",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.96 129.226C340.711 129.372 341.877 130.98 341.586 132.588C341.44 134.342 339.835 135.511 338.231 135.219C336.481 135.073 335.314 133.465 335.606 131.857C335.752 130.249 337.21 128.933 338.96 129.226Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.357 134.05C344.357 134.05 347.42 136.681 350.629 136.973C350.774 135.365 351.504 129.664 351.504 129.664C351.504 129.664 346.836 129.664 344.649 131.126",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.922 77.4825L364.595 103.187L399.504 139.102L425.831 113.397L390.922 77.4825Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.989 79.0865L397.009 77.9171L432.014 113.877L405.615 139.751L404.448 138.435",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.572 94.3583L370.378 103.335L379.131 112.339L388.324 103.363L379.572 94.3583Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.862 91.5117L390.3 84.2028",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.071 94.7276L393.509 87.5648",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.341 117.97L404.594 99.2592",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.988 121.771L408.094 103.06",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.634 125.425L411.741 106.714",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.129 -16.4122L366.375 -16.6158L366.098 33.5234L402.853 33.727L403.129 -16.4122Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.615 -11.8365H407.219L406.927 38.3027L370.027 38.1565V36.4023",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.335 -12.385L370.5 -12.4561L370.431 0.115294L383.266 0.186375L383.335 -12.385Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.902 8.4823L397.593 8.62848",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.902 13.7448L397.593 13.8909",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.756 18.861L397.593 19.0071",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.411 84.667L449.516 111.902L486.257 149.701L514.152 122.466L477.411 84.667Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.834 91.6588L456.775 111.243L461.151 115.746L481.21 96.1612L476.834 91.6588Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.783 102.942L467.516 122.731L486.446 142.206L506.714 122.418L487.783 102.942Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.957 113.146L496.481 132.149",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.666 122.794L491.521 136.973",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.062 108.03L501.585 127.179",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.561 127.618L492.397 108.176",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.374 132.442L497.21 113.146",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.187 137.412L501.877 118.116",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.312 152.047L299.444 154.469L302.711 207.139L341.579 204.718L338.312 152.047Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.342 157.015L305.392 158.756L305.781 165.03L333.731 163.288L333.342 157.015Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.296 172.675L306.055 174.435L307.738 201.573L335.979 199.813L334.296 172.675Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.146 173.956L321.896 200.561",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.728 180.973L314.895 200.853",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.438 173.518L329.043 199.976",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.727 181.411L334.293 179.657",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.165 188.282L334.731 186.528",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.602 195.152L335.168 193.398",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.795 49.8509L501.002 58.1831L502.898 74.8474L518.942 81.5716L532.214 71.3391L529.881 54.5286L518.067 49.4124",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.9 46.1965C517.921 47.5121 517.629 49.5586 516.316 50.5818C515.004 51.6051 512.962 51.3127 511.941 49.9971C510.92 48.6815 511.211 46.635 512.524 45.6118C513.837 44.5885 515.733 44.7347 516.9 46.1965Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.48 54.3824C497.356 55.4056 497.064 57.0136 496.043 57.8907C495.022 58.7677 493.418 58.4754 492.542 57.4521C491.667 56.4289 491.959 54.8209 492.98 53.9438C494.147 53.0668 495.751 53.2129 496.48 54.3824Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.171 92.2427C524.338 93.8507 524.046 96.0434 522.442 97.2128C520.838 98.3822 518.65 98.0899 517.483 96.4819C516.316 94.8739 516.608 92.6813 518.212 91.5118C519.817 90.3424 522.004 90.6348 523.171 92.2427Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.446 83.3258C551.321 84.4953 551.175 86.1032 550.008 87.1265C548.841 88.0035 547.237 87.8574 546.216 86.6879C545.341 85.5185 545.487 83.9105 546.653 82.8873C547.82 81.8641 549.57 82.1564 550.446 83.3258Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.882 30.1168C545.049 31.5786 544.757 33.7713 543.299 34.7946C541.84 35.964 539.653 35.6716 538.632 34.2098C537.465 32.7481 537.757 30.5554 539.215 29.5321C540.674 28.3627 542.716 28.6551 543.882 30.1168Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.302 65.6382C565.614 67.3924 565.323 69.8774 563.572 71.193C561.822 72.5086 559.343 72.2163 558.03 70.4621C556.717 68.708 557.009 66.2229 558.759 64.9073C560.509 63.5917 562.989 63.8841 564.302 65.6382Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.881 54.5286L543.007 44.5885L558.905 50.8742L560.218 63.7379",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.214 71.3391L547.674 77.9171L557.738 70.1697",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.695 35.5254L543.007 44.5885",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.064 56.7213L501.002 58.1831",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.671 90.9271L518.942 81.5717",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.674 77.9171L547.82 82.0101",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.783 2.05051L419.033 10.2365L426.617 17.2531L436.681 14.1833L439.015 3.95083L431.285 -2.91956L423.7 -0.726879",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.804 -1.75011C422.825 -1.45775 423.554 -0.434504 423.263 0.588745C422.971 1.61199 421.95 2.34289 420.929 2.05053C419.908 1.75817 419.179 0.734923 419.471 -0.288326C419.762 -1.31158 420.783 -1.89629 421.804 -1.75011Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.387 10.2365C416.262 10.3826 416.699 11.2597 416.554 11.9906C416.408 12.8677 415.533 13.3062 414.803 13.16C413.928 13.0138 413.491 12.1368 413.637 11.4059C413.782 10.5288 414.658 9.94409 415.387 10.2365Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.953 17.3993C444.12 17.6916 444.849 18.8611 444.557 20.0305C444.266 21.1999 443.099 21.9308 441.932 21.6385C440.765 21.3461 440.036 20.1767 440.328 19.0073C440.619 17.984 441.786 17.1069 442.953 17.3993Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.287 2.48901C453.162 2.63519 453.746 3.51227 453.454 4.38934C453.308 5.26641 452.433 5.85112 451.558 5.55876C450.683 5.41258 450.1 4.53551 450.391 3.65844C450.391 2.78137 451.266 2.19666 452.287 2.48901Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.015 3.95094L448.787 1.02737L450.537 -6.72009",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.7 11.1136L419.033 10.2366",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.765 18.1302L436.681 14.1833",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.787 1.02734L450.537 2.78149",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.465 187.697L365.214 183.019L352.525 193.106L355.296 209.77L370.319 215.471L382.862 204.946L381.112 192.667",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.008 189.89C382.424 191.498 380.674 192.229 379.07 191.644C377.466 191.059 376.736 189.305 377.32 187.697C377.903 186.089 379.653 185.358 381.258 185.943C382.862 186.674 383.591 188.428 383.008 189.89Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.089 177.465C365.652 178.634 364.193 179.365 363.026 178.78C361.859 178.342 361.13 176.88 361.714 175.71C362.151 174.541 363.61 173.81 364.776 174.395C365.943 174.833 366.527 176.295 366.089 177.465Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.733 218.687C348.003 220.441 346.107 221.318 344.357 220.733C342.607 220.003 341.732 218.102 342.315 216.348C343.044 214.594 344.941 213.717 346.691 214.302C348.441 214.886 349.316 216.933 348.733 218.687Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.881 236.375C369.444 237.69 367.839 238.421 366.527 237.836C365.214 237.398 364.485 235.79 365.068 234.474C365.506 233.159 367.11 232.428 368.423 233.012C369.735 233.597 370.465 235.059 369.881 236.375Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.99 203.923C409.407 205.677 407.511 206.408 405.761 205.823C404.011 205.238 403.281 203.338 403.865 201.584C404.448 199.83 406.344 199.099 408.094 199.684C409.845 200.415 410.574 202.315 409.99 203.923Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.229 241.172C390.311 240.942 391.813 239.065 391.584 236.979C391.355 234.892 389.482 233.387 387.4 233.616C385.318 233.846 383.816 235.723 384.045 237.809C384.274 239.896 386.147 241.401 388.229 241.172Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.862 204.946L397.739 210.647L400.656 226.873L390.884 234.62",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.319 215.471L372.944 231.405L384.321 235.79",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.448 204.946L397.739 210.647",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.339 179.219L365.214 183.019",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.003 215.179L355.296 209.77",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.944 231.404L369.59 233.597",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.027 -9.35145C537.027 -9.35145 522.005 -9.05909 520.4 -9.05909C518.796 -9.05909 516.9 -9.78999 514.712 -11.398C512.524 -13.0059 505.669 -17.3913 498.231 -17.2451C490.938 -17.0989 477.082 -8.3282 477.374 8.77468C477.666 26.0237 491.522 28.8011 495.897 28.655C500.273 28.655 503.481 26.7546 506.107 28.5088C508.732 30.2629 511.649 33.1865 512.962 33.1865C514.274 33.1865 513.837 28.9473 515.15 28.8011C516.462 28.655 522.588 27.4855 524.338 27.1932C526.089 26.9008 526.964 25.8776 526.964 22.954C526.964 20.0304 527.547 14.3295 530.318 14.3295C533.089 14.3295 538.194 14.1833 538.194 14.1833",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.687 35.964L483.062 29.8245",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.54 28.9473L476.791 24.7081",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.56 18.5687L471.686 15.6451",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.81 6.58215L471.102 6.28979",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.44 16.9607C505.961 17.1069 505.815 20.6152 503.773 20.3228C501.731 20.0305 499.689 22.077 498.085 21.3461C496.481 20.6152 492.98 22.3693 491.813 20.1767C490.646 17.984 487.584 19.8843 487.146 16.6684C486.854 13.4524 484.229 14.1833 484.229 11.1136C484.229 8.04384 481.895 6.58205 483.791 4.68173C485.542 2.78141 482.916 -0.873047 485.979 -1.45776C489.042 -2.04247 486.709 -5.11222 488.75 -5.40458C490.792 -5.69694 493.126 -9.64376 496.189 -8.47433C499.252 -7.3049 501.002 -10.2285 502.315 -8.03579C503.627 -5.84312 506.69 -9.05904 508.149 -5.98929C509.607 -2.91955 512.962 -3.79662 512.524 -0.580692C512.233 2.78141 515.441 4.38938 513.983 6.72823C512.524 9.06709 514.42 11.8445 512.378 13.0139C510.628 14.0372 512.67 16.6684 508.44 16.9607Z",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.606 16.2299C502.752 13.014 501.44 12.1369 499.106 11.8445C496.626 11.5522 495.46 11.2598 494.73 8.62861C494.001 5.85122 493.855 3.22001 491.667 1.9044C489.626 0.588795 487 -1.60388 487 -1.60388",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.292 8.62864C489.334 8.04392 491.084 3.36621 492.98 3.36621",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.626 13.0139C492.105 13.1601 495.022 9.79797 495.022 9.79797",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.314 16.376C497.356 15.9374 497.647 14.1833 499.106 12.5753",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.17 6.58208C504.357 7.60533 498.96 4.24322 501.002 -1.60392C502.898 -7.45106 497.064 -8.62048 497.064 -8.62048",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.772 10.6751C497.064 8.92094 499.106 4.68176 501.731 4.68176",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.815 6.72815C505.086 8.62847 505.961 11.9906 507.711 14.0371",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.938 -5.98926C491.522 -3.35805 493.418 -0.726832 497.647 0.0040601",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.524 0.296383C509.753 2.1967 506.69 3.07377 505.961 -0.28833",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.213 15.6452C358.213 15.6452 348.149 6.14361 347.128 5.12036C345.961 4.09711 345.232 2.34296 344.94 0.00410883C344.649 -2.33475 342.753 -9.78985 337.94 -14.3214C332.981 -18.9991 318.395 -21.9227 307.748 -10.5207C296.955 0.881178 304.248 11.6984 307.165 14.3296C310.082 17.107 313.436 17.9841 314.02 20.7615C314.603 23.685 314.749 27.3395 315.624 28.2166C316.499 28.9474 318.833 26.0239 319.854 26.7548C320.875 27.4857 325.542 30.5554 326.855 31.5787C328.167 32.6019 329.334 32.4557 331.23 30.5554C333.126 28.6551 337.064 25.293 338.961 27.0471C340.857 28.8013 344.211 32.0172 344.211 32.0172",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.121 8.04382L297.976 6.87439",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.975 -1.01929L297.101 -0.580753",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.771 14.6219C321.021 13.1601 318.687 15.4989 317.666 13.891C316.499 12.283 313.874 12.4292 313.291 10.8212C312.707 9.35943 309.207 8.19 309.936 6.1435C310.665 3.95083 307.311 3.21993 309.207 0.881076C310.957 -1.45778 308.915 -2.62721 310.811 -4.67371C312.707 -6.7202 312.124 -9.05906 314.603 -9.20524C317.083 -9.35142 317.52 -13.4444 320 -11.8365C322.479 -10.2285 322.771 -13.7368 324.375 -12.7135C325.834 -11.5441 329.918 -12.7135 331.23 -10.0823C332.543 -7.4511 335.46 -8.18199 334.877 -5.84313C334.293 -3.50428 338.523 -3.65045 337.356 -0.726885C336.335 2.19668 339.106 3.80465 336.773 5.70497C334.439 7.60529 335.606 10.8212 333.126 11.4059C330.647 11.9906 330.064 15.0604 328.022 14.4757C326.126 14.0371 325.834 17.1069 322.771 14.6219Z",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.562 10.3828C321.75 8.48244 321.458 7.02066 320 5.26652C318.541 3.51238 317.958 2.63531 319.271 0.296451C320.437 -2.0424 322.188 -3.94272 321.604 -6.1354C321.167 -8.32808 320.729 -11.3978 320.729 -11.3978",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.999 0.00402832C314.457 1.75817 318.541 1.31963 318.541 1.31963",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.457 5.85107C316.062 6.87432 317.374 5.85107 319.416 5.85107",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.918 8.33621C326.126 5.85118 324.813 0.2964 329.772 -2.33481C334.731 -4.81985 331.668 -9.49756 331.668 -9.49756",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.125 3.07365C320.437 2.05041 324.521 0.588621 326.271 2.34276",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.584 6.28967C325.834 7.16674 324.375 9.79796 324.23 12.283",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.043 6.28959C332.981 5.70488 330.501 4.38927 331.96 1.75806",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.774 280.959C350.774 280.959 339.981 274.966 338.815 274.235C337.648 273.504 336.043 273.358 333.856 273.796C331.668 274.089 324.959 274.673 319.562 271.604C314.311 268.68 307.602 256.986 314.457 244.561C321.312 232.135 332.543 235.498 335.606 237.252C338.815 239.006 340.419 241.637 343.044 241.345C345.67 241.052 348.878 240.175 349.899 240.614C350.774 241.052 348.878 243.976 349.899 244.707C350.774 245.438 354.712 248.654 356.025 249.384C357.192 250.262 357.338 251.285 356.317 253.477C355.296 255.67 353.4 259.909 355.442 261.079C357.484 262.248 361.13 264.295 361.13 264.295",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.834 225.265L326.709 231.405",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.958 227.604L320.146 232.72",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.498 232.866L312.999 237.398",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.664 240.906L308.769 243.83",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.601 250.408L306.29 251.139",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.456 260.348L306.144 259.617",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.81 269.119L308.332 266.634",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.273 250.7C338.523 249.531 339.835 247.046 338.231 246.461C336.627 245.876 335.898 243.537 334.439 243.537C332.98 243.537 331.084 240.76 329.48 241.929C327.876 243.099 326.271 240.468 324.813 242.66C323.354 244.853 321.75 243.391 320.583 245.584C319.416 247.776 317.228 247.923 317.666 250.115C318.249 252.308 314.895 253.77 316.937 255.524C318.979 257.132 316.062 258.448 317.374 259.471C318.833 260.494 318.979 264.295 321.604 264.587C324.229 264.879 324.375 267.657 326.271 266.634C328.021 265.464 329.042 269.119 331.376 267.364C333.564 265.61 335.752 267.657 336.773 265.172C337.794 262.687 340.856 262.833 340.711 260.494C340.565 258.155 342.898 256.84 341.877 255.378C340.565 253.624 343.19 252.6 340.273 250.7Z",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.606 248.946C334.585 251.285 333.126 251.577 331.376 250.846C329.48 250.115 328.605 249.823 326.855 251.577C325.25 253.185 324.084 255.232 322.042 255.378C320 255.524 317.374 256.109 317.374 256.109",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.458 248.507C322.771 249.677 322.187 253.916 323.5 254.501",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.959 246.169C326.855 247.046 327.584 250.554 327.584 250.554",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.355 246.022C331.668 247.046 331.23 248.507 331.668 250.262",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.773 258.448C333.71 255.816 328.459 256.255 327.584 261.225C326.709 266.195 322.042 264.879 322.042 264.879",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.188 250.7C328.605 252.016 328.459 255.963 330.501 256.986",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.293 257.132C334.585 255.378 336.481 253.331 338.523 252.6",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.541 260.64C320 258.886 322.333 257.863 325.688 258.886",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.627 264.441C335.314 261.956 333.418 260.202 331.668 262.248",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.614 21.3461C558.614 21.3461 563.427 10.675 564.156 8.92089C564.593 8.04381 565.76 7.60528 567.365 8.48235C569.261 9.35942 568.823 11.5521 568.823 11.5521C568.823 11.5521 602.515 26.7547 604.994 27.9241C607.474 29.0935 609.078 32.3094 607.182 36.5486C605.286 40.6416 601.786 41.3725 599.598 40.3493C597.41 39.326 563.135 23.8311 563.135 23.8311C563.135 23.8311 562.114 25.8776 559.78 24.7082C558.176 23.9773 558.176 22.2231 558.614 21.3461Z",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.052 19.2994L564.01 23.6848",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.656 22.3693L566.49 24.8543",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.594 21.7845L569.552 26.3161",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.345 25.0005L572.178 27.4855",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.283 24.2695L575.241 28.8011",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.887 27.4855L577.72 29.9705",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.12 26.1699C611.12 26.1699 622.788 0.296335 623.955 -2.33488C625.122 -4.96609 623.08 -10.6671 617.683 -10.6671C612.287 -10.6671 583.7 -9.78998 583.7 -9.78998L569.698 -16.0757C569.698 -16.0757 569.99 -18.2683 567.802 -19.2916C566.344 -20.0225 565.031 -19.1454 564.739 -18.4145C564.448 -17.6836 559.489 -6.86641 559.051 -5.69698C558.613 -4.81991 559.197 -3.79666 560.51 -3.21195C562.551 -2.33488 563.864 -4.2352 563.864 -4.2352C563.864 -4.2352 575.678 1.17341 576.262 1.31958C576.845 1.61194 588.805 15.9374 588.805 15.9374",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.494 -9.79004C603.098 -8.47443 606.453 6.58195 601.64 19.4457",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.314 65.1996C335.314 65.1996 339.69 59.2063 340.419 58.1831C340.711 57.7445 341.586 57.5984 342.461 58.3293C343.628 59.2063 342.899 60.5219 342.899 60.5219C342.899 60.5219 362.151 74.7012 363.61 75.7245C365.068 76.7477 365.651 79.0866 363.901 81.4255C362.151 83.7643 359.817 83.7643 358.651 82.7411C357.338 81.864 337.94 67.5385 337.94 67.5385C337.94 67.5385 337.064 68.7079 335.752 67.6847C334.731 66.8076 335.023 65.7844 335.314 65.1996Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.273 64.9072L338.377 67.5384",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.857 67.0999L339.836 68.5616",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.482 67.2461L341.586 69.8773",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.065 69.4388L343.044 70.9006",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.691 69.585L344.795 72.2162",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.274 71.7776L346.253 73.2394",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.693 75.2859C367.693 75.2859 378.486 60.5219 379.507 59.0601C380.528 57.5984 380.091 53.6515 376.736 52.9206C373.382 52.1898 355.15 48.9738 355.15 48.9738L347.128 43.1267C347.128 43.1267 347.566 41.8111 346.399 40.934C345.524 40.3493 344.649 40.6416 344.357 41.0802C344.065 41.5187 339.544 47.6582 338.961 48.3891C338.669 48.8276 338.815 49.5585 339.544 50.1433C340.711 51.0203 341.732 49.9971 341.732 49.9971C341.732 49.9971 348.441 54.9671 348.878 55.2595C349.17 55.5519 354.858 66.2229 354.858 66.2229",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.274 43.2728L345.378 45.7579",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.879 44.4423L347.858 45.7579",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.775 45.9041L349.024 48.3891",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.525 47.0734L351.504 48.389",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.527 51.3126C367.402 52.3359 367.548 62.276 362.734 69.7311",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.831 37.8643L321.458 66.0767L327.73 62.5684L311.249 33.9175L304.102 29.8245L304.831 37.8643Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.249 33.9175C311.249 33.9175 309.936 37.2796 304.831 37.7181",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.833 61.6913L325.105 58.3292",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.533 175.564C589.972 183.166 589.826 195.298 582.242 202.753C574.657 210.209 562.552 210.062 555.113 202.461C547.675 194.86 547.82 182.727 555.405 175.272C562.989 167.817 575.095 167.963 582.533 175.564Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.487 188.867L541.986 188.574C541.841 195.445 544.466 202.315 549.571 207.577C559.926 218.102 576.845 218.395 587.346 208.016C592.597 202.9 595.368 196.029 595.368 189.159H592.014",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.405 175.272C558.176 181.411 573.49 189.013 582.533 175.564",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.342 198.222C558.176 191.644 574.949 188.282 585.888 198.076",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.576 212.255L587.492 208.016",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.763 229.212L608.495 207.87C608.495 207.87 604.994 204.654 601.202 208.308C599.452 206.554 597.41 206.993 595.514 208.893C593.472 210.793 589.388 214.886 588.076 216.056C586.763 217.371 585.742 220.003 587.492 221.903C585.888 223.657 583.846 226.288 586.763 229.212Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.706 293.122C518.535 288.335 517.768 281.343 512.991 277.505C508.215 273.667 501.239 274.437 497.409 279.224C493.58 284.011 494.348 291.002 499.124 294.84C503.901 298.678 510.877 297.909 514.706 293.122Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.543 286.222L490.501 286.075C490.501 290.022 491.959 293.969 494.876 297.039C500.856 303.178 510.628 303.324 516.754 297.331C519.817 294.408 521.421 290.461 521.421 286.514H519.525",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.231 278.328C499.835 281.836 508.732 286.222 513.983 278.474",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.481 291.484C499.835 287.683 509.607 285.783 515.879 291.338",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.233 299.67L516.9 297.331",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.462 309.464L529.006 297.185C529.006 297.185 526.964 295.285 524.776 297.477C523.755 296.454 522.588 296.746 521.421 297.916C520.254 299.085 517.921 301.278 517.192 302.155C516.462 303.032 515.879 304.494 516.9 305.517C516.025 306.248 514.858 307.856 516.462 309.464Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.996 43.7113H669.607V-6.28174L618.996 43.7113ZM661.001 34.6482H641.895L661.001 15.7912V34.6482Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.669 4.82788H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.918 9.06702H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.669 12.8677H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.918 17.1069H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.669 21.0537H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.918 25.2928H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.669 29.2396H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.918 33.4789H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.669 37.2794H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.686 351.417H362.297V301.424L311.686 351.417ZM353.692 342.208H334.585L353.692 323.351V342.208Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.505 312.387H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.755 316.627H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.505 320.427H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.755 324.813H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.505 328.613H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.755 332.852H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.505 336.799H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.755 341.038H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.505 344.839H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.739 300.839L535.715 315.457L551.029 286.806L580.054 272.188L564.739 300.839Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.803 282.859L589.534 297.916C589.534 297.916 590.117 305.371 579.616 315.603C569.115 325.836 561.53 325.251 561.53 325.251L546.799 310.195",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.361 314.288L557.593 333.145",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.822 333.291C562.989 334.46 562.989 336.507 561.822 337.676C560.655 338.846 558.614 338.846 557.447 337.676C556.28 336.507 556.28 334.46 557.447 333.291C558.759 331.975 560.655 331.975 561.822 333.291Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.989 340.454C562.989 340.454 563.718 344.401 566.052 346.739C567.219 345.57 571.303 341.623 571.303 341.623C571.303 341.623 567.656 338.7 565.031 338.407",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.183 239.591L440.911 269.119L434.639 237.398L447.912 207.724L454.183 239.591Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.537 219.272L471.394 221.611C471.394 221.611 476.645 227.019 475.04 241.637C473.436 256.255 467.019 260.494 467.019 260.494L446.162 258.155",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.953 266.049L469.06 268.972",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.269 266.487C474.019 266.634 475.186 268.242 474.894 269.85C474.749 271.604 473.144 272.773 471.54 272.481C469.79 272.335 468.623 270.727 468.914 269.119C469.06 267.511 470.665 266.195 472.269 266.487Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.811 271.311C477.811 271.311 480.874 273.942 484.083 274.235C484.229 272.627 484.958 266.926 484.958 266.926C484.958 266.926 480.291 266.926 478.103 268.388",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.36 214.708L498.032 240.412L532.941 276.327L559.269 250.622L524.36 214.708Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.297 216.348L530.464 215.179L565.323 251.139L539.069 277.012L537.902 275.696",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.009 231.583L503.816 240.56L512.568 249.564L521.762 240.588L513.009 231.583Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.316 228.773L523.755 221.464",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.525 232.135L526.964 224.827",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.796 255.232L537.902 236.521",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.442 259.032L541.549 240.321",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.088 262.687L545.195 243.976",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.035 149.675L529.876 130.571L503.949 163.504L528.107 182.609L554.035 149.675Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.363 154.076L554.384 154.807L528.422 187.843L504.211 168.694L505.086 167.524",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.801 142.135L530.443 135.525L523.939 143.787L532.297 150.397L538.801 142.135Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.549 144.574L548.404 149.983",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.215 147.498L546.07 152.907",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.963 149.545L537.465 163.432",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.192 152.907L534.84 166.794",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.566 156.415L532.068 170.302",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.848 221.892L582.954 249.127L619.695 286.927L647.589 259.692L610.848 221.892Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.269 229.091L590.21 248.675L594.586 253.178L614.645 233.593L610.269 229.091Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.221 240.167L600.953 259.956L619.883 279.431L640.151 259.643L621.221 240.167Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.266 250.408L629.789 269.411",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.974 260.056L624.83 274.235",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.517 245.292L635.04 264.441",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.015 264.879L625.705 245.438",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.683 269.703L630.518 250.408",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.496 274.674L635.332 255.378",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.77 289.31L432.901 291.732L436.168 344.402L475.037 341.98L471.77 289.31Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.654 294.286L438.703 296.028L439.092 302.302L467.043 300.56L466.654 294.286Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.753 309.938L439.512 311.698L441.195 338.835L469.437 337.076L467.753 309.938Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.6 311.218L455.205 337.822",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.183 318.381L448.349 338.261",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.893 310.78L462.497 337.384",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.182 318.673L467.748 316.919",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.619 325.544L468.185 323.789",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.057 332.414L468.623 330.66",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.645 218.248L653.271 223.072L664.502 215.763L663.627 201.877L651.667 195.883L640.582 203.484L641.02 213.863",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.124 215.91C639.707 214.74 641.166 214.156 642.478 214.74C643.645 215.325 644.229 216.787 643.645 218.102C643.062 219.272 641.603 219.856 640.291 219.272C638.978 218.541 638.54 217.079 639.124 215.91Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.105 227.604C652.542 226.581 653.709 226.288 654.73 226.727C655.751 227.166 656.043 228.335 655.605 229.358C655.167 230.381 654.001 230.674 652.98 230.235C651.959 229.651 651.521 228.481 652.105 227.604Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.753 195.152C670.482 193.691 672.232 193.106 673.545 193.837C675.003 194.568 675.587 196.322 674.857 197.637C674.128 199.099 672.378 199.684 671.065 198.953C669.607 198.222 669.169 196.468 669.753 195.152Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.855 178.78C654.438 177.757 655.605 177.319 656.772 177.757C657.793 178.342 658.23 179.511 657.793 180.681C657.209 181.704 656.042 182.142 654.876 181.704C653.709 181.119 653.271 179.804 653.855 178.78Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.121 202.023C618.85 200.707 620.455 200.122 621.767 200.853C623.08 201.584 623.663 203.192 622.934 204.508C622.205 205.823 620.601 206.408 619.288 205.677C617.975 205.092 617.538 203.485 618.121 202.023Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.353 174.98C637.082 173.372 638.978 172.787 640.582 173.518C642.187 174.249 642.77 176.149 642.041 177.757C641.311 179.365 639.415 179.95 637.811 179.219C636.207 178.488 635.623 176.588 636.353 174.98Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.582 203.485L628.768 197.637L627.747 184.043L636.498 178.488",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.667 195.883L650.938 182.581L641.895 178.049",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.788 201.73L628.768 197.637",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.563 226.288L653.271 223.073",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.044 198.076L663.627 201.877",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.938 182.581L653.855 180.973",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.155 119.139L554.238 128.203L562.114 137.119L573.928 134.634L577.72 123.379L569.552 114.608L560.655 116.362",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.759 114.9C559.926 115.339 560.51 116.508 560.218 117.678C559.78 118.847 558.613 119.432 557.447 119.139C556.28 118.701 555.696 117.531 555.988 116.362C556.28 115.193 557.592 114.608 558.759 114.9Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.154 127.764C551.029 128.056 551.613 129.08 551.321 129.957C551.029 130.834 550.008 131.419 549.133 131.126C548.258 130.834 547.675 129.811 547.966 128.933C548.258 128.056 549.279 127.472 550.154 127.764Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.783 139.02C582.096 139.458 582.825 140.92 582.387 142.236C581.95 143.551 580.491 144.282 579.179 143.844C577.866 143.405 577.137 141.943 577.574 140.628C578.012 139.312 579.47 138.581 580.783 139.02Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.889 122.94C593.91 123.232 594.347 124.256 594.055 125.279C593.764 126.302 592.743 126.741 591.722 126.448C590.701 126.156 590.263 125.133 590.555 124.109C590.847 123.232 591.868 122.648 592.889 122.94Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.948 94.8738C569.261 95.3123 569.844 96.6279 569.406 97.7973C568.969 99.1129 567.656 99.6976 566.489 99.2591C565.177 98.8206 564.593 97.505 565.031 96.3355C565.323 95.1661 566.635 94.4352 567.948 94.8738Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.91 107.299C595.368 107.737 596.097 109.345 595.66 110.807C595.222 112.269 593.618 113 592.159 112.561C590.701 112.123 589.972 110.515 590.409 109.053C590.847 107.591 592.451 106.86 593.91 107.299Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.552 114.608L573.199 103.644L584.867 100.867L590.847 107.737",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.72 123.379L589.097 121.04L591.868 112.415",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.823 98.8206L573.199 103.644",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.467 128.933L554.238 128.202",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.158 139.604L573.928 134.634",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.097 121.04L590.847 123.232",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.273 319.258L489.188 322.181L485.104 335.922L495.46 346.447L509.315 342.792L512.962 328.905L505.377 321.012",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.523 318.088C505.961 319.55 505.086 321.012 503.627 321.304C502.169 321.743 500.71 320.866 500.419 319.404C499.981 317.942 500.856 316.48 502.315 316.188C503.627 315.749 505.086 316.627 505.523 318.088Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 317.65C487.292 318.819 486.563 319.842 485.542 320.135C484.375 320.427 483.354 319.696 483.062 318.673C482.77 317.65 483.5 316.48 484.521 316.188C485.542 315.896 486.708 316.627 487 317.65Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.314 356.241C495.751 357.849 494.73 359.457 493.126 359.895C491.522 360.334 489.917 359.311 489.48 357.703C489.042 356.095 490.063 354.487 491.667 354.048C493.272 353.61 494.876 354.633 495.314 356.241Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.525 358.141C519.817 359.311 519.088 360.626 517.921 360.919C516.754 361.211 515.441 360.48 515.15 359.311C514.858 358.141 515.587 356.826 516.754 356.533C518.067 356.241 519.233 356.972 519.525 358.141Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.923 314.434C532.36 316.042 531.339 317.504 529.881 317.942C528.276 318.381 526.818 317.357 526.38 315.896C525.943 314.288 526.964 312.826 528.422 312.387C530.026 311.949 531.631 312.826 531.923 314.434Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.152 348.932C536.59 350.686 535.569 352.586 533.819 353.025C532.068 353.464 530.172 352.44 529.735 350.686C529.297 348.932 530.318 347.032 532.068 346.593C533.965 346.008 535.715 347.178 536.152 348.932Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.962 328.905L526.526 325.397L536.881 335.63L533.673 346.155",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.315 342.793L519.233 353.025L529.589 350.248",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.568 317.942L526.526 325.397",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.563 319.843L489.188 322.181",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.126 354.048L495.46 346.447",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.233 353.025L517.921 356.241",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.836 125.571C666.836 125.571 652.688 125.717 651.084 125.864C649.479 125.864 647.729 125.133 645.687 123.671C643.645 122.209 637.082 117.97 630.081 118.116C623.08 118.262 610.099 126.448 610.391 142.674C610.683 158.9 623.809 161.531 627.893 161.531C631.977 161.531 635.04 159.631 637.665 161.385C640.145 163.139 642.916 165.77 644.083 165.77C645.25 165.77 644.958 161.823 646.271 161.677C647.583 161.531 653.271 160.362 655.022 160.216C656.626 160.069 657.501 159.046 657.501 156.269C657.501 153.491 658.085 148.083 660.71 148.083C663.335 148.083 668.148 147.937 668.148 147.937",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.704 168.402L615.933 162.554",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.994 161.824L609.953 157.731",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.16 151.883L605.14 149.106",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.702 140.628L604.411 140.335",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.598 129.226L605.724 131.565",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.849 119.14L610.099 123.086",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.87 112.123L616.225 117.093",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.853 150.568C637.519 150.714 637.373 154.076 635.477 153.784C633.581 153.491 631.539 155.392 630.081 154.661C628.622 153.93 625.268 155.684 624.247 153.491C623.226 151.445 620.163 153.199 619.871 150.129C619.58 147.059 617.246 147.79 617.1 144.867C617.1 141.943 614.912 140.628 616.663 138.727C618.413 136.827 615.787 133.465 618.704 132.88C621.621 132.295 619.434 129.372 621.33 129.226C623.226 129.079 625.414 125.279 628.331 126.302C631.248 127.325 632.852 124.694 634.165 126.741C635.477 128.787 638.394 125.717 639.707 128.641C641.02 131.565 644.229 130.687 643.937 133.757C643.645 136.827 646.708 138.435 645.249 140.628C643.791 142.82 645.541 145.451 643.645 146.475C641.895 147.644 643.937 150.129 639.853 150.568Z",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.311 149.691C634.456 146.621 633.29 145.744 630.956 145.452C628.622 145.159 627.601 144.867 626.872 142.382C626.143 139.751 625.997 137.266 623.955 135.95C622.059 134.634 619.58 132.734 619.58 132.734",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.871 142.528C621.767 141.943 623.372 137.558 625.122 137.558",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.059 146.767C624.393 146.913 627.164 143.698 627.164 143.698",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.31 149.983C629.206 149.545 629.497 147.937 630.956 146.329",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.582 140.628C636.061 141.505 630.956 138.435 632.852 132.88C634.748 127.325 629.06 126.156 629.06 126.156",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.768 144.574C628.914 142.967 630.956 138.874 633.436 138.874",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.374 140.774C636.644 142.674 637.519 145.744 639.124 147.644",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.372 128.641C623.809 131.126 625.705 133.611 629.643 134.196",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.645 134.634C641.02 136.388 638.103 137.266 637.373 134.196",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.158 340.892C418.158 340.892 416.116 327.005 415.824 325.397C415.533 323.936 416.116 322.035 417.283 319.843C418.45 317.65 421.658 310.633 420.638 303.763C419.617 296.893 409.844 285.198 393.947 287.537C378.049 289.876 377.174 303.178 377.757 307.125C378.34 311.218 380.528 313.995 379.216 316.627C377.903 319.258 375.569 322.328 375.715 323.497C375.861 324.666 379.653 323.789 380.091 325.105C380.382 326.274 382.278 331.829 382.716 333.437C383.154 335.045 384.175 335.63 386.946 335.337C389.717 335.045 394.968 334.753 395.405 337.384C395.843 340.015 396.426 344.693 396.426 344.693",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.152 292.215L375.424 295.577",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.694 284.76L379.362 289.145",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.591 277.889L387.092 283.298",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.53 274.82L395.551 281.544",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.907 275.258L404.302 281.69",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.408 279.205L413.345 284.76",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.43 286.075L419.908 290.022",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3 317.65C389.863 315.311 386.508 315.75 386.654 313.849C386.8 311.949 384.612 310.195 385.05 308.733C385.487 307.125 383.445 304.055 385.342 302.886C387.238 301.57 385.05 298.939 387.967 298.208C390.884 297.477 389.863 295.285 392.78 294.846C395.697 294.408 396.718 292.215 398.76 293.531C400.802 294.992 403.719 292.069 404.74 294.846C405.761 297.624 408.24 294.992 408.678 296.893C409.115 298.793 413.199 300.401 412.47 303.324C411.741 306.248 414.658 307.564 412.762 309.025C410.866 310.487 414.22 312.972 411.595 314.726C408.97 316.481 410.136 319.404 407.073 319.55C404.011 319.696 402.844 322.912 400.51 321.743C398.176 320.574 395.843 322.766 394.53 321.012C393.363 319.112 391.176 321.451 390.3 317.65Z",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3 312.095C393.217 311.949 393.947 310.487 393.947 308.294C393.947 305.956 394.093 304.932 396.426 303.763C398.906 302.74 401.385 302.155 402.26 300.108C403.281 298.062 404.886 295.431 404.886 295.431",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.551 296.893C396.28 298.647 400.948 299.67 401.093 301.424",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.613 299.67C391.759 302.009 395.259 304.201 395.259 304.201",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.279 305.225C389.863 306.979 391.613 307.125 393.363 308.295",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.927 316.919C398.468 312.534 400.948 307.125 406.49 308.294C412.032 309.464 412.616 303.763 412.616 303.763",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.676 305.956C396.28 305.956 400.51 307.271 400.802 309.903",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.489 313.849C397.593 313.411 394.676 314.58 392.926 316.48",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.553 298.5C407.219 299.378 405.032 301.424 404.886 305.371",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.344 319.258C404.302 316.919 403.135 314.142 406.052 312.972",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.979 354.925C645.979 354.925 634.165 348.347 632.852 347.616C631.539 346.886 629.789 346.739 627.455 347.032C625.122 347.47 617.683 347.909 611.995 344.693C606.161 341.477 599.014 328.759 606.453 315.311C613.891 301.863 625.997 305.517 629.497 307.417C632.852 309.318 634.748 312.241 637.519 311.949C640.436 311.657 643.937 310.633 644.958 311.218C645.979 311.803 643.937 314.872 644.958 315.603C645.979 316.334 650.208 319.843 651.521 320.72C652.834 321.597 652.98 322.912 651.813 325.105C650.646 327.444 648.604 332.122 650.792 333.437C652.98 334.607 657.063 336.945 657.063 336.945",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.996 294.261L619.871 301.132",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.391 296.893L612.725 302.594",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.202 302.594L604.848 307.564",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.93 311.364L600.473 314.58",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.43 321.743L597.556 322.474",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.284 332.56L597.41 331.683",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.93 342.062L599.889 339.43",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.602 322.035C632.706 320.866 634.165 317.942 632.414 317.358C630.664 316.773 629.789 314.288 628.331 314.142C626.726 314.142 624.684 311.218 622.934 312.387C621.184 313.703 619.434 310.779 617.829 313.265C616.225 315.603 614.475 313.995 613.162 316.48C611.849 318.965 609.37 319.112 610.099 321.451C610.683 323.789 607.036 325.397 609.224 327.298C611.412 329.052 608.203 330.514 609.807 331.537C611.266 332.56 611.558 336.799 614.329 337.092C617.246 337.53 617.392 340.454 619.434 339.284C621.33 338.115 622.497 341.915 624.976 340.161C627.455 338.261 629.643 340.454 630.81 337.676C631.977 334.899 635.186 335.045 635.04 332.56C634.894 330.075 637.519 328.613 636.352 326.859C634.894 325.251 637.811 324.082 634.602 322.035Z",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.497 320.135C628.331 322.766 626.872 322.912 624.83 322.181C622.788 321.304 621.767 321.158 620.017 322.912C618.267 324.666 616.954 326.859 614.766 327.005C612.579 327.151 609.662 327.736 609.662 327.736",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.183 319.696C615.496 321.012 614.912 325.544 616.371 326.274",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.975 317.065C620.017 317.942 620.892 321.889 620.892 321.889",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.809 316.919C625.268 318.088 624.684 319.696 625.268 321.597",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.664 330.514C627.31 327.736 621.621 328.028 620.746 333.583C619.871 338.992 614.621 337.53 614.621 337.53",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.642 322.035C622.059 323.497 621.913 327.736 624.101 328.906",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.039 329.052C628.331 327.151 630.373 324.959 632.56 324.082",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.974 332.853C612.579 330.952 615.204 329.783 618.704 330.952",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.664 336.945C629.352 334.314 627.164 332.268 625.122 334.607",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.559 98.8207C625.559 98.8207 626.726 88.7344 627.018 87.1264C627.164 86.3955 628.039 85.6646 629.497 85.8108C631.394 86.1032 631.394 88.0035 631.394 88.0035C631.394 88.0035 663.335 91.9503 665.669 92.2427C668.002 92.535 670.19 94.8739 669.753 98.8207C669.315 102.768 666.544 104.083 664.356 103.937C662.314 103.645 629.935 99.6978 629.935 99.6978C629.935 99.6978 629.497 101.598 627.31 101.306C625.851 101.16 625.414 99.6978 625.559 98.8207Z",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.102 95.1663L630.664 99.4054",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.29 97.359L632.998 99.6979",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.498 95.8971L635.915 100.136",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.686 98.0898L638.394 100.429",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.749 96.4819L641.311 100.721",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.937 98.6744L643.645 101.013",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.336 89.3191C670.336 89.3191 673.399 64.9073 673.691 62.4222C673.982 59.9372 670.774 55.698 666.398 57.1598C661.877 58.6216 638.54 66.6614 638.54 66.6614L625.268 65.0534C625.268 65.0534 624.976 63.1531 622.934 62.8608C621.621 62.7146 620.746 63.7378 620.601 64.4687C620.455 65.1996 619.288 75.4321 619.142 76.6015C618.996 77.3324 619.725 78.2095 621.038 78.3557C622.934 78.648 623.518 76.7477 623.518 76.7477C623.518 76.7477 634.748 78.0633 635.332 78.2095C635.915 78.2095 649.479 87.1264 649.479 87.1264",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.122 65.0535L624.684 69.2926",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.893 65.3458L627.601 67.6847",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.102 65.7844L630.518 70.0236",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.727 66.0767L633.435 68.4155",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.126 61.9836C654.876 62.5684 661.439 74.2626 660.71 86.1031",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.769 202.461C468.769 202.461 473.144 196.468 473.874 195.445C474.165 195.006 475.04 194.86 475.915 195.591C477.082 196.468 476.353 197.783 476.353 197.783C476.353 197.783 495.605 211.963 497.064 212.986C498.523 214.009 499.106 216.348 497.356 218.687C495.605 221.026 493.272 221.026 492.105 220.003C490.792 219.125 471.394 204.8 471.394 204.8C471.394 204.8 470.519 205.969 469.206 204.946C468.185 204.069 468.331 203.046 468.769 202.461Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.728 202.169L471.832 204.8",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.311 204.361L473.29 205.823",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.936 204.508L475.04 207.139",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.52 206.7L476.499 208.162",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.145 206.847L478.249 209.478",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.729 209.185L479.708 210.501",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.148 212.548C501.148 212.548 511.941 197.784 512.962 196.322C513.983 194.86 513.545 190.913 510.191 190.182C506.836 189.451 488.605 186.235 488.605 186.235L480.583 180.388C480.583 180.388 481.02 179.073 479.853 178.196C478.978 177.611 478.103 177.903 477.812 178.342C477.52 178.78 472.998 184.92 472.415 185.651C472.123 186.089 472.269 186.82 472.998 187.405C474.165 188.282 475.186 187.259 475.186 187.259C475.186 187.259 481.895 192.229 482.333 192.521C482.625 192.813 488.313 203.484 488.313 203.484",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.729 180.535L478.832 183.02",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.333 181.704L481.312 183.019",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.229 183.166L482.333 185.651",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.833 184.335L484.812 185.651",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.981 188.574C500.856 189.597 501.002 199.538 496.189 206.993",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.64 63.2993L596.243 95.6048L603.39 96.9204L608.932 64.3226L606.161 56.7213L601.64 63.2993Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.932 64.3225C608.932 64.3225 605.724 65.9305 601.494 63.1531",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.118 90.6346L604.119 91.9503",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.348 274.82L415.679 247.777L409.699 251.87L428.222 279.205L435.66 282.713L434.348 274.82Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.222 279.205C428.222 279.205 429.389 275.843 434.348 274.82",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.596 252.016L412.762 255.816",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.898 313.265L667.419 262.979L656.188 263.418L658.522 313.995L665.231 324.52L669.898 313.265Z",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.522 313.995C658.522 313.995 662.752 310.487 669.898 313.265",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.711 270.873L656.918 271.019",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.207 14.6218L658.96 -8.91293L653.855 -14.0292L630.81 9.50556L628.768 17.3992L636.207 14.6218Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.81 9.50549C630.81 9.50549 634.311 9.94403 636.207 14.6217",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M828.22 65.5318C835.836 58.0956 835.996 45.8793 828.576 38.2459C821.157 30.6126 808.968 30.4528 801.351 37.889C793.735 45.3252 793.576 57.5414 800.995 65.1748C808.415 72.8082 820.604 72.968 828.22 65.5318Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.452 51.605L787.952 51.3126C787.806 58.183 790.431 65.0534 795.536 70.3158C805.892 80.8407 822.81 81.133 833.312 70.7544C838.562 65.6381 841.334 58.7677 841.334 51.8973H837.979",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.37 38.0105C804.141 44.15 819.456 51.7513 828.499 38.3029",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.307 60.9604C804.141 54.3824 820.914 51.0203 831.853 60.8143",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.687 74.9936L833.457 70.7544",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.728 91.9503L854.46 70.6082C854.46 70.6082 850.96 67.3923 847.168 71.0468C845.417 69.2926 843.375 69.7312 841.479 71.6315C839.437 73.5318 835.354 77.6248 834.041 78.7942C832.728 80.1098 831.707 82.7411 833.458 84.6414C831.999 86.3955 829.957 89.0267 832.728 91.9503Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.106 157.522C763.829 153.619 764.5 146.617 760.606 141.883C756.711 137.15 749.725 136.477 745.002 140.38C740.278 144.284 739.607 151.285 743.502 156.019C747.397 160.753 754.383 161.426 759.106 157.522Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.654 148.96L736.612 148.814C736.612 152.761 738.07 156.707 740.987 159.777C746.967 165.917 756.739 166.063 762.865 160.069C765.928 157.146 767.533 153.199 767.533 149.252H765.636",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.342 141.066C745.946 144.574 754.843 148.96 760.094 141.212",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.592 154.222C745.946 150.422 755.718 148.521 761.99 154.076",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.345 162.408L762.865 159.923",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.428 172.202L774.971 159.923C774.971 159.923 772.929 158.023 770.741 160.216C769.72 159.192 768.553 159.485 767.387 160.654C766.22 161.824 763.886 164.016 763.157 164.893C762.428 165.624 761.844 167.232 762.865 168.255C761.99 168.986 760.823 170.594 762.428 172.202Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.229 288.56L675.646 321.45L682.938 321.743L683.668 288.706L679.875 281.544L676.229 288.56Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.668 288.706C683.668 288.706 680.751 290.753 676.229 288.706",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.791 316.334L682.792 316.627",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.168 332.268L716.922 303.178L688.335 273.796L687.168 332.268ZM706.566 302.74L695.336 313.703L695.773 291.63L706.566 302.74Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.273 282.421L693.294 281.544",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.731 285.929L695.627 284.029",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.94 287.245L697.961 286.368",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.399 290.753L700.295 288.853",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.607 292.069L702.482 291.192",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.066 295.577L704.962 293.677",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.275 296.746L707.15 295.869",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.733 300.401L709.629 298.354",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.942 301.57L711.817 300.693",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.705 163.578L781.826 178.196L796.995 149.545L826.019 134.927L810.705 163.578Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.768 145.598L835.499 160.654C835.499 160.654 836.083 168.109 825.582 178.342C815.08 188.574 807.496 187.99 807.496 187.99L792.765 172.933",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.326 177.026L803.704 195.883",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.788 196.029C808.954 197.199 808.954 199.245 807.788 200.415C806.621 201.584 804.579 201.584 803.412 200.415C802.245 199.245 802.245 197.199 803.412 196.029C804.725 194.714 806.621 194.714 807.788 196.029Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.954 203.192C808.954 203.192 809.684 207.139 812.017 209.478C813.184 208.308 817.268 204.362 817.268 204.362C817.268 204.362 813.622 201.438 810.996 201.146",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.149 102.329L686.876 131.857L680.751 99.9901L693.877 70.462L700.149 102.329Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.503 82.0101L717.359 84.349C717.359 84.349 722.61 89.7576 721.006 104.375C719.401 118.993 712.984 123.232 712.984 123.232L692.127 120.894",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.918 128.787L715.026 131.711",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.38 129.226C720.131 129.372 721.297 130.98 721.006 132.588C720.86 134.342 719.255 135.511 717.651 135.219C715.901 135.073 714.734 133.465 715.026 131.857C715.172 130.249 716.63 128.933 718.38 129.226Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.777 134.05C723.777 134.05 726.84 136.681 730.049 136.973C730.194 135.365 730.924 129.664 730.924 129.664C730.924 129.664 726.256 129.664 724.069 131.126",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.342 77.4825L744.015 103.187L778.924 139.102L805.251 113.397L770.342 77.4825Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.409 79.0865L776.429 77.9171L811.434 113.877L785.035 139.751L783.868 138.435",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.992 94.3583L749.798 103.335L758.551 112.339L767.744 103.363L758.992 94.3583Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.282 91.5117L769.72 84.2028",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.491 94.7276L772.929 87.5648",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.761 117.97L784.014 99.2592",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.408 121.771L787.514 103.06",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.054 125.425L791.161 106.714",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.549 -16.4122L745.795 -16.6158L745.518 33.5234L782.273 33.727L782.549 -16.4122Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.035 -11.8365H786.639L786.347 38.3027L749.447 38.1565V36.4023",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.755 -12.385L749.92 -12.4561L749.851 0.115294L762.686 0.186375L762.755 -12.385Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.322 8.4823L777.013 8.62848",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.322 13.7448L777.013 13.8909",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.176 18.861L777.013 19.0071",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.831 84.667L828.936 111.902L865.677 149.701L893.572 122.466L856.831 84.667Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.254 91.6588L836.195 111.243L840.571 115.746L860.63 96.1612L856.254 91.6588Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.203 102.942L846.935 122.731L865.866 142.206L886.134 122.418L867.203 102.942Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.377 113.146L875.901 132.149",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.086 122.794L870.941 136.973",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.482 108.03L881.005 127.179",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.981 127.618L871.817 108.176",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.794 132.442L876.63 113.146",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.607 137.412L881.297 118.116",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.732 152.047L678.864 154.469L682.131 207.139L720.999 204.718L717.732 152.047Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.762 157.015L684.811 158.756L685.201 165.03L713.151 163.288L712.762 157.015Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.716 172.675L685.474 174.435L687.158 201.573L715.399 199.813L713.716 172.675Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.565 173.956L701.316 200.561",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.148 180.973L694.315 200.853",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.858 173.518L708.462 199.976",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.147 181.411L713.713 179.657",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.585 188.282L714.151 186.528",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.022 195.152L714.588 193.398",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.215 49.8509L880.422 58.1831L882.318 74.8474L898.362 81.5716L911.634 71.3391L909.301 54.5286L897.487 49.4124",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.32 46.1965C897.341 47.5121 897.049 49.5586 895.736 50.5818C894.424 51.6051 892.382 51.3127 891.361 49.9971C890.34 48.6815 890.631 46.635 891.944 45.6118C893.257 44.5885 895.153 44.7347 896.32 46.1965Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.9 54.3824C876.776 55.4056 876.484 57.0136 875.463 57.8907C874.442 58.7677 872.838 58.4754 871.962 57.4521C871.087 56.4289 871.379 54.8209 872.4 53.9438C873.567 53.0668 875.171 53.2129 875.9 54.3824Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.591 92.2427C903.758 93.8507 903.466 96.0434 901.862 97.2128C900.258 98.3822 898.07 98.0899 896.903 96.4819C895.736 94.8739 896.028 92.6813 897.632 91.5118C899.237 90.3424 901.424 90.6348 902.591 92.2427Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.866 83.3258C930.741 84.4953 930.595 86.1032 929.428 87.1265C928.261 88.0035 926.657 87.8574 925.636 86.6879C924.761 85.5185 924.907 83.9105 926.073 82.8873C927.24 81.8641 928.99 82.1564 929.866 83.3258Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.302 30.1168C924.469 31.5786 924.177 33.7713 922.719 34.7946C921.26 35.964 919.073 35.6716 918.052 34.2098C916.885 32.7481 917.177 30.5554 918.635 29.5321C920.094 28.3627 922.135 28.6551 923.302 30.1168Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.722 65.6382C945.034 67.3924 944.742 69.8774 942.992 71.193C941.242 72.5086 938.763 72.2163 937.45 70.4621C936.137 68.708 936.429 66.2229 938.179 64.9073C939.929 63.5917 942.409 63.8841 943.722 65.6382Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.3 54.5286L922.427 44.5885L938.325 50.8742L939.638 63.7379",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.634 71.3391L927.094 77.9171L937.158 70.1697",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.114 35.5254L922.427 44.5885",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.484 56.7213L880.422 58.1831",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.091 90.9271L898.362 81.5717",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.094 77.9171L927.24 82.0101",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.203 2.05051L798.453 10.2365L806.037 17.2531L816.101 14.1833L818.435 3.95083L810.705 -2.91956L803.12 -0.726879",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.224 -1.75011C802.245 -1.45775 802.974 -0.434504 802.683 0.588745C802.391 1.61199 801.37 2.34289 800.349 2.05053C799.328 1.75817 798.599 0.734923 798.891 -0.288326C799.182 -1.31158 800.203 -1.89629 801.224 -1.75011Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.807 10.2365C795.682 10.3826 796.119 11.2597 795.974 11.9906C795.828 12.8677 794.953 13.3062 794.223 13.16C793.348 13.0138 792.911 12.1368 793.057 11.4059C793.202 10.5288 794.077 9.94409 794.807 10.2365Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.373 17.3993C823.54 17.6916 824.269 18.8611 823.977 20.0305C823.685 21.1999 822.519 21.9308 821.352 21.6385C820.185 21.3461 819.456 20.1767 819.747 19.0073C820.039 17.984 821.206 17.1069 822.373 17.3993Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.707 2.48901C832.582 2.63519 833.166 3.51227 832.874 4.38934C832.728 5.26641 831.853 5.85112 830.978 5.55876C830.103 5.41258 829.519 4.53551 829.811 3.65844C829.811 2.78137 830.686 2.19666 831.707 2.48901Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.435 3.95094L828.207 1.02737L829.957 -6.72009",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.119 11.1136L798.453 10.2366",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.185 18.1302L816.101 14.1833",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.207 1.02734L829.957 2.78149",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.885 187.697L744.634 183.019L731.945 193.106L734.716 209.77L749.739 215.471L762.282 204.946L760.532 192.667",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.428 189.89C761.844 191.498 760.094 192.229 758.49 191.644C756.885 191.059 756.156 189.305 756.739 187.697C757.323 186.089 759.073 185.358 760.677 185.943C762.282 186.674 763.011 188.428 762.428 189.89Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.509 177.465C745.071 178.634 743.613 179.365 742.446 178.78C741.279 178.342 740.55 176.88 741.133 175.71C741.571 174.541 743.029 173.81 744.196 174.395C745.363 174.833 745.946 176.295 745.509 177.465Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.152 218.687C727.423 220.441 725.527 221.318 723.777 220.733C722.027 220.003 721.152 218.102 721.735 216.348C722.464 214.594 724.36 213.717 726.111 214.302C727.861 214.886 728.736 216.933 728.152 218.687Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.301 236.375C748.863 237.69 747.259 238.421 745.946 237.836C744.634 237.398 743.905 235.79 744.488 234.474C744.925 233.159 746.53 232.428 747.843 233.012C749.155 233.597 749.884 235.059 749.301 236.375Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.41 203.923C788.827 205.677 786.931 206.408 785.181 205.823C783.43 205.238 782.701 203.338 783.285 201.584C783.868 199.83 785.764 199.099 787.514 199.684C789.264 200.415 789.994 202.315 789.41 203.923Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.649 241.172C769.73 240.942 771.232 239.065 771.003 236.979C770.775 234.892 768.901 233.387 766.82 233.616C764.738 233.846 763.236 235.723 763.465 237.809C763.694 239.896 765.567 241.401 767.649 241.172Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.282 204.946L777.159 210.647L780.076 226.873L770.304 234.62",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.739 215.471L752.364 231.405L763.74 235.79",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.868 204.946L777.159 210.647",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.759 179.219L744.634 183.019",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.423 215.179L734.716 209.77",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.364 231.404L749.009 233.597",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.447 -9.35145C916.447 -9.35145 901.425 -9.05909 899.82 -9.05909C898.216 -9.05909 896.32 -9.78999 894.132 -11.398C891.944 -13.0059 885.089 -17.3913 877.651 -17.2451C870.358 -17.0989 856.502 -8.3282 856.794 8.77468C857.086 26.0237 870.942 28.8011 875.317 28.655C879.693 28.655 882.901 26.7546 885.527 28.5088C888.152 30.2629 891.069 33.1865 892.382 33.1865C893.694 33.1865 893.257 28.9473 894.57 28.8011C895.882 28.655 902.008 27.4855 903.758 27.1932C905.508 26.9008 906.384 25.8776 906.384 22.954C906.384 20.0304 906.967 14.3295 909.738 14.3295C912.509 14.3295 917.614 14.1833 917.614 14.1833",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.107 35.964L862.482 29.8245",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.96 28.9473L856.21 24.7081",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.98 18.5687L851.106 15.6451",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.23 6.58215L850.522 6.28979",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.86 16.9607C885.381 17.1069 885.235 20.6152 883.193 20.3228C881.151 20.0305 879.109 22.077 877.505 21.3461C875.901 20.6152 872.4 22.3693 871.233 20.1767C870.066 17.984 867.004 19.8843 866.566 16.6684C866.274 13.4524 863.649 14.1833 863.649 11.1136C863.649 8.04384 861.315 6.58205 863.211 4.68173C864.962 2.78141 862.336 -0.873047 865.399 -1.45776C868.462 -2.04247 866.128 -5.11222 868.17 -5.40458C870.212 -5.69694 872.546 -9.64376 875.609 -8.47433C878.672 -7.3049 880.422 -10.2285 881.735 -8.03579C883.047 -5.84312 886.11 -9.05904 887.569 -5.98929C889.027 -2.91955 892.382 -3.79662 891.944 -0.580692C891.653 2.78141 894.861 4.38938 893.403 6.72823C891.944 9.06709 893.84 11.8445 891.798 13.0139C890.048 14.0372 892.09 16.6684 887.86 16.9607Z",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.026 16.2299C882.172 13.014 880.859 12.1369 878.526 11.8445C876.046 11.5522 874.88 11.2598 874.15 8.62861C873.421 5.85122 873.275 3.22001 871.087 1.9044C869.046 0.588795 866.42 -1.60388 866.42 -1.60388",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.712 8.62864C868.754 8.04392 870.504 3.36621 872.4 3.36621",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.045 13.0139C871.525 13.1601 874.442 9.79797 874.442 9.79797",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.734 16.376C876.776 15.9374 877.067 14.1833 878.526 12.5753",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.59 6.58208C883.777 7.60533 878.38 4.24322 880.422 -1.60392C882.318 -7.45106 876.484 -8.62048 876.484 -8.62048",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.192 10.6751C876.484 8.92094 878.526 4.68176 881.151 4.68176",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.235 6.72815C884.506 8.62847 885.381 11.9906 887.131 14.0371",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.358 -5.98926C870.941 -3.35805 872.838 -0.726832 877.067 0.0040601",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.944 0.296383C889.173 2.1967 886.11 3.07377 885.381 -0.28833",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.633 15.6452C737.633 15.6452 727.569 6.14361 726.548 5.12036C725.381 4.09711 724.652 2.34296 724.36 0.00410883C724.069 -2.33475 722.173 -9.78985 717.359 -14.3214C712.4 -18.9991 697.815 -21.9227 687.168 -10.5207C676.375 0.881178 683.668 11.6984 686.585 14.3296C689.502 17.107 692.856 17.9841 693.44 20.7615C694.023 23.685 694.169 27.3395 695.044 28.2166C695.919 28.9474 698.253 26.0239 699.274 26.7548C700.295 27.4857 704.962 30.5554 706.275 31.5787C707.587 32.6019 708.754 32.4557 710.65 30.5554C712.546 28.6551 716.484 25.293 718.38 27.0471C720.276 28.8013 723.631 32.0172 723.631 32.0172",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.541 8.04382L677.396 6.87439",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.395 -1.01929L676.521 -0.580753",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.191 14.6219C700.441 13.1601 698.107 15.4989 697.086 13.891C695.919 12.283 693.294 12.4292 692.71 10.8212C692.127 9.35943 688.627 8.19 689.356 6.1435C690.085 3.95083 686.731 3.21993 688.627 0.881076C690.377 -1.45778 688.335 -2.62721 690.231 -4.67371C692.127 -6.7202 691.544 -9.05906 694.023 -9.20524C696.503 -9.35142 696.94 -13.4444 699.42 -11.8365C701.899 -10.2285 702.191 -13.7368 703.795 -12.7135C705.254 -11.5441 709.338 -12.7135 710.65 -10.0823C711.963 -7.4511 714.88 -8.18199 714.297 -5.84313C713.713 -3.50428 717.943 -3.65045 716.776 -0.726885C715.755 2.19668 718.526 3.80465 716.193 5.70497C713.859 7.60529 715.026 10.8212 712.546 11.4059C710.067 11.9906 709.483 15.0604 707.442 14.4757C705.545 14.0371 705.254 17.1069 702.191 14.6219Z",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.982 10.3828C701.17 8.48244 700.878 7.02066 699.42 5.26652C697.961 3.51238 697.378 2.63531 698.69 0.296451C699.857 -2.0424 701.607 -3.94272 701.024 -6.1354C700.587 -8.32808 700.149 -11.3978 700.149 -11.3978",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.419 0.00402832C693.877 1.75817 697.961 1.31963 697.961 1.31963",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.877 5.85107C695.482 6.87432 696.794 5.85107 698.836 5.85107",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.338 8.33621C705.545 5.85118 704.233 0.2964 709.192 -2.33481C714.151 -4.81985 711.088 -9.49756 711.088 -9.49756",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.545 3.07365C699.857 2.05041 703.941 0.588621 705.691 2.34276",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.004 6.28967C705.254 7.16674 703.795 9.79796 703.649 12.283",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.463 6.28959C712.4 5.70488 709.921 4.38927 711.379 1.75806",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.194 280.959C730.194 280.959 719.401 274.966 718.235 274.235C717.068 273.504 715.463 273.358 713.276 273.796C711.088 274.089 704.379 274.673 698.982 271.604C693.731 268.68 687.022 256.986 693.877 244.561C700.732 232.135 711.963 235.498 715.026 237.252C718.235 239.006 719.839 241.637 722.464 241.345C725.09 241.052 728.298 240.175 729.319 240.614C730.194 241.052 728.298 243.976 729.319 244.707C730.194 245.438 734.132 248.654 735.445 249.384C736.612 250.262 736.758 251.285 735.737 253.477C734.716 255.67 732.82 259.909 734.862 261.079C736.904 262.248 740.55 264.295 740.55 264.295",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.254 225.265L706.129 231.405",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.378 227.604L699.566 232.72",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.918 232.866L692.419 237.398",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.084 240.906L688.189 243.83",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.021 250.408L685.71 251.139",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.875 260.348L685.564 259.617",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.23 269.119L687.752 266.634",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.693 250.7C717.943 249.531 719.255 247.046 717.651 246.461C716.047 245.876 715.317 243.537 713.859 243.537C712.4 243.537 710.504 240.76 708.9 241.929C707.296 243.099 705.691 240.468 704.233 242.66C702.774 244.853 701.17 243.391 700.003 245.584C698.836 247.776 696.648 247.923 697.086 250.115C697.669 252.308 694.315 253.77 696.357 255.524C698.399 257.132 695.482 258.448 696.794 259.471C698.253 260.494 698.399 264.295 701.024 264.587C703.649 264.879 703.795 267.657 705.691 266.634C707.441 265.464 708.462 269.119 710.796 267.364C712.984 265.61 715.172 267.657 716.193 265.172C717.214 262.687 720.276 262.833 720.131 260.494C719.985 258.155 722.318 256.84 721.297 255.378C719.985 253.624 722.61 252.6 719.693 250.7Z",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.026 248.946C714.005 251.285 712.546 251.577 710.796 250.846C708.9 250.115 708.025 249.823 706.275 251.577C704.67 253.185 703.503 255.232 701.462 255.378C699.42 255.524 696.794 256.109 696.794 256.109",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.878 248.507C702.191 249.677 701.607 253.916 702.92 254.501",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.379 246.169C706.275 247.046 707.004 250.554 707.004 250.554",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.775 246.022C711.088 247.046 710.65 248.507 711.088 250.262",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.193 258.448C713.13 255.816 707.879 256.255 707.004 261.225C706.129 266.195 701.462 264.879 701.462 264.879",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.608 250.7C708.025 252.016 707.879 255.963 709.921 256.986",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.713 257.132C714.005 255.378 715.901 253.331 717.943 252.6",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.961 260.64C699.42 258.886 701.753 257.863 705.108 258.886",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.047 264.441C714.734 261.956 712.838 260.202 711.088 262.248",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.033 21.3461C938.033 21.3461 942.847 10.675 943.576 8.92089C944.013 8.04381 945.18 7.60528 946.784 8.48235C948.681 9.35942 948.243 11.5521 948.243 11.5521C948.243 11.5521 981.935 26.7547 984.414 27.9241C986.894 29.0935 988.498 32.3094 986.602 36.5486C984.706 40.6416 981.206 41.3725 979.018 40.3493C976.83 39.326 942.555 23.8311 942.555 23.8311C942.555 23.8311 941.534 25.8776 939.2 24.7082C937.596 23.9773 937.596 22.2231 938.033 21.3461Z",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.472 19.2994L943.43 23.6848",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.076 22.3693L945.909 24.8543",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.014 21.7845L948.972 26.3161",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.764 25.0005L951.598 27.4855",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.702 24.2695L954.661 28.8011",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.307 27.4855L957.14 29.9705",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.54 26.1699C990.54 26.1699 1002.21 0.296335 1003.37 -2.33488C1004.54 -4.96609 1002.5 -10.6671 997.103 -10.6671C991.707 -10.6671 963.12 -9.78998 963.12 -9.78998L949.118 -16.0757C949.118 -16.0757 949.41 -18.2683 947.222 -19.2916C945.763 -20.0225 944.451 -19.1454 944.159 -18.4145C943.867 -17.6836 938.908 -6.86641 938.471 -5.69698C938.033 -4.81991 938.617 -3.79666 939.929 -3.21195C941.971 -2.33488 943.284 -4.2352 943.284 -4.2352C943.284 -4.2352 955.098 1.17341 955.681 1.31958C956.265 1.61194 968.225 15.9374 968.225 15.9374",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.914 -9.79004C982.518 -8.47443 985.873 6.58195 981.06 19.4457",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.734 65.1996C714.734 65.1996 719.11 59.2063 719.839 58.1831C720.131 57.7445 721.006 57.5984 721.881 58.3293C723.048 59.2063 722.318 60.5219 722.318 60.5219C722.318 60.5219 741.571 74.7012 743.029 75.7245C744.488 76.7477 745.071 79.0866 743.321 81.4255C741.571 83.7643 739.237 83.7643 738.07 82.7411C736.758 81.864 717.359 67.5385 717.359 67.5385C717.359 67.5385 716.484 68.7079 715.172 67.6847C714.151 66.8076 714.442 65.7844 714.734 65.1996Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.693 64.9072L717.797 67.5384",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.277 67.0999L719.256 68.5616",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.902 67.2461L721.006 69.8773",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.485 69.4388L722.464 70.9006",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.111 69.585L724.215 72.2162",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.694 71.7776L725.673 73.2394",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.113 75.2859C747.113 75.2859 757.906 60.5219 758.927 59.0601C759.948 57.5984 759.511 53.6515 756.156 52.9206C752.801 52.1898 734.57 48.9738 734.57 48.9738L726.548 43.1267C726.548 43.1267 726.986 41.8111 725.819 40.934C724.944 40.3493 724.069 40.6416 723.777 41.0802C723.485 41.5187 718.964 47.6582 718.38 48.3891C718.089 48.8276 718.235 49.5585 718.964 50.1433C720.131 51.0203 721.152 49.9971 721.152 49.9971C721.152 49.9971 727.861 54.9671 728.298 55.2595C728.59 55.5519 734.278 66.2229 734.278 66.2229",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.694 43.2728L724.798 45.7579",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.298 44.4423L727.277 45.7579",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.194 45.9041L728.444 48.3891",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.945 47.0734L730.924 48.389",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.946 51.3126C746.822 52.3359 746.967 62.276 742.154 69.7311",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.251 37.8643L700.878 66.0767L707.15 62.5684L690.669 33.9175L683.522 29.8245L684.251 37.8643Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.669 33.9175C690.669 33.9175 689.356 37.2796 684.251 37.7181",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.253 61.6913L704.525 58.3292",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.953 175.564C969.392 183.166 969.246 195.298 961.661 202.753C954.077 210.209 941.971 210.062 934.533 202.461C927.095 194.86 927.24 182.727 934.825 175.272C942.409 167.817 954.515 167.963 961.953 175.564Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.907 188.867L921.406 188.574C921.26 195.445 923.886 202.315 928.991 207.577C939.346 218.102 956.265 218.395 966.766 208.016C972.017 202.9 974.788 196.029 974.788 189.159H971.434",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.825 175.272C937.596 181.411 952.91 189.013 961.953 175.564",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.762 198.222C937.596 191.644 954.369 188.282 965.308 198.076",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.996 212.255L966.912 208.016",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.183 229.212L987.915 207.87C987.915 207.87 984.414 204.654 980.622 208.308C978.872 206.554 976.83 206.993 974.934 208.893C972.892 210.793 968.808 214.886 967.496 216.056C966.183 217.371 965.162 220.003 966.912 221.903C965.308 223.657 963.266 226.288 966.183 229.212Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.126 293.122C897.955 288.335 897.187 281.343 892.411 277.505C887.635 273.667 880.659 274.437 876.829 279.224C873 284.011 873.768 291.002 878.544 294.84C883.32 298.678 890.297 297.909 894.126 293.122Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.962 286.222L869.921 286.075C869.921 290.022 871.379 293.969 874.296 297.039C880.276 303.178 890.048 303.324 896.174 297.331C899.237 294.408 900.841 290.461 900.841 286.514H898.945",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.651 278.328C879.255 281.836 888.152 286.222 893.403 278.474",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.9 291.484C879.255 287.683 889.027 285.783 895.299 291.338",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.653 299.67L896.32 297.331",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.882 309.464L908.425 297.185C908.425 297.185 906.383 295.285 904.196 297.477C903.175 296.454 902.008 296.746 900.841 297.916C899.674 299.085 897.341 301.278 896.611 302.155C895.882 303.032 895.299 304.494 896.32 305.517C895.445 306.248 894.278 307.856 895.882 309.464Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.416 43.7113H1049.03V-6.28174L998.416 43.7113ZM1040.42 34.6482H1021.31L1040.42 15.7912V34.6482Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.09 4.82788H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.34 9.06702H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.09 12.8677H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.34 17.1069H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.09 21.0537H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.34 25.2928H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.09 29.2396H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.34 33.4789H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.09 37.2794H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.106 351.417H741.717V301.424L691.106 351.417ZM733.111 342.208H714.005L733.111 323.351V342.208Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.925 312.387H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.174 316.627H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.925 320.427H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.174 324.813H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.925 328.613H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.174 332.852H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.925 336.799H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.174 341.038H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.925 344.839H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.159 300.839L915.135 315.457L930.449 286.806L959.474 272.188L944.159 300.839Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.223 282.859L968.954 297.916C968.954 297.916 969.537 305.371 959.036 315.603C948.535 325.836 940.95 325.251 940.95 325.251L926.219 310.195",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.781 314.288L937.012 333.145",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.242 333.291C942.409 334.46 942.409 336.507 941.242 337.676C940.075 338.846 938.033 338.846 936.867 337.676C935.7 336.507 935.7 334.46 936.867 333.291C938.179 331.975 940.075 331.975 941.242 333.291Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.409 340.454C942.409 340.454 943.138 344.401 945.472 346.739C946.639 345.57 950.722 341.623 950.722 341.623C950.722 341.623 947.076 338.7 944.451 338.407",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.603 239.591L820.331 269.119L814.059 237.398L827.332 207.724L833.603 239.591Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.957 219.272L850.814 221.611C850.814 221.611 856.065 227.019 854.46 241.637C852.856 256.255 846.438 260.494 846.438 260.494L825.582 258.155",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.373 266.049L848.48 268.972",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.689 266.487C853.439 266.634 854.606 268.242 854.314 269.85C854.169 271.604 852.564 272.773 850.96 272.481C849.21 272.335 848.043 270.727 848.334 269.119C848.48 267.511 850.085 266.195 851.689 266.487Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.231 271.311C857.231 271.311 860.294 273.942 863.503 274.235C863.649 272.627 864.378 266.926 864.378 266.926C864.378 266.926 859.711 266.926 857.523 268.388",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.779 214.708L877.452 240.412L912.361 276.327L938.688 250.622L903.779 214.708Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.717 216.348L909.884 215.179L944.742 251.139L918.489 277.012L917.322 275.696",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.429 231.583L883.236 240.56L891.988 249.564L901.182 240.588L892.429 231.583Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.736 228.773L903.175 221.464",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.945 232.135L906.383 224.827",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.216 255.232L917.322 236.521",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.862 259.032L920.969 240.321",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.508 262.687L924.615 243.976",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.454 149.675L909.296 130.571L883.369 163.504L907.527 182.609L933.454 149.675Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.783 154.076L933.804 154.807L907.842 187.843L883.631 168.694L884.506 167.524",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.221 142.135L909.863 135.525L903.359 143.787L911.717 150.397L918.221 142.135Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.969 144.574L927.824 149.983",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.635 147.498L925.49 152.907",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.383 149.545L916.885 163.432",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.611 152.907L914.259 166.794",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.986 156.415L911.488 170.302",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.268 221.892L962.374 249.127L999.115 286.927L1027.01 259.692L990.268 221.892Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.689 229.091L969.63 248.675L974.006 253.178L994.065 233.593L989.689 229.091Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.64 240.167L980.373 259.956L999.303 279.431L1019.57 259.643L1000.64 240.167Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.686 250.408L1009.21 269.411",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.394 260.056L1004.25 274.235",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.937 245.292L1014.46 264.441",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.435 264.879L1005.13 245.438",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.102 269.703L1009.94 250.408",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.916 274.674L1014.75 255.378",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.19 289.31L812.321 291.732L815.588 344.402L854.457 341.98L851.19 289.31Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.073 294.286L818.123 296.028L818.512 302.302L846.463 300.56L846.073 294.286Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.173 309.938L818.932 311.698L820.615 338.835L848.856 337.076L847.173 309.938Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.02 311.218L834.624 337.822",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.602 318.381L827.769 338.261",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.312 310.78L841.917 337.384",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.602 318.673L847.168 316.919",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.039 325.544L847.605 323.789",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.477 332.414L848.043 330.66",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.06 218.248L1032.69 223.072L1043.92 215.763L1043.05 201.877L1031.09 195.883L1020 203.484L1020.44 213.863",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.54 215.91C1019.13 214.74 1020.59 214.156 1021.9 214.74C1023.06 215.325 1023.65 216.787 1023.06 218.102C1022.48 219.272 1021.02 219.856 1019.71 219.272C1018.4 218.541 1017.96 217.079 1018.54 215.91Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.52 227.604C1031.96 226.581 1033.13 226.288 1034.15 226.727C1035.17 227.166 1035.46 228.335 1035.02 229.358C1034.59 230.381 1033.42 230.674 1032.4 230.235C1031.38 229.651 1030.94 228.481 1031.52 227.604Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.17 195.152C1049.9 193.691 1051.65 193.106 1052.96 193.837C1054.42 194.568 1055.01 196.322 1054.28 197.637C1053.55 199.099 1051.8 199.684 1050.49 198.953C1049.03 198.222 1048.59 196.468 1049.17 195.152Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.27 178.78C1033.86 177.757 1035.02 177.319 1036.19 177.757C1037.21 178.342 1037.65 179.511 1037.21 180.681C1036.63 181.704 1035.46 182.142 1034.3 181.704C1033.13 181.119 1032.69 179.804 1033.27 178.78Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.541 202.023C998.27 200.707 999.875 200.122 1001.19 200.853C1002.5 201.584 1003.08 203.192 1002.35 204.508C1001.62 205.823 1000.02 206.408 998.708 205.677C997.395 205.092 996.957 203.485 997.541 202.023Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.77 174.98C1016.5 173.372 1018.4 172.787 1020 173.518C1021.61 174.249 1022.19 176.149 1021.46 177.757C1020.73 179.365 1018.84 179.95 1017.23 179.219C1015.63 178.488 1015.04 176.588 1015.77 174.98Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020 203.485L1008.19 197.637L1007.17 184.043L1015.92 178.488",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.09 195.883L1030.36 182.581L1021.31 178.049",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.21 201.73L1008.19 197.637",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.98 226.288L1032.69 223.073",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.46 198.076L1043.05 201.877",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.36 182.581L1033.27 180.973",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.575 119.139L933.658 128.203L941.534 137.119L953.348 134.634L957.14 123.379L948.972 114.608L940.075 116.362",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.179 114.9C939.346 115.339 939.929 116.508 939.638 117.678C939.2 118.847 938.033 119.432 936.866 119.139C935.7 118.701 935.116 117.531 935.408 116.362C935.7 115.193 937.012 114.608 938.179 114.9Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.574 127.764C930.449 128.056 931.032 129.08 930.741 129.957C930.449 130.834 929.428 131.419 928.553 131.126C927.678 130.834 927.094 129.811 927.386 128.933C927.678 128.056 928.699 127.472 929.574 127.764Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.203 139.02C961.515 139.458 962.245 140.92 961.807 142.236C961.37 143.551 959.911 144.282 958.598 143.844C957.286 143.405 956.556 141.943 956.994 140.628C957.432 139.312 958.89 138.581 960.203 139.02Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.309 122.94C973.329 123.232 973.767 124.256 973.475 125.279C973.184 126.302 972.163 126.741 971.142 126.448C970.121 126.156 969.683 125.133 969.975 124.109C970.267 123.232 971.288 122.648 972.309 122.94Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.368 94.8738C948.68 95.3123 949.264 96.6279 948.826 97.7973C948.389 99.1129 947.076 99.6976 945.909 99.2591C944.597 98.8206 944.013 97.505 944.451 96.3355C944.742 95.1661 946.055 94.4352 947.368 94.8738Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.329 107.299C974.788 107.737 975.517 109.345 975.08 110.807C974.642 112.269 973.038 113 971.579 112.561C970.121 112.123 969.391 110.515 969.829 109.053C970.267 107.591 971.871 106.86 973.329 107.299Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.972 114.608L952.618 103.644L964.287 100.867L970.267 107.737",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.14 123.379L968.516 121.04L971.288 112.415",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.243 98.8206L952.618 103.644",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.887 128.933L933.658 128.202",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.577 139.604L953.348 134.634",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.516 121.04L970.267 123.232",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.692 319.258L868.608 322.181L864.524 335.922L874.879 346.447L888.735 342.792L892.382 328.905L884.797 321.012",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.943 318.088C885.381 319.55 884.506 321.012 883.047 321.304C881.589 321.743 880.13 320.866 879.838 319.404C879.401 317.942 880.276 316.48 881.734 316.188C883.047 315.749 884.506 316.627 884.943 318.088Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.42 317.65C866.712 318.819 865.982 319.842 864.961 320.135C863.795 320.427 862.774 319.696 862.482 318.673C862.19 317.65 862.92 316.48 863.941 316.188C864.961 315.896 866.128 316.627 866.42 317.65Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.734 356.241C875.171 357.849 874.15 359.457 872.546 359.895C870.941 360.334 869.337 359.311 868.9 357.703C868.462 356.095 869.483 354.487 871.087 354.048C872.692 353.61 874.296 354.633 874.734 356.241Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.945 358.141C899.237 359.311 898.507 360.626 897.341 360.919C896.174 361.211 894.861 360.48 894.569 359.311C894.278 358.141 895.007 356.826 896.174 356.533C897.486 356.241 898.653 356.972 898.945 358.141Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.342 314.434C911.78 316.042 910.759 317.504 909.3 317.942C907.696 318.381 906.238 317.357 905.8 315.896C905.362 314.288 906.383 312.826 907.842 312.387C909.446 311.949 911.051 312.826 911.342 314.434Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.572 348.932C916.01 350.686 914.989 352.586 913.238 353.025C911.488 353.464 909.592 352.44 909.155 350.686C908.717 348.932 909.738 347.032 911.488 346.593C913.384 346.008 915.135 347.178 915.572 348.932Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.382 328.905L905.946 325.397L916.301 335.63L913.093 346.155",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.735 342.793L898.653 353.025L909.009 350.248",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.988 317.942L905.946 325.397",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.982 319.843L868.608 322.181",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.546 354.048L874.879 346.447",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.653 353.025L897.341 356.241",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.26 125.571C1046.26 125.571 1032.11 125.717 1030.5 125.864C1028.9 125.864 1027.15 125.133 1025.11 123.671C1023.06 122.209 1016.5 117.97 1009.5 118.116C1002.5 118.262 989.519 126.448 989.811 142.674C990.102 158.9 1003.23 161.531 1007.31 161.531C1011.4 161.531 1014.46 159.631 1017.09 161.385C1019.56 163.139 1022.34 165.77 1023.5 165.77C1024.67 165.77 1024.38 161.823 1025.69 161.677C1027 161.531 1032.69 160.362 1034.44 160.216C1036.05 160.069 1036.92 159.046 1036.92 156.269C1036.92 153.491 1037.5 148.083 1040.13 148.083C1042.75 148.083 1047.57 147.937 1047.57 147.937",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.123 168.402L995.353 162.554",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.414 161.824L989.373 157.731",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.58 151.883L984.56 149.106",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.122 140.628L983.831 140.335",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.018 129.226L985.144 131.565",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.268 119.14L989.519 123.086",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.29 112.123L995.645 117.093",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.27 150.568C1016.94 150.714 1016.79 154.076 1014.9 153.784C1013 153.491 1010.96 155.392 1009.5 154.661C1008.04 153.93 1004.69 155.684 1003.67 153.491C1002.65 151.445 999.583 153.199 999.291 150.129C998.999 147.059 996.666 147.79 996.52 144.867C996.52 141.943 994.332 140.628 996.082 138.727C997.833 136.827 995.207 133.465 998.124 132.88C1001.04 132.295 998.854 129.372 1000.75 129.226C1002.65 129.079 1004.83 125.279 1007.75 126.302C1010.67 127.325 1012.27 124.694 1013.58 126.741C1014.9 128.787 1017.81 125.717 1019.13 128.641C1020.44 131.565 1023.65 130.687 1023.36 133.757C1023.07 136.827 1026.13 138.435 1024.67 140.628C1023.21 142.82 1024.96 145.451 1023.07 146.475C1021.31 147.644 1023.36 150.129 1019.27 150.568Z",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.73 149.691C1013.88 146.621 1012.71 145.744 1010.38 145.452C1008.04 145.159 1007.02 144.867 1006.29 142.382C1005.56 139.751 1005.42 137.266 1003.37 135.95C1001.48 134.634 998.999 132.734 998.999 132.734",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.291 142.528C1001.19 141.943 1002.79 137.558 1004.54 137.558",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.48 146.767C1003.81 146.913 1006.58 143.698 1006.58 143.698",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.73 149.983C1008.63 149.545 1008.92 147.937 1010.38 146.329",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020 140.628C1015.48 141.505 1010.38 138.435 1012.27 132.88C1014.17 127.325 1008.48 126.156 1008.48 126.156",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.19 144.574C1008.33 142.967 1010.38 138.874 1012.86 138.874",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.79 140.774C1016.06 142.674 1016.94 145.744 1018.54 147.644",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.79 128.641C1003.23 131.126 1005.13 133.611 1009.06 134.196",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.07 134.634C1020.44 136.388 1017.52 137.266 1016.79 134.196",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.578 340.892C797.578 340.892 795.536 327.005 795.244 325.397C794.953 323.936 795.536 322.035 796.703 319.843C797.87 317.65 801.078 310.633 800.057 303.763C799.036 296.893 789.264 285.198 773.366 287.537C757.469 289.876 756.594 303.178 757.177 307.125C757.76 311.218 759.948 313.995 758.635 316.627C757.323 319.258 754.989 322.328 755.135 323.497C755.281 324.666 759.073 323.789 759.511 325.105C759.802 326.274 761.698 331.829 762.136 333.437C762.573 335.045 763.594 335.63 766.366 335.337C769.137 335.045 774.387 334.753 774.825 337.384C775.263 340.015 775.846 344.693 775.846 344.693",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.572 292.215L754.843 295.577",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.114 284.76L758.781 289.145",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.011 277.889L766.511 283.298",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.95 274.82L774.971 281.544",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.326 275.258L783.722 281.69",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.828 279.205L792.765 284.76",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.85 286.075L799.328 290.022",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.72 317.65C769.283 315.311 765.928 315.75 766.074 313.849C766.22 311.949 764.032 310.195 764.47 308.733C764.907 307.125 762.865 304.055 764.761 302.886C766.657 301.57 764.47 298.939 767.387 298.208C770.304 297.477 769.283 295.285 772.2 294.846C775.117 294.408 776.138 292.215 778.18 293.531C780.222 294.992 783.139 292.069 784.16 294.846C785.181 297.624 787.66 294.992 788.098 296.893C788.535 298.793 792.619 300.401 791.89 303.324C791.161 306.248 794.078 307.564 792.181 309.025C790.285 310.487 793.64 312.972 791.015 314.726C788.389 316.481 789.556 319.404 786.493 319.55C783.43 319.696 782.264 322.912 779.93 321.743C777.596 320.574 775.263 322.766 773.95 321.012C772.783 319.112 770.595 321.451 769.72 317.65Z",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.72 312.095C772.637 311.949 773.367 310.487 773.367 308.294C773.367 305.956 773.512 304.932 775.846 303.763C778.325 302.74 780.805 302.155 781.68 300.108C782.701 298.062 784.305 295.431 784.305 295.431",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.971 296.893C775.7 298.647 780.367 299.67 780.513 301.424",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.033 299.67C771.179 302.009 774.679 304.201 774.679 304.201",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.699 305.225C769.283 306.979 771.033 307.125 772.783 308.295",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.347 316.919C777.888 312.534 780.367 307.125 785.91 308.294C791.452 309.464 792.036 303.763 792.036 303.763",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.096 305.956C775.7 305.956 779.93 307.271 780.222 309.903",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.909 313.849C777.013 313.411 774.096 314.58 772.346 316.48",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.973 298.5C786.639 299.378 784.451 301.424 784.305 305.371",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.764 319.258C783.722 316.919 782.555 314.142 785.472 312.972",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.4 354.925C1025.4 354.925 1013.58 348.347 1012.27 347.616C1010.96 346.886 1009.21 346.739 1006.88 347.032C1004.54 347.47 997.103 347.909 991.415 344.693C985.581 341.477 978.434 328.759 985.873 315.311C993.311 301.863 1005.42 305.517 1008.92 307.417C1012.27 309.318 1014.17 312.241 1016.94 311.949C1019.86 311.657 1023.36 310.633 1024.38 311.218C1025.4 311.803 1023.36 314.872 1024.38 315.603C1025.4 316.334 1029.63 319.843 1030.94 320.72C1032.25 321.597 1032.4 322.912 1031.23 325.105C1030.07 327.444 1028.02 332.122 1030.21 333.437C1032.4 334.607 1036.48 336.945 1036.48 336.945",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.416 294.261L999.291 301.132",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.811 296.893L992.144 302.594",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.622 302.594L984.268 307.564",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.35 311.364L979.893 314.58",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.85 321.743L976.976 322.474",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.704 332.56L976.83 331.683",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.35 342.062L979.309 339.43",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.02 322.035C1012.13 320.866 1013.58 317.942 1011.83 317.358C1010.08 316.773 1009.21 314.288 1007.75 314.142C1006.15 314.142 1004.1 311.218 1002.35 312.387C1000.6 313.703 998.854 310.779 997.249 313.265C995.645 315.603 993.895 313.995 992.582 316.48C991.269 318.965 988.79 319.112 989.519 321.451C990.102 323.789 986.456 325.397 988.644 327.298C990.832 329.052 987.623 330.514 989.227 331.537C990.686 332.56 990.978 336.799 993.749 337.092C996.666 337.53 996.812 340.454 998.854 339.284C1000.75 338.115 1001.92 341.915 1004.4 340.161C1006.88 338.261 1009.06 340.454 1010.23 337.676C1011.4 334.899 1014.61 335.045 1014.46 332.56C1014.31 330.075 1016.94 328.613 1015.77 326.859C1014.31 325.251 1017.23 324.082 1014.02 322.035Z",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.92 320.135C1007.75 322.766 1006.29 322.912 1004.25 322.181C1002.21 321.304 1001.19 321.158 999.437 322.912C997.687 324.666 996.374 326.859 994.186 327.005C991.999 327.151 989.082 327.736 989.082 327.736",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.603 319.696C994.916 321.012 994.332 325.544 995.791 326.274",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.395 317.065C999.437 317.942 1000.31 321.889 1000.31 321.889",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.23 316.919C1004.69 318.088 1004.1 319.696 1004.69 321.597",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.08 330.514C1006.73 327.736 1001.04 328.028 1000.17 333.583C999.291 338.992 994.04 337.53 994.04 337.53",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.06 322.035C1001.48 323.497 1001.33 327.736 1003.52 328.906",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.46 329.052C1007.75 327.151 1009.79 324.959 1011.98 324.082",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.394 332.853C991.999 330.952 994.624 329.783 998.124 330.952",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.08 336.945C1008.77 334.314 1006.58 332.268 1004.54 334.607",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.98 98.8207C1004.98 98.8207 1006.15 88.7344 1006.44 87.1264C1006.58 86.3955 1007.46 85.6646 1008.92 85.8108C1010.81 86.1032 1010.81 88.0035 1010.81 88.0035C1010.81 88.0035 1042.75 91.9503 1045.09 92.2427C1047.42 92.535 1049.61 94.8739 1049.17 98.8207C1048.73 102.768 1045.96 104.083 1043.78 103.937C1041.73 103.645 1009.35 99.6978 1009.35 99.6978C1009.35 99.6978 1008.92 101.598 1006.73 101.306C1005.27 101.16 1004.83 99.6978 1004.98 98.8207Z",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.52 95.1663L1010.08 99.4054",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.71 97.359L1012.42 99.6979",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.92 95.8971L1015.33 100.136",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.11 98.0898L1017.81 100.429",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.17 96.4819L1020.73 100.721",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.36 98.6744L1023.07 101.013",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.76 89.3191C1049.76 89.3191 1052.82 64.9073 1053.11 62.4222C1053.4 59.9372 1050.19 55.698 1045.82 57.1598C1041.3 58.6216 1017.96 66.6614 1017.96 66.6614L1004.69 65.0534C1004.69 65.0534 1004.4 63.1531 1002.35 62.8608C1001.04 62.7146 1000.17 63.7378 1000.02 64.4687C999.875 65.1996 998.708 75.4321 998.562 76.6015C998.416 77.3324 999.145 78.2095 1000.46 78.3557C1002.35 78.648 1002.94 76.7477 1002.94 76.7477C1002.94 76.7477 1014.17 78.0633 1014.75 78.2095C1015.33 78.2095 1028.9 87.1264 1028.9 87.1264",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.54 65.0535L1004.1 69.2926",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.31 65.3458L1007.02 67.6847",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.52 65.7844L1009.94 70.0236",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.15 66.0767L1012.86 68.4155",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.55 61.9836C1034.3 62.5684 1040.86 74.2626 1040.13 86.1031",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.189 202.461C848.189 202.461 852.564 196.468 853.293 195.445C853.585 195.006 854.46 194.86 855.335 195.591C856.502 196.468 855.773 197.783 855.773 197.783C855.773 197.783 875.025 211.963 876.484 212.986C877.942 214.009 878.526 216.348 876.776 218.687C875.025 221.026 872.692 221.026 871.525 220.003C870.212 219.125 850.814 204.8 850.814 204.8C850.814 204.8 849.939 205.969 848.626 204.946C847.605 204.069 847.751 203.046 848.189 202.461Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.148 202.169L851.252 204.8",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.731 204.361L852.71 205.823",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.356 204.508L854.46 207.139",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.94 206.7L855.919 208.162",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.565 206.847L857.669 209.478",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.148 209.185L859.128 210.501",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.568 212.548C880.568 212.548 891.361 197.784 892.382 196.322C893.403 194.86 892.965 190.913 889.611 190.182C886.256 189.451 868.025 186.235 868.025 186.235L860.003 180.388C860.003 180.388 860.44 179.073 859.273 178.196C858.398 177.611 857.523 177.903 857.231 178.342C856.94 178.78 852.418 184.92 851.835 185.651C851.543 186.089 851.689 186.82 852.418 187.405C853.585 188.282 854.606 187.259 854.606 187.259C854.606 187.259 861.315 192.229 861.753 192.521C862.045 192.813 867.733 203.484 867.733 203.484",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.149 180.535L858.252 183.02",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.753 181.704L860.732 183.019",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.649 183.166L861.753 185.651",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.253 184.335L864.232 185.651",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.401 188.574C880.276 189.597 880.422 199.538 875.609 206.993",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.06 63.2993L975.663 95.6048L982.81 96.9204L988.352 64.3226L985.581 56.7213L981.06 63.2993Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.352 64.3225C988.352 64.3225 985.143 65.9305 980.914 63.1531",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.538 90.6346L983.539 91.9503",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.768 274.82L795.099 247.777L789.119 251.87L807.642 279.205L815.08 282.713L813.768 274.82Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.642 279.205C807.642 279.205 808.809 275.843 813.768 274.82",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.016 252.016L792.182 255.816",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.32 313.265L1046.84 262.979L1035.61 263.418L1037.94 313.995L1044.65 324.52L1049.32 313.265Z",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.94 313.995C1037.94 313.995 1042.17 310.487 1049.32 313.265",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.13 270.873L1036.34 271.019",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.63 14.6218L1038.38 -8.91293L1033.27 -14.0292L1010.23 9.50556L1008.19 17.3992L1015.63 14.6218Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.23 9.50549C1010.23 9.50549 1013.73 9.94403 1015.63 14.6217",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1207.64 65.5318C1215.26 58.0956 1215.42 45.8793 1208 38.2459C1200.58 30.6126 1188.39 30.4528 1180.77 37.889C1173.15 45.3252 1173 57.5414 1180.41 65.1748C1187.83 72.8082 1200.02 72.968 1207.64 65.5318Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.87 51.605L1167.37 51.3126C1167.23 58.183 1169.85 65.0534 1174.96 70.3158C1185.31 80.8407 1202.23 81.133 1212.73 70.7544C1217.98 65.6381 1220.75 58.7677 1220.75 51.8973H1217.4",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.79 38.0105C1183.56 44.15 1198.88 51.7513 1207.92 38.3029",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.73 60.9604C1183.56 54.3824 1200.33 51.0203 1211.27 60.8143",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.11 74.9936L1212.88 70.7544",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.15 91.9503L1233.88 70.6082C1233.88 70.6082 1230.38 67.3923 1226.59 71.0468C1224.84 69.2926 1222.8 69.7312 1220.9 71.6315C1218.86 73.5318 1214.77 77.6248 1213.46 78.7942C1212.15 80.1098 1211.13 82.7411 1212.88 84.6414C1211.42 86.3955 1209.38 89.0267 1212.15 91.9503Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.53 157.522C1143.25 153.619 1143.92 146.617 1140.03 141.883C1136.13 137.15 1129.14 136.477 1124.42 140.38C1119.7 144.284 1119.03 151.285 1122.92 156.019C1126.82 160.753 1133.8 161.426 1138.53 157.522Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.07 148.96L1116.03 148.814C1116.03 152.761 1117.49 156.707 1120.41 159.777C1126.39 165.917 1136.16 166.063 1142.28 160.069C1145.35 157.146 1146.95 153.199 1146.95 149.252H1145.06",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.76 141.066C1125.37 144.574 1134.26 148.96 1139.51 141.212",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.01 154.222C1125.37 150.422 1135.14 148.521 1141.41 154.076",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.76 162.408L1142.28 159.923",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.85 172.202L1154.39 159.923C1154.39 159.923 1152.35 158.023 1150.16 160.216C1149.14 159.192 1147.97 159.485 1146.81 160.654C1145.64 161.824 1143.31 164.016 1142.58 164.893C1141.85 165.624 1141.26 167.232 1142.28 168.255C1141.41 168.986 1140.24 170.594 1141.85 172.202Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.65 288.56L1055.07 321.45L1062.36 321.743L1063.09 288.706L1059.3 281.544L1055.65 288.56Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.09 288.706C1063.09 288.706 1060.17 290.753 1055.65 288.706",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.21 316.334L1062.21 316.627",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.59 332.268L1096.34 303.178L1067.75 273.796L1066.59 332.268ZM1085.99 302.74L1074.76 313.703L1075.19 291.63L1085.99 302.74Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.69 282.421L1072.71 281.544",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.15 285.929L1075.05 284.029",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.36 287.245L1077.38 286.368",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.82 290.753L1079.71 288.853",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.03 292.069L1081.9 291.192",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.49 295.577L1084.38 293.677",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.69 296.746L1086.57 295.869",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.15 300.401L1089.05 298.354",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.36 301.57L1091.24 300.693",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.12 163.578L1161.25 178.196L1176.41 149.545L1205.44 134.927L1190.12 163.578Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.19 145.598L1214.92 160.654C1214.92 160.654 1215.5 168.109 1205 178.342C1194.5 188.574 1186.92 187.99 1186.92 187.99L1172.18 172.933",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.75 177.026L1183.12 195.883",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.21 196.029C1188.37 197.199 1188.37 199.245 1187.21 200.415C1186.04 201.584 1184 201.584 1182.83 200.415C1181.66 199.245 1181.66 197.199 1182.83 196.029C1184.14 194.714 1186.04 194.714 1187.21 196.029Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.37 203.192C1188.37 203.192 1189.1 207.139 1191.44 209.478C1192.6 208.308 1196.69 204.362 1196.69 204.362C1196.69 204.362 1193.04 201.438 1190.42 201.146",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.57 102.329L1066.3 131.857L1060.17 99.9901L1073.3 70.462L1079.57 102.329Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.92 82.0101L1096.78 84.349C1096.78 84.349 1102.03 89.7576 1100.43 104.375C1098.82 118.993 1092.4 123.232 1092.4 123.232L1071.55 120.894",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.34 128.787L1094.45 131.711",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.8 129.226C1099.55 129.372 1100.72 130.98 1100.43 132.588C1100.28 134.342 1098.68 135.511 1097.07 135.219C1095.32 135.073 1094.15 133.465 1094.45 131.857C1094.59 130.249 1096.05 128.933 1097.8 129.226Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.2 134.05C1103.2 134.05 1106.26 136.681 1109.47 136.973C1109.61 135.365 1110.34 129.664 1110.34 129.664C1110.34 129.664 1105.68 129.664 1103.49 131.126",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.76 77.4825L1123.43 103.187L1158.34 139.102L1184.67 113.397L1149.76 77.4825Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.83 79.0865L1155.85 77.9171L1190.85 113.877L1164.45 139.751L1163.29 138.435",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.41 94.3583L1129.22 103.335L1137.97 112.339L1147.16 103.363L1138.41 94.3583Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.7 91.5117L1149.14 84.2028",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.91 94.7276L1152.35 87.5648",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.18 117.97L1163.43 99.2592",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.83 121.771L1166.93 103.06",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.47 125.425L1170.58 106.714",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.97 -16.4122L1125.21 -16.6158L1124.94 33.5234L1161.69 33.727L1161.97 -16.4122Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.45 -11.8365H1166.06L1165.77 38.3027L1128.87 38.1565V36.4023",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.17 -12.385L1129.34 -12.4561L1129.27 0.115294L1142.11 0.186375L1142.17 -12.385Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.74 8.4823L1156.43 8.62848",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.74 13.7448L1156.43 13.8909",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.6 18.861L1156.43 19.0071",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.25 84.667L1208.36 111.902L1245.1 149.701L1272.99 122.466L1236.25 84.667Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.67 91.6588L1215.61 111.243L1219.99 115.746L1240.05 96.1612L1235.67 91.6588Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.62 102.942L1226.36 122.731L1245.29 142.206L1265.55 122.418L1246.62 102.942Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.8 113.146L1255.32 132.149",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.51 122.794L1250.36 136.973",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.9 108.03L1260.42 127.179",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.4 127.618L1251.24 108.176",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.21 132.442L1256.05 113.146",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.03 137.412L1260.72 118.116",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.15 152.047L1058.28 154.469L1061.55 207.139L1100.42 204.718L1097.15 152.047Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.18 157.015L1064.23 158.756L1064.62 165.03L1092.57 163.288L1092.18 157.015Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.14 172.675L1064.89 174.435L1066.58 201.573L1094.82 199.813L1093.14 172.675Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.99 173.956L1080.74 200.561",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.57 180.973L1073.73 200.853",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.28 173.518L1087.88 199.976",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.57 181.411L1093.13 179.657",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 188.282L1093.57 186.528",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.44 195.152L1094.01 193.398",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.63 49.8509L1259.84 58.1831L1261.74 74.8474L1277.78 81.5716L1291.05 71.3391L1288.72 54.5286L1276.91 49.4124",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.74 46.1965C1276.76 47.5121 1276.47 49.5586 1275.16 50.5818C1273.84 51.6051 1271.8 51.3127 1270.78 49.9971C1269.76 48.6815 1270.05 46.635 1271.36 45.6118C1272.68 44.5885 1274.57 44.7347 1275.74 46.1965Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.32 54.3824C1256.2 55.4056 1255.9 57.0136 1254.88 57.8907C1253.86 58.7677 1252.26 58.4754 1251.38 57.4521C1250.51 56.4289 1250.8 54.8209 1251.82 53.9438C1252.99 53.0668 1254.59 53.2129 1255.32 54.3824Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.01 92.2427C1283.18 93.8507 1282.89 96.0434 1281.28 97.2128C1279.68 98.3822 1277.49 98.0899 1276.32 96.4819C1275.16 94.8739 1275.45 92.6813 1277.05 91.5118C1278.66 90.3424 1280.84 90.6348 1282.01 92.2427Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.29 83.3258C1310.16 84.4953 1310.01 86.1032 1308.85 87.1265C1307.68 88.0035 1306.08 87.8574 1305.06 86.6879C1304.18 85.5185 1304.33 83.9105 1305.49 82.8873C1306.66 81.8641 1308.41 82.1564 1309.29 83.3258Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.72 30.1168C1303.89 31.5786 1303.6 33.7713 1302.14 34.7946C1300.68 35.964 1298.49 35.6716 1297.47 34.2098C1296.3 32.7481 1296.6 30.5554 1298.05 29.5321C1299.51 28.3627 1301.56 28.6551 1302.72 30.1168Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.14 65.6382C1324.45 67.3924 1324.16 69.8774 1322.41 71.193C1320.66 72.5086 1318.18 72.2163 1316.87 70.4621C1315.56 68.708 1315.85 66.2229 1317.6 64.9073C1319.35 63.5917 1321.83 63.8841 1323.14 65.6382Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.72 54.5286L1301.85 44.5885L1317.74 50.8742L1319.06 63.7379",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.05 71.3391L1306.51 77.9171L1316.58 70.1697",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.53 35.5254L1301.85 44.5885",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.9 56.7213L1259.84 58.1831",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.51 90.9271L1277.78 81.5717",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.51 77.9171L1306.66 82.0101",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.62 2.05051L1177.87 10.2365L1185.46 17.2531L1195.52 14.1833L1197.85 3.95083L1190.12 -2.91956L1182.54 -0.726879",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.64 -1.75011C1181.66 -1.45775 1182.39 -0.434504 1182.1 0.588745C1181.81 1.61199 1180.79 2.34289 1179.77 2.05053C1178.75 1.75817 1178.02 0.734923 1178.31 -0.288326C1178.6 -1.31158 1179.62 -1.89629 1180.64 -1.75011Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.23 10.2365C1175.1 10.3826 1175.54 11.2597 1175.39 11.9906C1175.25 12.8677 1174.37 13.3062 1173.64 13.16C1172.77 13.0138 1172.33 12.1368 1172.48 11.4059C1172.62 10.5288 1173.5 9.94409 1174.23 10.2365Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.79 17.3993C1202.96 17.6916 1203.69 18.8611 1203.4 20.0305C1203.11 21.1999 1201.94 21.9308 1200.77 21.6385C1199.6 21.3461 1198.88 20.1767 1199.17 19.0073C1199.46 17.984 1200.63 17.1069 1201.79 17.3993Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.13 2.48901C1212 2.63519 1212.59 3.51227 1212.29 4.38934C1212.15 5.26641 1211.27 5.85112 1210.4 5.55876C1209.52 5.41258 1208.94 4.53551 1209.23 3.65844C1209.23 2.78137 1210.11 2.19666 1211.13 2.48901Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.85 3.95094L1207.63 1.02737L1209.38 -6.72009",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.54 11.1136L1177.87 10.2366",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.6 18.1302L1195.52 14.1833",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.63 1.02734L1209.38 2.78149",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.31 187.697L1124.05 183.019L1111.36 193.106L1114.14 209.77L1129.16 215.471L1141.7 204.946L1139.95 192.667",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.85 189.89C1141.26 191.498 1139.51 192.229 1137.91 191.644C1136.31 191.059 1135.58 189.305 1136.16 187.697C1136.74 186.089 1138.49 185.358 1140.1 185.943C1141.7 186.674 1142.43 188.428 1141.85 189.89Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.93 177.465C1124.49 178.634 1123.03 179.365 1121.87 178.78C1120.7 178.342 1119.97 176.88 1120.55 175.71C1120.99 174.541 1122.45 173.81 1123.62 174.395C1124.78 174.833 1125.37 176.295 1124.93 177.465Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.57 218.687C1106.84 220.441 1104.95 221.318 1103.2 220.733C1101.45 220.003 1100.57 218.102 1101.15 216.348C1101.88 214.594 1103.78 213.717 1105.53 214.302C1107.28 214.886 1108.16 216.933 1107.57 218.687Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.72 236.375C1128.28 237.69 1126.68 238.421 1125.37 237.836C1124.05 237.398 1123.32 235.79 1123.91 234.474C1124.35 233.159 1125.95 232.428 1127.26 233.012C1128.57 233.597 1129.3 235.059 1128.72 236.375Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.83 203.923C1168.25 205.677 1166.35 206.408 1164.6 205.823C1162.85 205.238 1162.12 203.338 1162.7 201.584C1163.29 199.83 1165.18 199.099 1166.93 199.684C1168.68 200.415 1169.41 202.315 1168.83 203.923Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.07 241.172C1149.15 240.942 1150.65 239.065 1150.42 236.979C1150.19 234.892 1148.32 233.387 1146.24 233.616C1144.16 233.846 1142.66 235.723 1142.88 237.809C1143.11 239.896 1144.99 241.401 1147.07 241.172Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.7 204.946L1156.58 210.647L1159.5 226.873L1149.72 234.62",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.16 215.471L1131.78 231.405L1143.16 235.79",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.29 204.946L1156.58 210.647",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.18 179.219L1124.05 183.019",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.84 215.179L1114.14 209.77",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.78 231.404L1128.43 233.597",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.87 -9.35145C1295.87 -9.35145 1280.84 -9.05909 1279.24 -9.05909C1277.64 -9.05909 1275.74 -9.78999 1273.55 -11.398C1271.36 -13.0059 1264.51 -17.3913 1257.07 -17.2451C1249.78 -17.0989 1235.92 -8.3282 1236.21 8.77468C1236.51 26.0237 1250.36 28.8011 1254.74 28.655C1259.11 28.655 1262.32 26.7546 1264.95 28.5088C1267.57 30.2629 1270.49 33.1865 1271.8 33.1865C1273.11 33.1865 1272.68 28.9473 1273.99 28.8011C1275.3 28.655 1281.43 27.4855 1283.18 27.1932C1284.93 26.9008 1285.8 25.8776 1285.8 22.954C1285.8 20.0304 1286.39 14.3295 1289.16 14.3295C1291.93 14.3295 1297.03 14.1833 1297.03 14.1833",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.53 35.964L1241.9 29.8245",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.38 28.9473L1235.63 24.7081",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.4 18.5687L1230.53 15.6451",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.65 6.58215L1229.94 6.28979",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.28 16.9607C1264.8 17.1069 1264.65 20.6152 1262.61 20.3228C1260.57 20.0305 1258.53 22.077 1256.92 21.3461C1255.32 20.6152 1251.82 22.3693 1250.65 20.1767C1249.49 17.984 1246.42 19.8843 1245.99 16.6684C1245.69 13.4524 1243.07 14.1833 1243.07 11.1136C1243.07 8.04384 1240.73 6.58205 1242.63 4.68173C1244.38 2.78141 1241.76 -0.873047 1244.82 -1.45776C1247.88 -2.04247 1245.55 -5.11222 1247.59 -5.40458C1249.63 -5.69694 1251.97 -9.64376 1255.03 -8.47433C1258.09 -7.3049 1259.84 -10.2285 1261.15 -8.03579C1262.47 -5.84312 1265.53 -9.05904 1266.99 -5.98929C1268.45 -2.91955 1271.8 -3.79662 1271.36 -0.580692C1271.07 2.78141 1274.28 4.38938 1272.82 6.72823C1271.36 9.06709 1273.26 11.8445 1271.22 13.0139C1269.47 14.0372 1271.51 16.6684 1267.28 16.9607Z",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.45 16.2299C1261.59 13.014 1260.28 12.1369 1257.95 11.8445C1255.47 11.5522 1254.3 11.2598 1253.57 8.62861C1252.84 5.85122 1252.69 3.22001 1250.51 1.9044C1248.47 0.588795 1245.84 -1.60388 1245.84 -1.60388",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.13 8.62864C1248.17 8.04392 1249.92 3.36621 1251.82 3.36621",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.47 13.0139C1250.94 13.1601 1253.86 9.79797 1253.86 9.79797",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.15 16.376C1256.2 15.9374 1256.49 14.1833 1257.95 12.5753",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.01 6.58208C1263.2 7.60533 1257.8 4.24322 1259.84 -1.60392C1261.74 -7.45106 1255.9 -8.62048 1255.9 -8.62048",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.61 10.6751C1255.9 8.92094 1257.95 4.68176 1260.57 4.68176",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.65 6.72815C1263.93 8.62847 1264.8 11.9906 1266.55 14.0371",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.78 -5.98926C1250.36 -3.35805 1252.26 -0.726832 1256.49 0.0040601",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.36 0.296383C1268.59 2.1967 1265.53 3.07377 1264.8 -0.28833",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.05 15.6452C1117.05 15.6452 1106.99 6.14361 1105.97 5.12036C1104.8 4.09711 1104.07 2.34296 1103.78 0.00410883C1103.49 -2.33475 1101.59 -9.78985 1096.78 -14.3214C1091.82 -18.9991 1077.23 -21.9227 1066.59 -10.5207C1055.79 0.881178 1063.09 11.6984 1066 14.3296C1068.92 17.107 1072.28 17.9841 1072.86 20.7615C1073.44 23.685 1073.59 27.3395 1074.46 28.2166C1075.34 28.9474 1077.67 26.0239 1078.69 26.7548C1079.71 27.4857 1084.38 30.5554 1085.69 31.5787C1087.01 32.6019 1088.17 32.4557 1090.07 30.5554C1091.97 28.6551 1095.9 25.293 1097.8 27.0471C1099.7 28.8013 1103.05 32.0172 1103.05 32.0172",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.96 8.04382L1056.82 6.87439",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.81 -1.01929L1055.94 -0.580753",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.61 14.6219C1079.86 13.1601 1077.53 15.4989 1076.51 13.891C1075.34 12.283 1072.71 12.4292 1072.13 10.8212C1071.55 9.35943 1068.05 8.19 1068.78 6.1435C1069.5 3.95083 1066.15 3.21993 1068.05 0.881076C1069.8 -1.45778 1067.75 -2.62721 1069.65 -4.67371C1071.55 -6.7202 1070.96 -9.05906 1073.44 -9.20524C1075.92 -9.35142 1076.36 -13.4444 1078.84 -11.8365C1081.32 -10.2285 1081.61 -13.7368 1083.21 -12.7135C1084.67 -11.5441 1088.76 -12.7135 1090.07 -10.0823C1091.38 -7.4511 1094.3 -8.18199 1093.72 -5.84313C1093.13 -3.50428 1097.36 -3.65045 1096.2 -0.726885C1095.17 2.19668 1097.95 3.80465 1095.61 5.70497C1093.28 7.60529 1094.45 10.8212 1091.97 11.4059C1089.49 11.9906 1088.9 15.0604 1086.86 14.4757C1084.97 14.0371 1084.67 17.1069 1081.61 14.6219Z",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.4 10.3828C1080.59 8.48244 1080.3 7.02066 1078.84 5.26652C1077.38 3.51238 1076.8 2.63531 1078.11 0.296451C1079.28 -2.0424 1081.03 -3.94272 1080.44 -6.1354C1080.01 -8.32808 1079.57 -11.3978 1079.57 -11.3978",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.84 0.00402832C1073.3 1.75817 1077.38 1.31963 1077.38 1.31963",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.3 5.85107C1074.9 6.87432 1076.21 5.85107 1078.26 5.85107",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.76 8.33621C1084.97 5.85118 1083.65 0.2964 1088.61 -2.33481C1093.57 -4.81985 1090.51 -9.49756 1090.51 -9.49756",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.96 3.07365C1079.28 2.05041 1083.36 0.588621 1085.11 2.34276",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.42 6.28967C1084.67 7.16674 1083.21 9.79796 1083.07 12.283",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.88 6.28959C1091.82 5.70488 1089.34 4.38927 1090.8 1.75806",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.61 280.959C1109.61 280.959 1098.82 274.966 1097.65 274.235C1096.49 273.504 1094.88 273.358 1092.7 273.796C1090.51 274.089 1083.8 274.673 1078.4 271.604C1073.15 268.68 1066.44 256.986 1073.3 244.561C1080.15 232.135 1091.38 235.498 1094.45 237.252C1097.65 239.006 1099.26 241.637 1101.88 241.345C1104.51 241.052 1107.72 240.175 1108.74 240.614C1109.61 241.052 1107.72 243.976 1108.74 244.707C1109.61 245.438 1113.55 248.654 1114.86 249.384C1116.03 250.262 1116.18 251.285 1115.16 253.477C1114.14 255.67 1112.24 259.909 1114.28 261.079C1116.32 262.248 1119.97 264.295 1119.97 264.295",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.67 225.265L1085.55 231.405",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.8 227.604L1078.99 232.72",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.34 232.866L1071.84 237.398",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.5 240.906L1067.61 243.83",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.44 250.408L1065.13 251.139",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.3 260.348L1064.98 259.617",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.65 269.119L1067.17 266.634",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.11 250.7C1097.36 249.531 1098.68 247.046 1097.07 246.461C1095.47 245.876 1094.74 243.537 1093.28 243.537C1091.82 243.537 1089.92 240.76 1088.32 241.929C1086.72 243.099 1085.11 240.468 1083.65 242.66C1082.19 244.853 1080.59 243.391 1079.42 245.584C1078.26 247.776 1076.07 247.923 1076.51 250.115C1077.09 252.308 1073.73 253.77 1075.78 255.524C1077.82 257.132 1074.9 258.448 1076.21 259.471C1077.67 260.494 1077.82 264.295 1080.44 264.587C1083.07 264.879 1083.21 267.657 1085.11 266.634C1086.86 265.464 1087.88 269.119 1090.22 267.364C1092.4 265.61 1094.59 267.657 1095.61 265.172C1096.63 262.687 1099.7 262.833 1099.55 260.494C1099.4 258.155 1101.74 256.84 1100.72 255.378C1099.4 253.624 1102.03 252.6 1099.11 250.7Z",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.45 248.946C1093.42 251.285 1091.97 251.577 1090.22 250.846C1088.32 250.115 1087.44 249.823 1085.69 251.577C1084.09 253.185 1082.92 255.232 1080.88 255.378C1078.84 255.524 1076.21 256.109 1076.21 256.109",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.3 248.507C1081.61 249.677 1081.03 253.916 1082.34 254.501",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.8 246.169C1085.69 247.046 1086.42 250.554 1086.42 250.554",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.19 246.022C1090.51 247.046 1090.07 248.507 1090.51 250.262",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.61 258.448C1092.55 255.816 1087.3 256.255 1086.42 261.225C1085.55 266.195 1080.88 264.879 1080.88 264.879",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.03 250.7C1087.44 252.016 1087.3 255.963 1089.34 256.986",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.13 257.132C1093.42 255.378 1095.32 253.331 1097.36 252.6",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.38 260.64C1078.84 258.886 1081.17 257.863 1084.53 258.886",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.47 264.441C1094.15 261.956 1092.26 260.202 1090.51 262.248",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.45 21.3461C1317.45 21.3461 1322.27 10.675 1323 8.92089C1323.43 8.04381 1324.6 7.60528 1326.2 8.48235C1328.1 9.35942 1327.66 11.5521 1327.66 11.5521C1327.66 11.5521 1361.35 26.7547 1363.83 27.9241C1366.31 29.0935 1367.92 32.3094 1366.02 36.5486C1364.13 40.6416 1360.63 41.3725 1358.44 40.3493C1356.25 39.326 1321.97 23.8311 1321.97 23.8311C1321.97 23.8311 1320.95 25.8776 1318.62 24.7082C1317.02 23.9773 1317.02 22.2231 1317.45 21.3461Z",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.89 19.2994L1322.85 23.6848",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.5 22.3693L1325.33 24.8543",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.43 21.7845L1328.39 26.3161",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.18 25.0005L1331.02 27.4855",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.12 24.2695L1334.08 28.8011",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.73 27.4855L1336.56 29.9705",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.96 26.1699C1369.96 26.1699 1381.63 0.296335 1382.79 -2.33488C1383.96 -4.96609 1381.92 -10.6671 1376.52 -10.6671C1371.13 -10.6671 1342.54 -9.78998 1342.54 -9.78998L1328.54 -16.0757C1328.54 -16.0757 1328.83 -18.2683 1326.64 -19.2916C1325.18 -20.0225 1323.87 -19.1454 1323.58 -18.4145C1323.29 -17.6836 1318.33 -6.86641 1317.89 -5.69698C1317.45 -4.81991 1318.04 -3.79666 1319.35 -3.21195C1321.39 -2.33488 1322.7 -4.2352 1322.7 -4.2352C1322.7 -4.2352 1334.52 1.17341 1335.1 1.31958C1335.68 1.61194 1347.64 15.9374 1347.64 15.9374",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.33 -9.79004C1361.94 -8.47443 1365.29 6.58195 1360.48 19.4457",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.15 65.1996C1094.15 65.1996 1098.53 59.2063 1099.26 58.1831C1099.55 57.7445 1100.43 57.5984 1101.3 58.3293C1102.47 59.2063 1101.74 60.5219 1101.74 60.5219C1101.74 60.5219 1120.99 74.7012 1122.45 75.7245C1123.91 76.7477 1124.49 79.0866 1122.74 81.4255C1120.99 83.7643 1118.66 83.7643 1117.49 82.7411C1116.18 81.864 1096.78 67.5385 1096.78 67.5385C1096.78 67.5385 1095.9 68.7079 1094.59 67.6847C1093.57 66.8076 1093.86 65.7844 1094.15 65.1996Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.11 64.9072L1097.22 67.5384",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.7 67.0999L1098.68 68.5616",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.32 67.2461L1100.43 69.8773",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.9 69.4388L1101.88 70.9006",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.53 69.585L1103.63 72.2162",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 71.7776L1105.09 73.2394",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.53 75.2859C1126.53 75.2859 1137.33 60.5219 1138.35 59.0601C1139.37 57.5984 1138.93 53.6515 1135.58 52.9206C1132.22 52.1898 1113.99 48.9738 1113.99 48.9738L1105.97 43.1267C1105.97 43.1267 1106.41 41.8111 1105.24 40.934C1104.36 40.3493 1103.49 40.6416 1103.2 41.0802C1102.9 41.5187 1098.38 47.6582 1097.8 48.3891C1097.51 48.8276 1097.65 49.5585 1098.38 50.1433C1099.55 51.0203 1100.57 49.9971 1100.57 49.9971C1100.57 49.9971 1107.28 54.9671 1107.72 55.2595C1108.01 55.5519 1113.7 66.2229 1113.7 66.2229",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 43.2728L1104.22 45.7579",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.72 44.4423L1106.7 45.7579",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.61 45.9041L1107.86 48.3891",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.36 47.0734L1110.34 48.389",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.37 51.3126C1126.24 52.3359 1126.39 62.276 1121.57 69.7311",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.67 37.8643L1080.3 66.0767L1086.57 62.5684L1070.09 33.9175L1062.94 29.8245L1063.67 37.8643Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.09 33.9175C1070.09 33.9175 1068.78 37.2796 1063.67 37.7181",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.67 61.6913L1083.94 58.3292",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.37 175.564C1348.81 183.166 1348.67 195.298 1341.08 202.753C1333.5 210.209 1321.39 210.062 1313.95 202.461C1306.51 194.86 1306.66 182.727 1314.24 175.272C1321.83 167.817 1333.93 167.963 1341.37 175.564Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.33 188.867L1300.83 188.574C1300.68 195.445 1303.31 202.315 1308.41 207.577C1318.77 218.102 1335.68 218.395 1346.19 208.016C1351.44 202.9 1354.21 196.029 1354.21 189.159H1350.85",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.24 175.272C1317.02 181.411 1332.33 189.013 1341.37 175.564",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.18 198.222C1317.02 191.644 1333.79 188.282 1344.73 198.076",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.42 212.255L1346.33 208.016",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.6 229.212L1367.33 207.87C1367.33 207.87 1363.83 204.654 1360.04 208.308C1358.29 206.554 1356.25 206.993 1354.35 208.893C1352.31 210.793 1348.23 214.886 1346.92 216.056C1345.6 217.371 1344.58 220.003 1346.33 221.903C1344.73 223.657 1342.69 226.288 1345.6 229.212Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.55 293.122C1277.37 288.335 1276.61 281.343 1271.83 277.505C1267.05 273.667 1260.08 274.437 1256.25 279.224C1252.42 284.011 1253.19 291.002 1257.96 294.84C1262.74 298.678 1269.72 297.909 1273.55 293.122Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.38 286.222L1249.34 286.075C1249.34 290.022 1250.8 293.969 1253.72 297.039C1259.7 303.178 1269.47 303.324 1275.59 297.331C1278.66 294.408 1280.26 290.461 1280.26 286.514H1278.36",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.07 278.328C1258.67 281.836 1267.57 286.222 1272.82 278.474",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.32 291.484C1258.67 287.683 1268.45 285.783 1274.72 291.338",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.07 299.67L1275.74 297.331",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.3 309.464L1287.85 297.185C1287.85 297.185 1285.8 295.285 1283.62 297.477C1282.59 296.454 1281.43 296.746 1280.26 297.916C1279.09 299.085 1276.76 301.278 1276.03 302.155C1275.3 303.032 1274.72 304.494 1275.74 305.517C1274.86 306.248 1273.7 307.856 1275.3 309.464Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.84 43.7113H1428.45V-6.28174L1377.84 43.7113ZM1419.84 34.6482H1400.73L1419.84 15.7912V34.6482Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.51 4.82788H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.76 9.06702H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.51 12.8677H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.76 17.1069H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.51 21.0537H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.76 25.2928H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.51 29.2396H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.76 33.4789H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.51 37.2794H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.53 351.417H1121.14V301.424L1070.53 351.417ZM1112.53 342.208H1093.42L1112.53 323.351V342.208Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.34 312.387H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.59 316.627H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.34 320.427H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.59 324.813H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.34 328.613H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.59 332.852H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.34 336.799H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.59 341.038H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.34 344.839H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.58 300.839L1294.55 315.457L1309.87 286.806L1338.89 272.188L1323.58 300.839Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.64 282.859L1348.37 297.916C1348.37 297.916 1348.96 305.371 1338.46 315.603C1327.95 325.836 1320.37 325.251 1320.37 325.251L1305.64 310.195",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.2 314.288L1316.43 333.145",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.66 333.291C1321.83 334.46 1321.83 336.507 1320.66 337.676C1319.49 338.846 1317.45 338.846 1316.29 337.676C1315.12 336.507 1315.12 334.46 1316.29 333.291C1317.6 331.975 1319.49 331.975 1320.66 333.291Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.83 340.454C1321.83 340.454 1322.56 344.401 1324.89 346.739C1326.06 345.57 1330.14 341.623 1330.14 341.623C1330.14 341.623 1326.5 338.7 1323.87 338.407",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.02 239.591L1199.75 269.119L1193.48 237.398L1206.75 207.724L1213.02 239.591Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.38 219.272L1230.23 221.611C1230.23 221.611 1235.48 227.019 1233.88 241.637C1232.28 256.255 1225.86 260.494 1225.86 260.494L1205 258.155",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.79 266.049L1227.9 268.972",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.11 266.487C1232.86 266.634 1234.03 268.242 1233.73 269.85C1233.59 271.604 1231.98 272.773 1230.38 272.481C1228.63 272.335 1227.46 270.727 1227.75 269.119C1227.9 267.511 1229.5 266.195 1231.11 266.487Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.65 271.311C1236.65 271.311 1239.71 273.942 1242.92 274.235C1243.07 272.627 1243.8 266.926 1243.8 266.926C1243.8 266.926 1239.13 266.926 1236.94 268.388",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.2 214.708L1256.87 240.412L1291.78 276.327L1318.11 250.622L1283.2 214.708Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.14 216.348L1289.3 215.179L1324.16 251.139L1297.91 277.012L1296.74 275.696",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.85 231.583L1262.66 240.56L1271.41 249.564L1280.6 240.588L1271.85 231.583Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.16 228.773L1282.59 221.464",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.36 232.135L1285.8 224.827",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.64 255.232L1296.74 236.521",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.28 259.032L1300.39 240.321",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.93 262.687L1304.03 243.976",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.87 149.675L1288.72 130.571L1262.79 163.504L1286.95 182.609L1312.87 149.675Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.2 154.076L1313.22 154.807L1287.26 187.843L1263.05 168.694L1263.93 167.524",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.64 142.135L1289.28 135.525L1282.78 143.787L1291.14 150.397L1297.64 142.135Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.39 144.574L1307.24 149.983",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.05 147.498L1304.91 152.907",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.8 149.545L1296.3 163.432",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.03 152.907L1293.68 166.794",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.41 156.415L1290.91 170.302",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.69 221.892L1341.79 249.127L1378.53 286.927L1406.43 259.692L1369.69 221.892Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.11 229.091L1349.05 248.675L1353.43 253.178L1373.48 233.593L1369.11 229.091Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.06 240.167L1359.79 259.956L1378.72 279.431L1398.99 259.643L1380.06 240.167Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.11 250.408L1388.63 269.411",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.81 260.056L1383.67 274.235",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.36 245.292L1393.88 264.441",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.85 264.879L1384.54 245.438",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.52 269.703L1389.36 250.408",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.34 274.674L1394.17 255.378",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.61 289.31L1191.74 291.732L1195.01 344.402L1233.88 341.98L1230.61 289.31Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.49 294.286L1197.54 296.028L1197.93 302.302L1225.88 300.56L1225.49 294.286Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.59 309.938L1198.35 311.698L1200.03 338.835L1228.28 337.076L1226.59 309.938Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.44 311.218L1214.04 337.822",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.02 318.381L1207.19 338.261",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.73 310.78L1221.34 337.384",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.02 318.673L1226.59 316.919",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.46 325.544L1227.02 323.789",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.9 332.414L1227.46 330.66",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.48 218.248L1412.11 223.072L1423.34 215.763L1422.47 201.877L1410.51 195.883L1399.42 203.484L1399.86 213.863",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397.96 215.91C1398.55 214.74 1400.01 214.156 1401.32 214.74C1402.48 215.325 1403.07 216.787 1402.48 218.102C1401.9 219.272 1400.44 219.856 1399.13 219.272C1397.82 218.541 1397.38 217.079 1397.96 215.91Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.94 227.604C1411.38 226.581 1412.55 226.288 1413.57 226.727C1414.59 227.166 1414.88 228.335 1414.44 229.358C1414.01 230.381 1412.84 230.674 1411.82 230.235C1410.8 229.651 1410.36 228.481 1410.94 227.604Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.59 195.152C1429.32 193.691 1431.07 193.106 1432.38 193.837C1433.84 194.568 1434.43 196.322 1433.7 197.637C1432.97 199.099 1431.22 199.684 1429.9 198.953C1428.45 198.222 1428.01 196.468 1428.59 195.152Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.69 178.78C1413.28 177.757 1414.44 177.319 1415.61 177.757C1416.63 178.342 1417.07 179.511 1416.63 180.681C1416.05 181.704 1414.88 182.142 1413.72 181.704C1412.55 181.119 1412.11 179.804 1412.69 178.78Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.96 202.023C1377.69 200.707 1379.29 200.122 1380.61 200.853C1381.92 201.584 1382.5 203.192 1381.77 204.508C1381.04 205.823 1379.44 206.408 1378.13 205.677C1376.81 205.092 1376.38 203.485 1376.96 202.023Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.19 174.98C1395.92 173.372 1397.82 172.787 1399.42 173.518C1401.03 174.249 1401.61 176.149 1400.88 177.757C1400.15 179.365 1398.26 179.95 1396.65 179.219C1395.05 178.488 1394.46 176.588 1395.19 174.98Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.42 203.485L1387.61 197.637L1386.59 184.043L1395.34 178.488",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.51 195.883L1409.78 182.581L1400.73 178.049",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.63 201.73L1387.61 197.637",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.4 226.288L1412.11 223.073",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.88 198.076L1422.47 201.877",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.78 182.581L1412.69 180.973",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.99 119.139L1313.08 128.203L1320.95 137.119L1332.77 134.634L1336.56 123.379L1328.39 114.608L1319.5 116.362",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.6 114.9C1318.77 115.339 1319.35 116.508 1319.06 117.678C1318.62 118.847 1317.45 119.432 1316.29 119.139C1315.12 118.701 1314.54 117.531 1314.83 116.362C1315.12 115.193 1316.43 114.608 1317.6 114.9Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.99 127.764C1309.87 128.056 1310.45 129.08 1310.16 129.957C1309.87 130.834 1308.85 131.419 1307.97 131.126C1307.1 130.834 1306.51 129.811 1306.81 128.933C1307.1 128.056 1308.12 127.472 1308.99 127.764Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.62 139.02C1340.94 139.458 1341.66 140.92 1341.23 142.236C1340.79 143.551 1339.33 144.282 1338.02 143.844C1336.71 143.405 1335.98 141.943 1336.41 140.628C1336.85 139.312 1338.31 138.581 1339.62 139.02Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.73 122.94C1352.75 123.232 1353.19 124.256 1352.9 125.279C1352.6 126.302 1351.58 126.741 1350.56 126.448C1349.54 126.156 1349.1 125.133 1349.39 124.109C1349.69 123.232 1350.71 122.648 1351.73 122.94Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.79 94.8738C1328.1 95.3123 1328.68 96.6279 1328.25 97.7973C1327.81 99.1129 1326.5 99.6976 1325.33 99.2591C1324.02 98.8206 1323.43 97.505 1323.87 96.3355C1324.16 95.1661 1325.47 94.4352 1326.79 94.8738Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1352.75 107.299C1354.21 107.737 1354.94 109.345 1354.5 110.807C1354.06 112.269 1352.46 113 1351 112.561C1349.54 112.123 1348.81 110.515 1349.25 109.053C1349.69 107.591 1351.29 106.86 1352.75 107.299Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.39 114.608L1332.04 103.644L1343.71 100.867L1349.69 107.737",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.56 123.379L1347.94 121.04L1350.71 112.415",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.66 98.8206L1332.04 103.644",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.31 128.933L1313.08 128.202",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337 139.604L1332.77 134.634",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.94 121.04L1349.69 123.232",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.11 319.258L1248.03 322.181L1243.94 335.922L1254.3 346.447L1268.16 342.792L1271.8 328.905L1264.22 321.012",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.36 318.088C1264.8 319.55 1263.93 321.012 1262.47 321.304C1261.01 321.743 1259.55 320.866 1259.26 319.404C1258.82 317.942 1259.7 316.48 1261.15 316.188C1262.47 315.749 1263.93 316.627 1264.36 318.088Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.84 317.65C1246.13 318.819 1245.4 319.842 1244.38 320.135C1243.21 320.427 1242.19 319.696 1241.9 318.673C1241.61 317.65 1242.34 316.48 1243.36 316.188C1244.38 315.896 1245.55 316.627 1245.84 317.65Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.15 356.241C1254.59 357.849 1253.57 359.457 1251.97 359.895C1250.36 360.334 1248.76 359.311 1248.32 357.703C1247.88 356.095 1248.9 354.487 1250.51 354.048C1252.11 353.61 1253.72 354.633 1254.15 356.241Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.36 358.141C1278.66 359.311 1277.93 360.626 1276.76 360.919C1275.59 361.211 1274.28 360.48 1273.99 359.311C1273.7 358.141 1274.43 356.826 1275.59 356.533C1276.91 356.241 1278.07 356.972 1278.36 358.141Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.76 314.434C1291.2 316.042 1290.18 317.504 1288.72 317.942C1287.12 318.381 1285.66 317.357 1285.22 315.896C1284.78 314.288 1285.8 312.826 1287.26 312.387C1288.87 311.949 1290.47 312.826 1290.76 314.434Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.99 348.932C1295.43 350.686 1294.41 352.586 1292.66 353.025C1290.91 353.464 1289.01 352.44 1288.57 350.686C1288.14 348.932 1289.16 347.032 1290.91 346.593C1292.8 346.008 1294.55 347.178 1294.99 348.932Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.8 328.905L1285.37 325.397L1295.72 335.63L1292.51 346.155",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.16 342.793L1278.07 353.025L1288.43 350.248",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.41 317.942L1285.37 325.397",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.4 319.843L1248.03 322.181",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.97 354.048L1254.3 346.447",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.07 353.025L1276.76 356.241",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.68 125.571C1425.68 125.571 1411.53 125.717 1409.92 125.864C1408.32 125.864 1406.57 125.133 1404.53 123.671C1402.48 122.209 1395.92 117.97 1388.92 118.116C1381.92 118.262 1368.94 126.448 1369.23 142.674C1369.52 158.9 1382.65 161.531 1386.73 161.531C1390.82 161.531 1393.88 159.631 1396.5 161.385C1398.98 163.139 1401.76 165.77 1402.92 165.77C1404.09 165.77 1403.8 161.823 1405.11 161.677C1406.42 161.531 1412.11 160.362 1413.86 160.216C1415.47 160.069 1416.34 159.046 1416.34 156.269C1416.34 153.491 1416.92 148.083 1419.55 148.083C1422.17 148.083 1426.99 147.937 1426.99 147.937",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.54 168.402L1374.77 162.554",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.83 161.824L1368.79 157.731",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358 151.883L1363.98 149.106",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.54 140.628L1363.25 140.335",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.44 129.226L1364.56 131.565",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.69 119.14L1368.94 123.086",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.71 112.123L1375.06 117.093",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.69 150.568C1396.36 150.714 1396.21 154.076 1394.32 153.784C1392.42 153.491 1390.38 155.392 1388.92 154.661C1387.46 153.93 1384.11 155.684 1383.09 153.491C1382.07 151.445 1379 153.199 1378.71 150.129C1378.42 147.059 1376.09 147.79 1375.94 144.867C1375.94 141.943 1373.75 140.628 1375.5 138.727C1377.25 136.827 1374.63 133.465 1377.54 132.88C1380.46 132.295 1378.27 129.372 1380.17 129.226C1382.07 129.079 1384.25 125.279 1387.17 126.302C1390.09 127.325 1391.69 124.694 1393 126.741C1394.32 128.787 1397.23 125.717 1398.55 128.641C1399.86 131.565 1403.07 130.687 1402.78 133.757C1402.48 136.827 1405.55 138.435 1404.09 140.628C1402.63 142.82 1404.38 145.451 1402.48 146.475C1400.73 147.644 1402.78 150.129 1398.69 150.568Z",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.15 149.691C1393.3 146.621 1392.13 145.744 1389.8 145.452C1387.46 145.159 1386.44 144.867 1385.71 142.382C1384.98 139.751 1384.84 137.266 1382.79 135.95C1380.9 134.634 1378.42 132.734 1378.42 132.734",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.71 142.528C1380.61 141.943 1382.21 137.558 1383.96 137.558",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.9 146.767C1383.23 146.913 1386 143.698 1386 143.698",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.15 149.983C1388.05 149.545 1388.34 147.937 1389.8 146.329",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.42 140.628C1394.9 141.505 1389.8 138.435 1391.69 132.88C1393.59 127.325 1387.9 126.156 1387.9 126.156",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.61 144.574C1387.75 142.967 1389.8 138.874 1392.28 138.874",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.21 140.774C1395.48 142.674 1396.36 145.744 1397.96 147.644",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.21 128.641C1382.65 131.126 1384.54 133.611 1388.48 134.196",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.48 134.634C1399.86 136.388 1396.94 137.266 1396.21 134.196",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177 340.892C1177 340.892 1174.96 327.005 1174.66 325.397C1174.37 323.936 1174.96 322.035 1176.12 319.843C1177.29 317.65 1180.5 310.633 1179.48 303.763C1178.46 296.893 1168.68 285.198 1152.79 287.537C1136.89 289.876 1136.01 303.178 1136.6 307.125C1137.18 311.218 1139.37 313.995 1138.06 316.627C1136.74 319.258 1134.41 322.328 1134.55 323.497C1134.7 324.666 1138.49 323.789 1138.93 325.105C1139.22 326.274 1141.12 331.829 1141.56 333.437C1141.99 335.045 1143.01 335.63 1145.79 335.337C1148.56 335.045 1153.81 334.753 1154.24 337.384C1154.68 340.015 1155.27 344.693 1155.27 344.693",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.99 292.215L1134.26 295.577",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.53 284.76L1138.2 289.145",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.43 277.889L1145.93 283.298",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.37 274.82L1154.39 281.544",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.75 275.258L1163.14 281.69",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.25 279.205L1172.18 284.76",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.27 286.075L1178.75 290.022",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.14 317.65C1148.7 315.311 1145.35 315.75 1145.49 313.849C1145.64 311.949 1143.45 310.195 1143.89 308.733C1144.33 307.125 1142.28 304.055 1144.18 302.886C1146.08 301.57 1143.89 298.939 1146.81 298.208C1149.72 297.477 1148.7 295.285 1151.62 294.846C1154.54 294.408 1155.56 292.215 1157.6 293.531C1159.64 294.992 1162.56 292.069 1163.58 294.846C1164.6 297.624 1167.08 294.992 1167.52 296.893C1167.95 298.793 1172.04 300.401 1171.31 303.324C1170.58 306.248 1173.5 307.564 1171.6 309.025C1169.71 310.487 1173.06 312.972 1170.43 314.726C1167.81 316.481 1168.98 319.404 1165.91 319.55C1162.85 319.696 1161.68 322.912 1159.35 321.743C1157.02 320.574 1154.68 322.766 1153.37 321.012C1152.2 319.112 1150.02 321.451 1149.14 317.65Z",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.14 312.095C1152.06 311.949 1152.79 310.487 1152.79 308.294C1152.79 305.956 1152.93 304.932 1155.27 303.763C1157.75 302.74 1160.22 302.155 1161.1 300.108C1162.12 298.062 1163.73 295.431 1163.73 295.431",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.39 296.893C1155.12 298.647 1159.79 299.67 1159.93 301.424",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.45 299.67C1150.6 302.009 1154.1 304.201 1154.1 304.201",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.12 305.225C1148.7 306.979 1150.45 307.125 1152.2 308.295",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.77 316.919C1157.31 312.534 1159.79 307.125 1165.33 308.294C1170.87 309.464 1171.46 303.763 1171.46 303.763",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.52 305.956C1155.12 305.956 1159.35 307.271 1159.64 309.903",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.33 313.849C1156.43 313.411 1153.52 314.58 1151.77 316.48",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.39 298.5C1166.06 299.378 1163.87 301.424 1163.73 305.371",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.18 319.258C1163.14 316.919 1161.97 314.142 1164.89 312.972",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404.82 354.925C1404.82 354.925 1393 348.347 1391.69 347.616C1390.38 346.886 1388.63 346.739 1386.3 347.032C1383.96 347.47 1376.52 347.909 1370.83 344.693C1365 341.477 1357.85 328.759 1365.29 315.311C1372.73 301.863 1384.84 305.517 1388.34 307.417C1391.69 309.318 1393.59 312.241 1396.36 311.949C1399.28 311.657 1402.78 310.633 1403.8 311.218C1404.82 311.803 1402.78 314.872 1403.8 315.603C1404.82 316.334 1409.05 319.843 1410.36 320.72C1411.67 321.597 1411.82 322.912 1410.65 325.105C1409.49 327.444 1407.44 332.122 1409.63 333.437C1411.82 334.607 1415.9 336.945 1415.9 336.945",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.84 294.261L1378.71 301.132",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.23 296.893L1371.56 302.594",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.04 302.594L1363.69 307.564",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.77 311.364L1359.31 314.58",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.27 321.743L1356.4 322.474",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.12 332.56L1356.25 331.683",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.77 342.062L1358.73 339.43",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.44 322.035C1391.55 320.866 1393 317.942 1391.25 317.358C1389.5 316.773 1388.63 314.288 1387.17 314.142C1385.57 314.142 1383.52 311.218 1381.77 312.387C1380.02 313.703 1378.27 310.779 1376.67 313.265C1375.06 315.603 1373.31 313.995 1372 316.48C1370.69 318.965 1368.21 319.112 1368.94 321.451C1369.52 323.789 1365.88 325.397 1368.06 327.298C1370.25 329.052 1367.04 330.514 1368.65 331.537C1370.11 332.56 1370.4 336.799 1373.17 337.092C1376.09 337.53 1376.23 340.454 1378.27 339.284C1380.17 338.115 1381.34 341.915 1383.82 340.161C1386.3 338.261 1388.48 340.454 1389.65 337.676C1390.82 334.899 1394.03 335.045 1393.88 332.56C1393.73 330.075 1396.36 328.613 1395.19 326.859C1393.73 325.251 1396.65 324.082 1393.44 322.035Z",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1388.34 320.135C1387.17 322.766 1385.71 322.912 1383.67 322.181C1381.63 321.304 1380.61 321.158 1378.86 322.912C1377.11 324.666 1375.79 326.859 1373.61 327.005C1371.42 327.151 1368.5 327.736 1368.5 327.736",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.02 319.696C1374.34 321.012 1373.75 325.544 1375.21 326.274",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.81 317.065C1378.86 317.942 1379.73 321.889 1379.73 321.889",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.65 316.919C1384.11 318.088 1383.52 319.696 1384.11 321.597",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.5 330.514C1386.15 327.736 1380.46 328.028 1379.59 333.583C1378.71 338.992 1373.46 337.53 1373.46 337.53",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.48 322.035C1380.9 323.497 1380.75 327.736 1382.94 328.906",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.88 329.052C1387.17 327.151 1389.21 324.959 1391.4 324.082",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.81 332.853C1371.42 330.952 1374.04 329.783 1377.54 330.952",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.5 336.945C1388.19 334.314 1386 332.268 1383.96 334.607",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.4 98.8207C1384.4 98.8207 1385.57 88.7344 1385.86 87.1264C1386 86.3955 1386.88 85.6646 1388.34 85.8108C1390.23 86.1032 1390.23 88.0035 1390.23 88.0035C1390.23 88.0035 1422.17 91.9503 1424.51 92.2427C1426.84 92.535 1429.03 94.8739 1428.59 98.8207C1428.15 102.768 1425.38 104.083 1423.2 103.937C1421.15 103.645 1388.77 99.6978 1388.77 99.6978C1388.77 99.6978 1388.34 101.598 1386.15 101.306C1384.69 101.16 1384.25 99.6978 1384.4 98.8207Z",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.94 95.1663L1389.5 99.4054",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392.13 97.359L1391.84 99.6979",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.34 95.8971L1394.75 100.136",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397.53 98.0898L1397.23 100.429",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.59 96.4819L1400.15 100.721",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.78 98.6744L1402.48 101.013",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.18 89.3191C1429.18 89.3191 1432.24 64.9073 1432.53 62.4222C1432.82 59.9372 1429.61 55.698 1425.24 57.1598C1420.72 58.6216 1397.38 66.6614 1397.38 66.6614L1384.11 65.0534C1384.11 65.0534 1383.82 63.1531 1381.77 62.8608C1380.46 62.7146 1379.59 63.7378 1379.44 64.4687C1379.29 65.1996 1378.13 75.4321 1377.98 76.6015C1377.84 77.3324 1378.56 78.2095 1379.88 78.3557C1381.77 78.648 1382.36 76.7477 1382.36 76.7477C1382.36 76.7477 1393.59 78.0633 1394.17 78.2095C1394.75 78.2095 1408.32 87.1264 1408.32 87.1264",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383.96 65.0535L1383.52 69.2926",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.73 65.3458L1386.44 67.6847",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.94 65.7844L1389.36 70.0236",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392.57 66.0767L1392.28 68.4155",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.97 61.9836C1413.72 62.5684 1420.28 74.2626 1419.55 86.1031",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.61 202.461C1227.61 202.461 1231.98 196.468 1232.71 195.445C1233 195.006 1233.88 194.86 1234.76 195.591C1235.92 196.468 1235.19 197.783 1235.19 197.783C1235.19 197.783 1254.45 211.963 1255.9 212.986C1257.36 214.009 1257.95 216.348 1256.2 218.687C1254.45 221.026 1252.11 221.026 1250.94 220.003C1249.63 219.125 1230.23 204.8 1230.23 204.8C1230.23 204.8 1229.36 205.969 1228.05 204.946C1227.02 204.069 1227.17 203.046 1227.61 202.461Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.57 202.169L1230.67 204.8",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.15 204.361L1232.13 205.823",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.78 204.508L1233.88 207.139",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.36 206.7L1235.34 208.162",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.98 206.847L1237.09 209.478",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.57 209.185L1238.55 210.501",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.99 212.548C1259.99 212.548 1270.78 197.784 1271.8 196.322C1272.82 194.86 1272.38 190.913 1269.03 190.182C1265.68 189.451 1247.44 186.235 1247.44 186.235L1239.42 180.388C1239.42 180.388 1239.86 179.073 1238.69 178.196C1237.82 177.611 1236.94 177.903 1236.65 178.342C1236.36 178.78 1231.84 184.92 1231.25 185.651C1230.96 186.089 1231.11 186.82 1231.84 187.405C1233 188.282 1234.03 187.259 1234.03 187.259C1234.03 187.259 1240.73 192.229 1241.17 192.521C1241.46 192.813 1247.15 203.484 1247.15 203.484",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.57 180.535L1237.67 183.02",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.17 181.704L1240.15 183.019",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.07 183.166L1241.17 185.651",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.67 184.335L1243.65 185.651",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.82 188.574C1259.7 189.597 1259.84 199.538 1255.03 206.993",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.48 63.2993L1355.08 95.6048L1362.23 96.9204L1367.77 64.3226L1365 56.7213L1360.48 63.2993Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.77 64.3225C1367.77 64.3225 1364.56 65.9305 1360.33 63.1531",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1355.96 90.6346L1362.96 91.9503",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.19 274.82L1174.52 247.777L1168.54 251.87L1187.06 279.205L1194.5 282.713L1193.19 274.82Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.06 279.205C1187.06 279.205 1188.23 275.843 1193.19 274.82",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.44 252.016L1171.6 255.816",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.74 313.265L1426.26 262.979L1415.03 263.418L1417.36 313.995L1424.07 324.52L1428.74 313.265Z",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.36 313.995C1417.36 313.995 1421.59 310.487 1428.74 313.265",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.55 270.873L1415.76 271.019",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.05 14.6218L1417.8 -8.91293L1412.69 -14.0292L1389.65 9.50556L1387.61 17.3992L1395.05 14.6218Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.65 9.50549C1389.65 9.50549 1393.15 9.94403 1395.05 14.6217",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1587.06 65.5318C1594.68 58.0956 1594.84 45.8793 1587.42 38.2459C1580 30.6126 1567.81 30.4528 1560.19 37.889C1552.57 45.3252 1552.42 57.5414 1559.83 65.1748C1567.25 72.8082 1579.44 72.968 1587.06 65.5318Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1550.29 51.605L1546.79 51.3126C1546.65 58.183 1549.27 65.0534 1554.38 70.3158C1564.73 80.8407 1581.65 81.133 1592.15 70.7544C1597.4 65.6381 1600.17 58.7677 1600.17 51.8973H1596.82",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560.21 38.0105C1562.98 44.15 1578.3 51.7513 1587.34 38.3029",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1557.15 60.9604C1562.98 54.3824 1579.75 51.0203 1590.69 60.8143",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.53 74.9936L1592.3 70.7544",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.57 91.9503L1613.3 70.6082C1613.3 70.6082 1609.8 67.3923 1606.01 71.0468C1604.26 69.2926 1602.21 69.7312 1600.32 71.6315C1598.28 73.5318 1594.19 77.6248 1592.88 78.7942C1591.57 80.1098 1590.55 82.7411 1592.3 84.6414C1590.84 86.3955 1588.8 89.0267 1591.57 91.9503Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517.95 157.522C1522.67 153.619 1523.34 146.617 1519.44 141.883C1515.55 137.15 1508.56 136.477 1503.84 140.38C1499.12 144.284 1498.45 151.285 1502.34 156.019C1506.24 160.753 1513.22 161.426 1517.95 157.522Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497.49 148.96L1495.45 148.814C1495.45 152.761 1496.91 156.707 1499.83 159.777C1505.81 165.917 1515.58 166.063 1521.7 160.069C1524.77 157.146 1526.37 153.199 1526.37 149.252H1524.48",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1503.18 141.066C1504.79 144.574 1513.68 148.96 1518.93 141.212",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1501.43 154.222C1504.79 150.422 1514.56 148.521 1520.83 154.076",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524.18 162.408L1521.7 159.923",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.27 172.202L1533.81 159.923C1533.81 159.923 1531.77 158.023 1529.58 160.216C1528.56 159.192 1527.39 159.485 1526.23 160.654C1525.06 161.824 1522.73 164.016 1522 164.893C1521.27 165.624 1520.68 167.232 1521.7 168.255C1520.83 168.986 1519.66 170.594 1521.27 172.202Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.07 288.56L1434.49 321.45L1441.78 321.743L1442.51 288.706L1438.71 281.544L1435.07 288.56Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.51 288.706C1442.51 288.706 1439.59 290.753 1435.07 288.706",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.63 316.334L1441.63 316.627",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.01 332.268L1475.76 303.178L1447.17 273.796L1446.01 332.268ZM1465.41 302.74L1454.18 313.703L1454.61 291.63L1465.41 302.74Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1451.11 282.421L1452.13 281.544",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.57 285.929L1454.47 284.029",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.78 287.245L1456.8 286.368",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.24 290.753L1459.13 288.853",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460.45 292.069L1461.32 291.192",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.91 295.577L1463.8 293.677",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.11 296.746L1465.99 295.869",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1466.57 300.401L1468.47 298.354",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1469.78 301.57L1470.66 300.693",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1569.54 163.578L1540.67 178.196L1555.83 149.545L1584.86 134.927L1569.54 163.578Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.61 145.598L1594.34 160.654C1594.34 160.654 1594.92 168.109 1584.42 178.342C1573.92 188.574 1566.34 187.99 1566.34 187.99L1551.6 172.933",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.17 177.026L1562.54 195.883",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.63 196.029C1567.79 197.199 1567.79 199.245 1566.63 200.415C1565.46 201.584 1563.42 201.584 1562.25 200.415C1561.08 199.245 1561.08 197.199 1562.25 196.029C1563.56 194.714 1565.46 194.714 1566.63 196.029Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1567.79 203.192C1567.79 203.192 1568.52 207.139 1570.86 209.478C1572.02 208.308 1576.11 204.362 1576.11 204.362C1576.11 204.362 1572.46 201.438 1569.84 201.146",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.99 102.329L1445.72 131.857L1439.59 99.9901L1452.72 70.462L1458.99 102.329Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.34 82.0101L1476.2 84.349C1476.2 84.349 1481.45 89.7576 1479.85 104.375C1478.24 118.993 1471.82 123.232 1471.82 123.232L1450.97 120.894",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447.76 128.787L1473.87 131.711",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1477.22 129.226C1478.97 129.372 1480.14 130.98 1479.85 132.588C1479.7 134.342 1478.09 135.511 1476.49 135.219C1474.74 135.073 1473.57 133.465 1473.87 131.857C1474.01 130.249 1475.47 128.933 1477.22 129.226Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.62 134.05C1482.62 134.05 1485.68 136.681 1488.89 136.973C1489.03 135.365 1489.76 129.664 1489.76 129.664C1489.76 129.664 1485.1 129.664 1482.91 131.126",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1529.18 77.4825L1502.85 103.187L1537.76 139.102L1564.09 113.397L1529.18 77.4825Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.25 79.0865L1535.27 77.9171L1570.27 113.877L1543.87 139.751L1542.71 138.435",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517.83 94.3583L1508.64 103.335L1517.39 112.339L1526.58 103.363L1517.83 94.3583Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.12 91.5117L1528.56 84.2028",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524.33 94.7276L1531.77 87.5648",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.6 117.97L1542.85 99.2592",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1527.25 121.771L1546.35 103.06",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.89 125.425L1550 106.714",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.39 -16.4122L1504.63 -16.6158L1504.36 33.5234L1541.11 33.727L1541.39 -16.4122Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.87 -11.8365H1545.48L1545.19 38.3027L1508.29 38.1565V36.4023",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.59 -12.385L1508.76 -12.4561L1508.69 0.115294L1521.53 0.186375L1521.59 -12.385Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.16 8.4823L1535.85 8.62848",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.16 13.7448L1535.85 13.8909",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.02 18.861L1535.85 19.0071",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.67 84.667L1587.78 111.902L1624.52 149.701L1652.41 122.466L1615.67 84.667Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.09 91.6588L1595.03 111.243L1599.41 115.746L1619.47 96.1612L1615.09 91.6588Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1626.04 102.942L1605.77 122.731L1624.71 142.206L1644.97 122.418L1626.04 102.942Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.22 113.146L1634.74 132.149",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.92 122.794L1629.78 136.973",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.32 108.03L1639.84 127.179",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610.82 127.618L1630.66 108.176",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.63 132.442L1635.47 113.146",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.45 137.412L1640.14 118.116",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.57 152.047L1437.7 154.469L1440.97 207.139L1479.84 204.718L1476.57 152.047Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.6 157.015L1443.65 158.756L1444.04 165.03L1471.99 163.288L1471.6 157.015Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.56 172.675L1444.31 174.435L1446 201.573L1474.24 199.813L1472.56 172.675Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.4 173.956L1460.16 200.561",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1451.99 180.973L1453.15 200.853",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.7 173.518L1467.3 199.976",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444.99 181.411L1472.55 179.657",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445.42 188.282L1472.99 186.528",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445.86 195.152L1473.43 193.398",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.05 49.8509L1639.26 58.1831L1641.16 74.8474L1657.2 81.5716L1670.47 71.3391L1668.14 54.5286L1656.33 49.4124",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.16 46.1965C1656.18 47.5121 1655.89 49.5586 1654.58 50.5818C1653.26 51.6051 1651.22 51.3127 1650.2 49.9971C1649.18 48.6815 1649.47 46.635 1650.78 45.6118C1652.1 44.5885 1653.99 44.7347 1655.16 46.1965Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.74 54.3824C1635.61 55.4056 1635.32 57.0136 1634.3 57.8907C1633.28 58.7677 1631.68 58.4754 1630.8 57.4521C1629.93 56.4289 1630.22 54.8209 1631.24 53.9438C1632.41 53.0668 1634.01 53.2129 1634.74 54.3824Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1661.43 92.2427C1662.6 93.8507 1662.31 96.0434 1660.7 97.2128C1659.1 98.3822 1656.91 98.0899 1655.74 96.4819C1654.58 94.8739 1654.87 92.6813 1656.47 91.5118C1658.08 90.3424 1660.26 90.6348 1661.43 92.2427Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.71 83.3258C1689.58 84.4953 1689.43 86.1032 1688.27 87.1265C1687.1 88.0035 1685.5 87.8574 1684.48 86.6879C1683.6 85.5185 1683.75 83.9105 1684.91 82.8873C1686.08 81.8641 1687.83 82.1564 1688.71 83.3258Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.14 30.1168C1683.31 31.5786 1683.02 33.7713 1681.56 34.7946C1680.1 35.964 1677.91 35.6716 1676.89 34.2098C1675.72 32.7481 1676.02 30.5554 1677.47 29.5321C1678.93 28.3627 1680.97 28.6551 1682.14 30.1168Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.56 65.6382C1703.87 67.3924 1703.58 69.8774 1701.83 71.193C1700.08 72.5086 1697.6 72.2163 1696.29 70.4621C1694.98 68.708 1695.27 66.2229 1697.02 64.9073C1698.77 63.5917 1701.25 63.8841 1702.56 65.6382Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1668.14 54.5286L1681.27 44.5885L1697.16 50.8742L1698.48 63.7379",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670.47 71.3391L1685.93 77.9171L1696 70.1697",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1679.95 35.5254L1681.27 44.5885",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.32 56.7213L1639.26 58.1831",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.93 90.9271L1657.2 81.5717",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685.93 77.9171L1686.08 82.0101",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559.04 2.05051L1557.29 10.2365L1564.88 17.2531L1574.94 14.1833L1577.27 3.95083L1569.54 -2.91956L1561.96 -0.726879",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560.06 -1.75011C1561.08 -1.45775 1561.81 -0.434504 1561.52 0.588745C1561.23 1.61199 1560.21 2.34289 1559.19 2.05053C1558.17 1.75817 1557.44 0.734923 1557.73 -0.288326C1558.02 -1.31158 1559.04 -1.89629 1560.06 -1.75011Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553.65 10.2365C1554.52 10.3826 1554.96 11.2597 1554.81 11.9906C1554.67 12.8677 1553.79 13.3062 1553.06 13.16C1552.19 13.0138 1551.75 12.1368 1551.9 11.4059C1552.04 10.5288 1552.92 9.94409 1553.65 10.2365Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.21 17.3993C1582.38 17.6916 1583.11 18.8611 1582.82 20.0305C1582.52 21.1999 1581.36 21.9308 1580.19 21.6385C1579.02 21.3461 1578.3 20.1767 1578.59 19.0073C1578.88 17.984 1580.05 17.1069 1581.21 17.3993Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1590.55 2.48901C1591.42 2.63519 1592.01 3.51227 1591.71 4.38934C1591.57 5.26641 1590.69 5.85112 1589.82 5.55876C1588.94 5.41258 1588.36 4.53551 1588.65 3.65844C1588.65 2.78137 1589.53 2.19666 1590.55 2.48901Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1577.27 3.95094L1587.05 1.02737L1588.8 -6.72009",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554.96 11.1136L1557.29 10.2366",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.02 18.1302L1574.94 14.1833",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.05 1.02734L1588.8 2.78149",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515.72 187.697L1503.47 183.019L1490.78 193.106L1493.56 209.77L1508.58 215.471L1521.12 204.946L1519.37 192.667",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.27 189.89C1520.68 191.498 1518.93 192.229 1517.33 191.644C1515.72 191.059 1515 189.305 1515.58 187.697C1516.16 186.089 1517.91 185.358 1519.52 185.943C1521.12 186.674 1521.85 188.428 1521.27 189.89Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.35 177.465C1503.91 178.634 1502.45 179.365 1501.29 178.78C1500.12 178.342 1499.39 176.88 1499.97 175.71C1500.41 174.541 1501.87 173.81 1503.04 174.395C1504.2 174.833 1504.79 176.295 1504.35 177.465Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.99 218.687C1486.26 220.441 1484.37 221.318 1482.62 220.733C1480.87 220.003 1479.99 218.102 1480.57 216.348C1481.3 214.594 1483.2 213.717 1484.95 214.302C1486.7 214.886 1487.58 216.933 1486.99 218.687Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.14 236.375C1507.7 237.69 1506.1 238.421 1504.79 237.836C1503.47 237.398 1502.74 235.79 1503.33 234.474C1503.76 233.159 1505.37 232.428 1506.68 233.012C1507.99 233.597 1508.72 235.059 1508.14 236.375Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.25 203.923C1547.67 205.677 1545.77 206.408 1544.02 205.823C1542.27 205.238 1541.54 203.338 1542.12 201.584C1542.71 199.83 1544.6 199.099 1546.35 199.684C1548.1 200.415 1548.83 202.315 1548.25 203.923Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.49 241.172C1528.57 240.942 1530.07 239.065 1529.84 236.979C1529.61 234.892 1527.74 233.387 1525.66 233.616C1523.58 233.846 1522.08 235.723 1522.3 237.809C1522.53 239.896 1524.41 241.401 1526.49 241.172Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.12 204.946L1536 210.647L1538.92 226.873L1529.14 234.62",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.58 215.471L1511.2 231.405L1522.58 235.79",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.71 204.946L1536 210.647",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1502.6 179.219L1503.47 183.019",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.26 215.179L1493.56 209.77",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1511.2 231.404L1507.85 233.597",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.29 -9.35145C1675.29 -9.35145 1660.26 -9.05909 1658.66 -9.05909C1657.06 -9.05909 1655.16 -9.78999 1652.97 -11.398C1650.78 -13.0059 1643.93 -17.3913 1636.49 -17.2451C1629.2 -17.0989 1615.34 -8.3282 1615.63 8.77468C1615.93 26.0237 1629.78 28.8011 1634.16 28.655C1638.53 28.655 1641.74 26.7546 1644.37 28.5088C1646.99 30.2629 1649.91 33.1865 1651.22 33.1865C1652.53 33.1865 1652.1 28.9473 1653.41 28.8011C1654.72 28.655 1660.85 27.4855 1662.6 27.1932C1664.35 26.9008 1665.22 25.8776 1665.22 22.954C1665.22 20.0304 1665.81 14.3295 1668.58 14.3295C1671.35 14.3295 1676.45 14.1833 1676.45 14.1833",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.95 35.964L1621.32 29.8245",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1609.8 28.9473L1615.05 24.7081",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.82 18.5687L1609.95 15.6451",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.07 6.58215L1609.36 6.28979",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.7 16.9607C1644.22 17.1069 1644.07 20.6152 1642.03 20.3228C1639.99 20.0305 1637.95 22.077 1636.34 21.3461C1634.74 20.6152 1631.24 22.3693 1630.07 20.1767C1628.91 17.984 1625.84 19.8843 1625.41 16.6684C1625.11 13.4524 1622.49 14.1833 1622.49 11.1136C1622.49 8.04384 1620.15 6.58205 1622.05 4.68173C1623.8 2.78141 1621.18 -0.873047 1624.24 -1.45776C1627.3 -2.04247 1624.97 -5.11222 1627.01 -5.40458C1629.05 -5.69694 1631.39 -9.64376 1634.45 -8.47433C1637.51 -7.3049 1639.26 -10.2285 1640.57 -8.03579C1641.89 -5.84312 1644.95 -9.05904 1646.41 -5.98929C1647.87 -2.91955 1651.22 -3.79662 1650.78 -0.580692C1650.49 2.78141 1653.7 4.38938 1652.24 6.72823C1650.78 9.06709 1652.68 11.8445 1650.64 13.0139C1648.89 14.0372 1650.93 16.6684 1646.7 16.9607Z",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640.87 16.2299C1641.01 13.014 1639.7 12.1369 1637.37 11.8445C1634.89 11.5522 1633.72 11.2598 1632.99 8.62861C1632.26 5.85122 1632.11 3.22001 1629.93 1.9044C1627.88 0.588795 1625.26 -1.60388 1625.26 -1.60388",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625.55 8.62864C1627.59 8.04392 1629.34 3.36621 1631.24 3.36621",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.88 13.0139C1630.36 13.1601 1633.28 9.79797 1633.28 9.79797",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.57 16.376C1635.62 15.9374 1635.91 14.1833 1637.37 12.5753",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1647.43 6.58208C1642.62 7.60533 1637.22 4.24322 1639.26 -1.60392C1641.16 -7.45106 1635.32 -8.62048 1635.32 -8.62048",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.03 10.6751C1635.32 8.92094 1637.37 4.68176 1639.99 4.68176",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644.07 6.72815C1643.35 8.62847 1644.22 11.9906 1645.97 14.0371",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.2 -5.98926C1629.78 -3.35805 1631.68 -0.726832 1635.91 0.0040601",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.78 0.296383C1648.01 2.1967 1644.95 3.07377 1644.22 -0.28833",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.47 15.6452C1496.47 15.6452 1486.41 6.14361 1485.39 5.12036C1484.22 4.09711 1483.49 2.34296 1483.2 0.00410883C1482.91 -2.33475 1481.01 -9.78985 1476.2 -14.3214C1471.24 -18.9991 1456.65 -21.9227 1446.01 -10.5207C1435.21 0.881178 1442.51 11.6984 1445.42 14.3296C1448.34 17.107 1451.7 17.9841 1452.28 20.7615C1452.86 23.685 1453.01 27.3395 1453.88 28.2166C1454.76 28.9474 1457.09 26.0239 1458.11 26.7548C1459.13 27.4857 1463.8 30.5554 1465.11 31.5787C1466.43 32.6019 1467.59 32.4557 1469.49 30.5554C1471.39 28.6551 1475.32 25.293 1477.22 27.0471C1479.12 28.8013 1482.47 32.0172 1482.47 32.0172",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.38 8.04382L1436.24 6.87439",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.23 -1.01929L1435.36 -0.580753",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.03 14.6219C1459.28 13.1601 1456.95 15.4989 1455.93 13.891C1454.76 12.283 1452.13 12.4292 1451.55 10.8212C1450.97 9.35943 1447.47 8.19 1448.2 6.1435C1448.92 3.95083 1445.57 3.21993 1447.47 0.881076C1449.22 -1.45778 1447.17 -2.62721 1449.07 -4.67371C1450.97 -6.7202 1450.38 -9.05906 1452.86 -9.20524C1455.34 -9.35142 1455.78 -13.4444 1458.26 -11.8365C1460.74 -10.2285 1461.03 -13.7368 1462.63 -12.7135C1464.09 -11.5441 1468.18 -12.7135 1469.49 -10.0823C1470.8 -7.4511 1473.72 -8.18199 1473.14 -5.84313C1472.55 -3.50428 1476.78 -3.65045 1475.62 -0.726885C1474.59 2.19668 1477.37 3.80465 1475.03 5.70497C1472.7 7.60529 1473.87 10.8212 1471.39 11.4059C1468.91 11.9906 1468.32 15.0604 1466.28 14.4757C1464.38 14.0371 1464.09 17.1069 1461.03 14.6219Z",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.82 10.3828C1460.01 8.48244 1459.72 7.02066 1458.26 5.26652C1456.8 3.51238 1456.22 2.63531 1457.53 0.296451C1458.7 -2.0424 1460.45 -3.94272 1459.86 -6.1354C1459.43 -8.32808 1458.99 -11.3978 1458.99 -11.3978",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1451.26 0.00402832C1452.72 1.75817 1456.8 1.31963 1456.8 1.31963",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.72 5.85107C1454.32 6.87432 1455.63 5.85107 1457.68 5.85107",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.18 8.33621C1464.38 5.85118 1463.07 0.2964 1468.03 -2.33481C1472.99 -4.81985 1469.93 -9.49756 1469.93 -9.49756",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.38 3.07365C1458.7 2.05041 1462.78 0.588621 1464.53 2.34276",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.84 6.28967C1464.09 7.16674 1462.63 9.79796 1462.49 12.283",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474.3 6.28959C1471.24 5.70488 1468.76 4.38927 1470.22 1.75806",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1489.03 280.959C1489.03 280.959 1478.24 274.966 1477.07 274.235C1475.91 273.504 1474.3 273.358 1472.12 273.796C1469.93 274.089 1463.22 274.673 1457.82 271.604C1452.57 268.68 1445.86 256.986 1452.72 244.561C1459.57 232.135 1470.8 235.498 1473.87 237.252C1477.07 239.006 1478.68 241.637 1481.3 241.345C1483.93 241.052 1487.14 240.175 1488.16 240.614C1489.03 241.052 1487.14 243.976 1488.16 244.707C1489.03 245.438 1492.97 248.654 1494.28 249.384C1495.45 250.262 1495.6 251.285 1494.58 253.477C1493.56 255.67 1491.66 259.909 1493.7 261.079C1495.74 262.248 1499.39 264.295 1499.39 264.295",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.09 225.265L1464.97 231.405",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.22 227.604L1458.41 232.72",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447.76 232.866L1451.26 237.398",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.92 240.906L1447.03 243.83",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.86 250.408L1444.55 251.139",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.71 260.348L1444.4 259.617",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.07 269.119L1446.59 266.634",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478.53 250.7C1476.78 249.531 1478.1 247.046 1476.49 246.461C1474.89 245.876 1474.16 243.537 1472.7 243.537C1471.24 243.537 1469.34 240.76 1467.74 241.929C1466.14 243.099 1464.53 240.468 1463.07 242.66C1461.61 244.853 1460.01 243.391 1458.84 245.584C1457.68 247.776 1455.49 247.923 1455.93 250.115C1456.51 252.308 1453.15 253.77 1455.2 255.524C1457.24 257.132 1454.32 258.448 1455.63 259.471C1457.09 260.494 1457.24 264.295 1459.86 264.587C1462.49 264.879 1462.63 267.657 1464.53 266.634C1466.28 265.464 1467.3 269.119 1469.64 267.364C1471.82 265.61 1474.01 267.657 1475.03 265.172C1476.05 262.687 1479.12 262.833 1478.97 260.494C1478.82 258.155 1481.16 256.84 1480.14 255.378C1478.82 253.624 1481.45 252.6 1478.53 250.7Z",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.87 248.946C1472.84 251.285 1471.39 251.577 1469.64 250.846C1467.74 250.115 1466.86 249.823 1465.11 251.577C1463.51 253.185 1462.34 255.232 1460.3 255.378C1458.26 255.524 1455.63 256.109 1455.63 256.109",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1459.72 248.507C1461.03 249.677 1460.45 253.916 1461.76 254.501",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.22 246.169C1465.11 247.046 1465.84 250.554 1465.84 250.554",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.61 246.022C1469.93 247.046 1469.49 248.507 1469.93 250.262",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.03 258.448C1471.97 255.816 1466.72 256.255 1465.84 261.225C1464.97 266.195 1460.3 264.879 1460.3 264.879",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1467.45 250.7C1466.86 252.016 1466.72 255.963 1468.76 256.986",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.55 257.132C1472.84 255.378 1474.74 253.331 1476.78 252.6",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.8 260.64C1458.26 258.886 1460.59 257.863 1463.95 258.886",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474.89 264.441C1473.57 261.956 1471.68 260.202 1469.93 262.248",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.87 21.3461C1696.87 21.3461 1701.69 10.675 1702.42 8.92089C1702.85 8.04381 1704.02 7.60528 1705.62 8.48235C1707.52 9.35942 1707.08 11.5521 1707.08 11.5521C1707.08 11.5521 1740.77 26.7547 1743.25 27.9241C1745.73 29.0935 1747.34 32.3094 1745.44 36.5486C1743.55 40.6416 1740.04 41.3725 1737.86 40.3493C1735.67 39.326 1701.39 23.8311 1701.39 23.8311C1701.39 23.8311 1700.37 25.8776 1698.04 24.7082C1696.44 23.9773 1696.44 22.2231 1696.87 21.3461Z",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.31 19.2994L1702.27 23.6848",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.92 22.3693L1704.75 24.8543",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709.85 21.7845L1707.81 26.3161",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1711.6 25.0005L1710.44 27.4855",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.54 24.2695L1713.5 28.8011",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.15 27.4855L1715.98 29.9705",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.38 26.1699C1749.38 26.1699 1761.05 0.296335 1762.21 -2.33488C1763.38 -4.96609 1761.34 -10.6671 1755.94 -10.6671C1750.55 -10.6671 1721.96 -9.78998 1721.96 -9.78998L1707.96 -16.0757C1707.96 -16.0757 1708.25 -18.2683 1706.06 -19.2916C1704.6 -20.0225 1703.29 -19.1454 1703 -18.4145C1702.71 -17.6836 1697.75 -6.86641 1697.31 -5.69698C1696.87 -4.81991 1697.46 -3.79666 1698.77 -3.21195C1700.81 -2.33488 1702.12 -4.2352 1702.12 -4.2352C1702.12 -4.2352 1713.94 1.17341 1714.52 1.31958C1715.1 1.61194 1727.06 15.9374 1727.06 15.9374",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.75 -9.79004C1741.36 -8.47443 1744.71 6.58195 1739.9 19.4457",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.57 65.1996C1473.57 65.1996 1477.95 59.2063 1478.68 58.1831C1478.97 57.7445 1479.85 57.5984 1480.72 58.3293C1481.89 59.2063 1481.16 60.5219 1481.16 60.5219C1481.16 60.5219 1500.41 74.7012 1501.87 75.7245C1503.33 76.7477 1503.91 79.0866 1502.16 81.4255C1500.41 83.7643 1498.08 83.7643 1496.91 82.7411C1495.6 81.864 1476.2 67.5385 1476.2 67.5385C1476.2 67.5385 1475.32 68.7079 1474.01 67.6847C1472.99 66.8076 1473.28 65.7844 1473.57 65.1996Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478.53 64.9072L1476.64 67.5384",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.12 67.0999L1478.09 68.5616",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1481.74 67.2461L1479.85 69.8773",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.32 69.4388L1481.3 70.9006",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.95 69.585L1483.05 72.2162",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.53 71.7776L1484.51 73.2394",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.95 75.2859C1505.95 75.2859 1516.75 60.5219 1517.77 59.0601C1518.79 57.5984 1518.35 53.6515 1515 52.9206C1511.64 52.1898 1493.41 48.9738 1493.41 48.9738L1485.39 43.1267C1485.39 43.1267 1485.83 41.8111 1484.66 40.934C1483.78 40.3493 1482.91 40.6416 1482.62 41.0802C1482.32 41.5187 1477.8 47.6582 1477.22 48.3891C1476.93 48.8276 1477.07 49.5585 1477.8 50.1433C1478.97 51.0203 1479.99 49.9971 1479.99 49.9971C1479.99 49.9971 1486.7 54.9671 1487.14 55.2595C1487.43 55.5519 1493.12 66.2229 1493.12 66.2229",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.53 43.2728L1483.64 45.7579",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1487.14 44.4423L1486.12 45.7579",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1489.03 45.9041L1487.28 48.3891",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490.78 47.0734L1489.76 48.389",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.79 51.3126C1505.66 52.3359 1505.81 62.276 1500.99 69.7311",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.09 37.8643L1459.72 66.0767L1465.99 62.5684L1449.51 33.9175L1442.36 29.8245L1443.09 37.8643Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.51 33.9175C1449.51 33.9175 1448.2 37.2796 1443.09 37.7181",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.09 61.6913L1463.36 58.3292",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.79 175.564C1728.23 183.166 1728.09 195.298 1720.5 202.753C1712.92 210.209 1700.81 210.062 1693.37 202.461C1685.93 194.86 1686.08 182.727 1693.66 175.272C1701.25 167.817 1713.35 167.963 1720.79 175.564Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.75 188.867L1680.25 188.574C1680.1 195.445 1682.73 202.315 1687.83 207.577C1698.19 218.102 1715.1 218.395 1725.61 208.016C1730.86 202.9 1733.63 196.029 1733.63 189.159H1730.27",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.66 175.272C1696.44 181.411 1711.75 189.013 1720.79 175.564",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690.6 198.222C1696.44 191.644 1713.21 188.282 1724.15 198.076",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729.84 212.255L1725.75 208.016",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725.02 229.212L1746.75 207.87C1746.75 207.87 1743.25 204.654 1739.46 208.308C1737.71 206.554 1735.67 206.993 1733.77 208.893C1731.73 210.793 1727.65 214.886 1726.33 216.056C1725.02 217.371 1724 220.003 1725.75 221.903C1724.15 223.657 1722.11 226.288 1725.02 229.212Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.97 293.122C1656.79 288.335 1656.03 281.343 1651.25 277.505C1646.47 273.667 1639.5 274.437 1635.67 279.224C1631.84 284.011 1632.61 291.002 1637.38 294.84C1642.16 298.678 1649.14 297.909 1652.97 293.122Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630.8 286.222L1628.76 286.075C1628.76 290.022 1630.22 293.969 1633.14 297.039C1639.12 303.178 1648.89 303.324 1655.01 297.331C1658.08 294.408 1659.68 290.461 1659.68 286.514H1657.78",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1636.49 278.328C1638.09 281.836 1646.99 286.222 1652.24 278.474",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.74 291.484C1638.09 287.683 1647.87 285.783 1654.14 291.338",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.49 299.67L1655.16 297.331",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.72 309.464L1667.26 297.185C1667.26 297.185 1665.22 295.285 1663.04 297.477C1662.01 296.454 1660.85 296.746 1659.68 297.916C1658.51 299.085 1656.18 301.278 1655.45 302.155C1654.72 303.032 1654.14 304.494 1655.16 305.517C1654.28 306.248 1653.12 307.856 1654.72 309.464Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.26 43.7113H1807.87V-6.28174L1757.26 43.7113ZM1799.26 34.6482H1780.15L1799.26 15.7912V34.6482Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.93 4.82788H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.18 9.06702H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.93 12.8677H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.18 17.1069H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.93 21.0537H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.18 25.2928H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.93 29.2396H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.18 33.4789H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.93 37.2794H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.95 351.417H1500.56V301.424L1449.95 351.417ZM1491.95 342.208H1472.84L1491.95 323.351V342.208Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.76 312.387H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.01 316.627H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.76 320.427H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.01 324.813H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.76 328.613H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.01 332.852H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.76 336.799H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.01 341.038H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.76 344.839H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1703 300.839L1673.97 315.457L1689.29 286.806L1718.31 272.188L1703 300.839Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.06 282.859L1727.79 297.916C1727.79 297.916 1728.38 305.371 1717.88 315.603C1707.37 325.836 1699.79 325.251 1699.79 325.251L1685.06 310.195",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.62 314.288L1695.85 333.145",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700.08 333.291C1701.25 334.46 1701.25 336.507 1700.08 337.676C1698.91 338.846 1696.87 338.846 1695.71 337.676C1694.54 336.507 1694.54 334.46 1695.71 333.291C1697.02 331.975 1698.91 331.975 1700.08 333.291Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.25 340.454C1701.25 340.454 1701.98 344.401 1704.31 346.739C1705.48 345.57 1709.56 341.623 1709.56 341.623C1709.56 341.623 1705.92 338.7 1703.29 338.407",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1592.44 239.591L1579.17 269.119L1572.9 237.398L1586.17 207.724L1592.44 239.591Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.8 219.272L1609.65 221.611C1609.65 221.611 1614.9 227.019 1613.3 241.637C1611.7 256.255 1605.28 260.494 1605.28 260.494L1584.42 258.155",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.21 266.049L1607.32 268.972",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610.53 266.487C1612.28 266.634 1613.45 268.242 1613.15 269.85C1613.01 271.604 1611.4 272.773 1609.8 272.481C1608.05 272.335 1606.88 270.727 1607.17 269.119C1607.32 267.511 1608.92 266.195 1610.53 266.487Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.07 271.311C1616.07 271.311 1619.13 273.942 1622.34 274.235C1622.49 272.627 1623.22 266.926 1623.22 266.926C1623.22 266.926 1618.55 266.926 1616.36 268.388",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662.62 214.708L1636.29 240.412L1671.2 276.327L1697.53 250.622L1662.62 214.708Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667.56 216.348L1668.72 215.179L1703.58 251.139L1677.33 277.012L1676.16 275.696",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.27 231.583L1642.08 240.56L1650.83 249.564L1660.02 240.588L1651.27 231.583Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.58 228.773L1662.01 221.464",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.78 232.135L1665.22 224.827",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.06 255.232L1676.16 236.521",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.7 259.032L1679.81 240.321",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664.35 262.687L1683.45 243.976",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.29 149.675L1668.14 130.571L1642.21 163.504L1666.37 182.609L1692.29 149.675Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1691.62 154.076L1692.64 154.807L1666.68 187.843L1642.47 168.694L1643.35 167.524",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.06 142.135L1668.7 135.525L1662.2 143.787L1670.56 150.397L1677.06 142.135Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1679.81 144.574L1686.66 149.983",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.47 147.498L1684.33 152.907",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1658.22 149.545L1675.72 163.432",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.45 152.907L1673.1 166.794",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.83 156.415L1670.33 170.302",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.11 221.892L1721.21 249.127L1757.95 286.927L1785.85 259.692L1749.11 221.892Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.53 229.091L1728.47 248.675L1732.85 253.178L1752.9 233.593L1748.53 229.091Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.48 240.167L1739.21 259.956L1758.14 279.431L1778.41 259.643L1759.48 240.167Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.53 250.408L1768.05 269.411",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.23 260.056L1763.09 274.235",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.78 245.292L1773.3 264.441",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.27 264.879L1763.96 245.438",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.94 269.703L1768.78 250.408",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753.76 274.674L1773.59 255.378",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610.03 289.31L1571.16 291.732L1574.43 344.402L1613.3 341.98L1610.03 289.31Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.91 294.286L1576.96 296.028L1577.35 302.302L1605.3 300.56L1604.91 294.286Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1606.01 309.938L1577.77 311.698L1579.45 338.835L1607.7 337.076L1606.01 309.938Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.86 311.218L1593.46 337.822",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585.44 318.381L1586.61 338.261",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.15 310.78L1600.76 337.384",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.44 318.673L1606.01 316.919",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.88 325.544L1606.44 323.789",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.32 332.414L1606.88 330.66",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.9 218.248L1791.53 223.072L1802.76 215.763L1801.89 201.877L1789.93 195.883L1778.84 203.484L1779.28 213.863",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.38 215.91C1777.97 214.74 1779.42 214.156 1780.74 214.74C1781.9 215.325 1782.49 216.787 1781.9 218.102C1781.32 219.272 1779.86 219.856 1778.55 219.272C1777.24 218.541 1776.8 217.079 1777.38 215.91Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.36 227.604C1790.8 226.581 1791.97 226.288 1792.99 226.727C1794.01 227.166 1794.3 228.335 1793.86 229.358C1793.43 230.381 1792.26 230.674 1791.24 230.235C1790.22 229.651 1789.78 228.481 1790.36 227.604Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.01 195.152C1808.74 193.691 1810.49 193.106 1811.8 193.837C1813.26 194.568 1813.85 196.322 1813.12 197.637C1812.39 199.099 1810.64 199.684 1809.32 198.953C1807.87 198.222 1807.43 196.468 1808.01 195.152Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.11 178.78C1792.7 177.757 1793.86 177.319 1795.03 177.757C1796.05 178.342 1796.49 179.511 1796.05 180.681C1795.47 181.704 1794.3 182.142 1793.14 181.704C1791.97 181.119 1791.53 179.804 1792.11 178.78Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.38 202.023C1757.11 200.707 1758.71 200.122 1760.03 200.853C1761.34 201.584 1761.92 203.192 1761.19 204.508C1760.46 205.823 1758.86 206.408 1757.55 205.677C1756.23 205.092 1755.8 203.485 1756.38 202.023Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.61 174.98C1775.34 173.372 1777.24 172.787 1778.84 173.518C1780.45 174.249 1781.03 176.149 1780.3 177.757C1779.57 179.365 1777.67 179.95 1776.07 179.219C1774.47 178.488 1773.88 176.588 1774.61 174.98Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.84 203.485L1767.03 197.637L1766.01 184.043L1774.76 178.488",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.93 195.883L1789.2 182.581L1780.15 178.049",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.05 201.73L1767.03 197.637",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.82 226.288L1791.53 223.073",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.3 198.076L1801.89 201.877",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.2 182.581L1792.11 180.973",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695.41 119.139L1692.5 128.203L1700.37 137.119L1712.19 134.634L1715.98 123.379L1707.81 114.608L1698.91 116.362",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.02 114.9C1698.19 115.339 1698.77 116.508 1698.48 117.678C1698.04 118.847 1696.87 119.432 1695.71 119.139C1694.54 118.701 1693.96 117.531 1694.25 116.362C1694.54 115.193 1695.85 114.608 1697.02 114.9Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.41 127.764C1689.29 128.056 1689.87 129.08 1689.58 129.957C1689.29 130.834 1688.27 131.419 1687.39 131.126C1686.52 130.834 1685.93 129.811 1686.23 128.933C1686.52 128.056 1687.54 127.472 1688.41 127.764Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1719.04 139.02C1720.35 139.458 1721.08 140.92 1720.65 142.236C1720.21 143.551 1718.75 144.282 1717.44 143.844C1716.13 143.405 1715.4 141.943 1715.83 140.628C1716.27 139.312 1717.73 138.581 1719.04 139.02Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.15 122.94C1732.17 123.232 1732.61 124.256 1732.31 125.279C1732.02 126.302 1731 126.741 1729.98 126.448C1728.96 126.156 1728.52 125.133 1728.81 124.109C1729.11 123.232 1730.13 122.648 1731.15 122.94Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.21 94.8738C1707.52 95.3123 1708.1 96.6279 1707.67 97.7973C1707.23 99.1129 1705.92 99.6976 1704.75 99.2591C1703.44 98.8206 1702.85 97.505 1703.29 96.3355C1703.58 95.1661 1704.89 94.4352 1706.21 94.8738Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732.17 107.299C1733.63 107.737 1734.36 109.345 1733.92 110.807C1733.48 112.269 1731.88 113 1730.42 112.561C1728.96 112.123 1728.23 110.515 1728.67 109.053C1729.11 107.591 1730.71 106.86 1732.17 107.299Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.81 114.608L1711.46 103.644L1723.13 100.867L1729.11 107.737",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.98 123.379L1727.36 121.04L1730.13 112.415",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.08 98.8206L1711.46 103.644",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.73 128.933L1692.5 128.202",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1716.42 139.604L1712.19 134.634",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.36 121.04L1729.11 123.232",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.53 319.258L1627.45 322.181L1623.36 335.922L1633.72 346.447L1647.57 342.792L1651.22 328.905L1643.64 321.012",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.78 318.088C1644.22 319.55 1643.35 321.012 1641.89 321.304C1640.43 321.743 1638.97 320.866 1638.68 319.404C1638.24 317.942 1639.12 316.48 1640.57 316.188C1641.89 315.749 1643.35 316.627 1643.78 318.088Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625.26 317.65C1625.55 318.819 1624.82 319.842 1623.8 320.135C1622.63 320.427 1621.61 319.696 1621.32 318.673C1621.03 317.65 1621.76 316.48 1622.78 316.188C1623.8 315.896 1624.97 316.627 1625.26 317.65Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.57 356.241C1634.01 357.849 1632.99 359.457 1631.39 359.895C1629.78 360.334 1628.18 359.311 1627.74 357.703C1627.3 356.095 1628.32 354.487 1629.93 354.048C1631.53 353.61 1633.14 354.633 1633.57 356.241Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.78 358.141C1658.08 359.311 1657.35 360.626 1656.18 360.919C1655.01 361.211 1653.7 360.48 1653.41 359.311C1653.12 358.141 1653.85 356.826 1655.01 356.533C1656.33 356.241 1657.49 356.972 1657.78 358.141Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670.18 314.434C1670.62 316.042 1669.6 317.504 1668.14 317.942C1666.54 318.381 1665.08 317.357 1664.64 315.896C1664.2 314.288 1665.22 312.826 1666.68 312.387C1668.29 311.949 1669.89 312.826 1670.18 314.434Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.41 348.932C1674.85 350.686 1673.83 352.586 1672.08 353.025C1670.33 353.464 1668.43 352.44 1667.99 350.686C1667.56 348.932 1668.58 347.032 1670.33 346.593C1672.22 346.008 1673.97 347.178 1674.41 348.932Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.22 328.905L1664.79 325.397L1675.14 335.63L1671.93 346.155",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1647.57 342.793L1657.49 353.025L1667.85 350.248",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1666.83 317.942L1664.79 325.397",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.82 319.843L1627.45 322.181",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1631.39 354.048L1633.72 346.447",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.49 353.025L1656.18 356.241",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.09 125.571C1805.09 125.571 1790.95 125.717 1789.34 125.864C1787.74 125.864 1785.99 125.133 1783.95 123.671C1781.9 122.209 1775.34 117.97 1768.34 118.116C1761.34 118.262 1748.36 126.448 1748.65 142.674C1748.94 158.9 1762.07 161.531 1766.15 161.531C1770.24 161.531 1773.3 159.631 1775.92 161.385C1778.4 163.139 1781.18 165.77 1782.34 165.77C1783.51 165.77 1783.22 161.823 1784.53 161.677C1785.84 161.531 1791.53 160.362 1793.28 160.216C1794.89 160.069 1795.76 159.046 1795.76 156.269C1795.76 153.491 1796.34 148.083 1798.97 148.083C1801.59 148.083 1806.41 147.937 1806.41 147.937",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.96 168.402L1754.19 162.554",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.25 161.824L1748.21 157.731",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.42 151.883L1743.4 149.106",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.96 140.628L1742.67 140.335",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.86 129.226L1743.98 131.565",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.11 119.14L1748.36 123.086",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.13 112.123L1754.48 117.093",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.11 150.568C1775.78 150.714 1775.63 154.076 1773.74 153.784C1771.84 153.491 1769.8 155.392 1768.34 154.661C1766.88 153.93 1763.53 155.684 1762.51 153.491C1761.49 151.445 1758.42 153.199 1758.13 150.129C1757.84 147.059 1755.51 147.79 1755.36 144.867C1755.36 141.943 1753.17 140.628 1754.92 138.727C1756.67 136.827 1754.05 133.465 1756.96 132.88C1759.88 132.295 1757.69 129.372 1759.59 129.226C1761.49 129.079 1763.67 125.279 1766.59 126.302C1769.51 127.325 1771.11 124.694 1772.42 126.741C1773.74 128.787 1776.65 125.717 1777.97 128.641C1779.28 131.565 1782.49 130.687 1782.2 133.757C1781.9 136.827 1784.97 138.435 1783.51 140.628C1782.05 142.82 1783.8 145.451 1781.9 146.475C1780.15 147.644 1782.2 150.129 1778.11 150.568Z",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.57 149.691C1772.72 146.621 1771.55 145.744 1769.22 145.452C1766.88 145.159 1765.86 144.867 1765.13 142.382C1764.4 139.751 1764.26 137.266 1762.21 135.95C1760.32 134.634 1757.84 132.734 1757.84 132.734",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.13 142.528C1760.03 141.943 1761.63 137.558 1763.38 137.558",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.32 146.767C1762.65 146.913 1765.42 143.698 1765.42 143.698",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.57 149.983C1767.47 149.545 1767.76 147.937 1769.22 146.329",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.84 140.628C1774.32 141.505 1769.22 138.435 1771.11 132.88C1773.01 127.325 1767.32 126.156 1767.32 126.156",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.03 144.574C1767.17 142.967 1769.22 138.874 1771.69 138.874",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.63 140.774C1774.9 142.674 1775.78 145.744 1777.38 147.644",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.63 128.641C1762.07 131.126 1763.96 133.611 1767.9 134.196",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.9 134.634C1779.28 136.388 1776.36 137.266 1775.63 134.196",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.42 340.892C1556.42 340.892 1554.38 327.005 1554.08 325.397C1553.79 323.936 1554.38 322.035 1555.54 319.843C1556.71 317.65 1559.92 310.633 1558.9 303.763C1557.88 296.893 1548.1 285.198 1532.21 287.537C1516.31 289.876 1515.43 303.178 1516.02 307.125C1516.6 311.218 1518.79 313.995 1517.47 316.627C1516.16 319.258 1513.83 322.328 1513.97 323.497C1514.12 324.666 1517.91 323.789 1518.35 325.105C1518.64 326.274 1520.54 331.829 1520.98 333.437C1521.41 335.045 1522.43 335.63 1525.21 335.337C1527.98 335.045 1533.23 334.753 1533.66 337.384C1534.1 340.015 1534.69 344.693 1534.69 344.693",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.41 292.215L1513.68 295.577",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.95 284.76L1517.62 289.145",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.85 277.889L1525.35 283.298",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.79 274.82L1533.81 281.544",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.17 275.258L1542.56 281.69",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554.67 279.205L1551.6 284.76",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1562.69 286.075L1558.17 290.022",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.56 317.65C1528.12 315.311 1524.77 315.75 1524.91 313.849C1525.06 311.949 1522.87 310.195 1523.31 308.733C1523.75 307.125 1521.7 304.055 1523.6 302.886C1525.5 301.57 1523.31 298.939 1526.23 298.208C1529.14 297.477 1528.12 295.285 1531.04 294.846C1533.96 294.408 1534.98 292.215 1537.02 293.531C1539.06 294.992 1541.98 292.069 1543 294.846C1544.02 297.624 1546.5 294.992 1546.94 296.893C1547.37 298.793 1551.46 300.401 1550.73 303.324C1550 306.248 1552.92 307.564 1551.02 309.025C1549.12 310.487 1552.48 312.972 1549.85 314.726C1547.23 316.481 1548.4 319.404 1545.33 319.55C1542.27 319.696 1541.1 322.912 1538.77 321.743C1536.44 320.574 1534.1 322.766 1532.79 321.012C1531.62 319.112 1529.43 321.451 1528.56 317.65Z",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.56 312.095C1531.48 311.949 1532.21 310.487 1532.21 308.294C1532.21 305.956 1532.35 304.932 1534.69 303.763C1537.16 302.74 1539.64 302.155 1540.52 300.108C1541.54 298.062 1543.14 295.431 1543.14 295.431",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533.81 296.893C1534.54 298.647 1539.21 299.67 1539.35 301.424",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1529.87 299.67C1530.02 302.009 1533.52 304.201 1533.52 304.201",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1527.54 305.225C1528.12 306.979 1529.87 307.125 1531.62 308.295",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.19 316.919C1536.73 312.534 1539.21 307.125 1544.75 308.294C1550.29 309.464 1550.88 303.763 1550.88 303.763",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.94 305.956C1534.54 305.956 1538.77 307.271 1539.06 309.903",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.75 313.849C1535.85 313.411 1532.94 314.58 1531.18 316.48",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.81 298.5C1545.48 299.378 1543.29 301.424 1543.14 305.371",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.6 319.258C1542.56 316.919 1541.39 314.142 1544.31 312.972",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.24 354.925C1784.24 354.925 1772.42 348.347 1771.11 347.616C1769.8 346.886 1768.05 346.739 1765.71 347.032C1763.38 347.47 1755.94 347.909 1750.25 344.693C1744.42 341.477 1737.27 328.759 1744.71 315.311C1752.15 301.863 1764.26 305.517 1767.76 307.417C1771.11 309.318 1773.01 312.241 1775.78 311.949C1778.7 311.657 1782.2 310.633 1783.22 311.218C1784.24 311.803 1782.2 314.872 1783.22 315.603C1784.24 316.334 1788.47 319.843 1789.78 320.72C1791.09 321.597 1791.24 322.912 1790.07 325.105C1788.91 327.444 1786.86 332.122 1789.05 333.437C1791.24 334.607 1795.32 336.945 1795.32 336.945",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.26 294.261L1758.13 301.132",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.65 296.893L1750.98 302.594",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.46 302.594L1743.11 307.564",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1733.19 311.364L1738.73 314.58",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729.69 321.743L1735.82 322.474",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729.54 332.56L1735.67 331.683",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1733.19 342.062L1738.15 339.43",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.86 322.035C1770.97 320.866 1772.42 317.942 1770.67 317.358C1768.92 316.773 1768.05 314.288 1766.59 314.142C1764.99 314.142 1762.94 311.218 1761.19 312.387C1759.44 313.703 1757.69 310.779 1756.09 313.265C1754.48 315.603 1752.73 313.995 1751.42 316.48C1750.11 318.965 1747.63 319.112 1748.36 321.451C1748.94 323.789 1745.3 325.397 1747.48 327.298C1749.67 329.052 1746.46 330.514 1748.07 331.537C1749.53 332.56 1749.82 336.799 1752.59 337.092C1755.51 337.53 1755.65 340.454 1757.69 339.284C1759.59 338.115 1760.76 341.915 1763.24 340.161C1765.71 338.261 1767.9 340.454 1769.07 337.676C1770.24 334.899 1773.44 335.045 1773.3 332.56C1773.15 330.075 1775.78 328.613 1774.61 326.859C1773.15 325.251 1776.07 324.082 1772.86 322.035Z",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.76 320.135C1766.59 322.766 1765.13 322.912 1763.09 322.181C1761.05 321.304 1760.03 321.158 1758.28 322.912C1756.53 324.666 1755.21 326.859 1753.03 327.005C1750.84 327.151 1747.92 327.736 1747.92 327.736",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.44 319.696C1753.75 321.012 1753.17 325.544 1754.63 326.274",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.23 317.065C1758.28 317.942 1759.15 321.889 1759.15 321.889",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.07 316.919C1763.53 318.088 1762.94 319.696 1763.53 321.597",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.92 330.514C1765.57 327.736 1759.88 328.028 1759.01 333.583C1758.13 338.992 1752.88 337.53 1752.88 337.53",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.9 322.035C1760.32 323.497 1760.17 327.736 1762.36 328.906",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.3 329.052C1766.59 327.151 1768.63 324.959 1770.82 324.082",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.23 332.853C1750.84 330.952 1753.46 329.783 1756.96 330.952",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.92 336.945C1767.61 334.314 1765.42 332.268 1763.38 334.607",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.82 98.8207C1763.82 98.8207 1764.99 88.7344 1765.28 87.1264C1765.42 86.3955 1766.3 85.6646 1767.76 85.8108C1769.65 86.1032 1769.65 88.0035 1769.65 88.0035C1769.65 88.0035 1801.59 91.9503 1803.93 92.2427C1806.26 92.535 1808.45 94.8739 1808.01 98.8207C1807.57 102.768 1804.8 104.083 1802.62 103.937C1800.57 103.645 1768.19 99.6978 1768.19 99.6978C1768.19 99.6978 1767.76 101.598 1765.57 101.306C1764.11 101.16 1763.67 99.6978 1763.82 98.8207Z",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.36 95.1663L1768.92 99.4054",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1771.55 97.359L1771.26 99.6979",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.76 95.8971L1774.17 100.136",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1776.95 98.0898L1776.65 100.429",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780.01 96.4819L1779.57 100.721",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.2 98.6744L1781.9 101.013",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.6 89.3191C1808.6 89.3191 1811.66 64.9073 1811.95 62.4222C1812.24 59.9372 1809.03 55.698 1804.66 57.1598C1800.14 58.6216 1776.8 66.6614 1776.8 66.6614L1763.53 65.0534C1763.53 65.0534 1763.24 63.1531 1761.19 62.8608C1759.88 62.7146 1759.01 63.7378 1758.86 64.4687C1758.71 65.1996 1757.55 75.4321 1757.4 76.6015C1757.26 77.3324 1757.98 78.2095 1759.3 78.3557C1761.19 78.648 1761.78 76.7477 1761.78 76.7477C1761.78 76.7477 1773.01 78.0633 1773.59 78.2095C1774.17 78.2095 1787.74 87.1264 1787.74 87.1264",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.38 65.0535L1762.94 69.2926",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.15 65.3458L1765.86 67.6847",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.36 65.7844L1768.78 70.0236",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1771.99 66.0767L1771.69 68.4155",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.38 61.9836C1793.14 62.5684 1799.7 74.2626 1798.97 86.1031",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607.03 202.461C1607.03 202.461 1611.4 196.468 1612.13 195.445C1612.42 195.006 1613.3 194.86 1614.17 195.591C1615.34 196.468 1614.61 197.783 1614.61 197.783C1614.61 197.783 1633.86 211.963 1635.32 212.986C1636.78 214.009 1637.37 216.348 1635.61 218.687C1633.86 221.026 1631.53 221.026 1630.36 220.003C1629.05 219.125 1609.65 204.8 1609.65 204.8C1609.65 204.8 1608.78 205.969 1607.47 204.946C1606.44 204.069 1606.59 203.046 1607.03 202.461Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1611.99 202.169L1610.09 204.8",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.57 204.361L1611.55 205.823",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.2 204.508L1613.3 207.139",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.78 206.7L1614.76 208.162",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.4 206.847L1616.51 209.478",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.99 209.185L1617.97 210.501",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1639.41 212.548C1639.41 212.548 1650.2 197.784 1651.22 196.322C1652.24 194.86 1651.8 190.913 1648.45 190.182C1645.1 189.451 1626.86 186.235 1626.86 186.235L1618.84 180.388C1618.84 180.388 1619.28 179.073 1618.11 178.196C1617.24 177.611 1616.36 177.903 1616.07 178.342C1615.78 178.78 1611.26 184.92 1610.67 185.651C1610.38 186.089 1610.53 186.82 1611.26 187.405C1612.42 188.282 1613.45 187.259 1613.45 187.259C1613.45 187.259 1620.15 192.229 1620.59 192.521C1620.88 192.813 1626.57 203.484 1626.57 203.484",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.99 180.535L1617.09 183.02",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.59 181.704L1619.57 183.019",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.49 183.166L1620.59 185.651",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.09 184.335L1623.07 185.651",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.24 188.574C1639.12 189.597 1639.26 199.538 1634.45 206.993",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.9 63.2993L1734.5 95.6048L1741.65 96.9204L1747.19 64.3226L1744.42 56.7213L1739.9 63.2993Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.19 64.3225C1747.19 64.3225 1743.98 65.9305 1739.75 63.1531",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.38 90.6346L1742.38 91.9503",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.61 274.82L1553.94 247.777L1547.96 251.87L1566.48 279.205L1573.92 282.713L1572.61 274.82Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.48 279.205C1566.48 279.205 1567.65 275.843 1572.61 274.82",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.85 252.016L1551.02 255.816",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.16 313.265L1805.68 262.979L1794.45 263.418L1796.78 313.995L1803.49 324.52L1808.16 313.265Z",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796.78 313.995C1796.78 313.995 1801.01 310.487 1808.16 313.265",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.97 270.873L1795.18 271.019",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.47 14.6218L1797.22 -8.91293L1792.11 -14.0292L1769.07 9.50556L1767.03 17.3992L1774.47 14.6218Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.07 9.50549C1769.07 9.50549 1772.57 9.94403 1774.47 14.6217",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1897.36 157.522C1902.09 153.619 1902.76 146.617 1898.86 141.883C1894.97 137.15 1887.98 136.477 1883.26 140.38C1878.54 144.284 1877.87 151.285 1881.76 156.019C1885.66 160.753 1892.64 161.426 1897.36 157.522Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.91 148.96L1874.87 148.814C1874.87 152.761 1876.33 156.707 1879.25 159.777C1885.23 165.917 1895 166.063 1901.12 160.069C1904.19 157.146 1905.79 153.199 1905.79 149.252H1903.9",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882.6 141.066C1884.21 144.574 1893.1 148.96 1898.35 141.212",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.85 154.222C1884.21 150.422 1893.98 148.521 1900.25 154.076",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1903.6 162.408L1901.12 159.923",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1900.69 172.202L1913.23 159.923C1913.23 159.923 1911.19 158.023 1909 160.216C1907.98 159.192 1906.81 159.485 1905.65 160.654C1904.48 161.824 1902.15 164.016 1901.42 164.893C1900.69 165.624 1900.1 167.232 1901.12 168.255C1900.25 168.986 1899.08 170.594 1900.69 172.202Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.49 288.56L1813.9 321.45L1821.2 321.743L1821.93 288.706L1818.13 281.544L1814.49 288.56Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.93 288.706C1821.93 288.706 1819.01 290.753 1814.49 288.706",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.05 316.334L1821.05 316.627",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825.43 332.268L1855.18 303.178L1826.59 273.796L1825.43 332.268ZM1844.83 302.74L1833.59 313.703L1834.03 291.63L1844.83 302.74Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.53 282.421L1831.55 281.544",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1831.99 285.929L1833.89 284.029",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1835.2 287.245L1836.22 286.368",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.66 290.753L1838.55 288.853",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.87 292.069L1840.74 291.192",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1841.33 295.577L1843.22 293.677",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.53 296.746L1845.41 295.869",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.99 300.401L1847.89 298.354",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1849.2 301.57L1850.08 300.693",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1948.96 163.578L1920.09 178.196L1935.25 149.545L1964.28 134.927L1948.96 163.578Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.41 102.329L1825.14 131.857L1819.01 99.9901L1832.14 70.462L1838.41 102.329Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.76 82.0101L1855.62 84.349C1855.62 84.349 1860.87 89.7576 1859.26 104.375C1857.66 118.993 1851.24 123.232 1851.24 123.232L1830.39 120.894",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.18 128.787L1853.29 131.711",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1856.64 129.226C1858.39 129.372 1859.56 130.98 1859.26 132.588C1859.12 134.342 1857.51 135.511 1855.91 135.219C1854.16 135.073 1852.99 133.465 1853.29 131.857C1853.43 130.249 1854.89 128.933 1856.64 129.226Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1862.04 134.05C1862.04 134.05 1865.1 136.681 1868.31 136.973C1868.45 135.365 1869.18 129.664 1869.18 129.664C1869.18 129.664 1864.52 129.664 1862.33 131.126",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1908.6 77.4825L1882.27 103.187L1917.18 139.102L1943.51 113.397L1908.6 77.4825Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1913.67 79.0865L1914.69 77.9171L1949.69 113.877L1923.29 139.751L1922.13 138.435",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1897.25 94.3583L1888.06 103.335L1896.81 112.339L1906 103.363L1897.25 94.3583Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1900.54 91.5117L1907.98 84.2028",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1903.75 94.7276L1911.19 87.5648",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1903.02 117.97L1922.27 99.2592",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1906.67 121.771L1925.77 103.06",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910.31 125.425L1929.42 106.714",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920.81 -16.4122L1884.05 -16.6158L1883.78 33.5234L1920.53 33.727L1920.81 -16.4122Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.29 -11.8365H1924.9L1924.61 38.3027L1887.71 38.1565V36.4023",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1901.01 -12.385L1888.18 -12.4561L1888.11 0.115294L1900.94 0.186375L1901.01 -12.385Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888.58 8.4823L1915.27 8.62848",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888.58 13.7448L1915.27 13.8909",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888.44 18.861L1915.27 19.0071",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855.99 152.047L1817.12 154.469L1820.39 207.139L1859.26 204.718L1855.99 152.047Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.02 157.015L1823.07 158.756L1823.46 165.03L1851.41 163.288L1851.02 157.015Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.98 172.675L1823.73 174.435L1825.42 201.573L1853.66 199.813L1851.98 172.675Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1837.82 173.956L1839.57 200.561",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1831.41 180.973L1832.57 200.853",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.12 173.518L1846.72 199.976",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1824.41 181.411L1851.97 179.657",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1824.84 188.282L1852.41 186.528",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825.28 195.152L1852.85 193.398",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895.14 187.697L1882.89 183.019L1870.2 193.106L1872.98 209.77L1888 215.471L1900.54 204.946L1898.79 192.667",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1900.69 189.89C1900.1 191.498 1898.35 192.229 1896.75 191.644C1895.14 191.059 1894.42 189.305 1895 187.697C1895.58 186.089 1897.33 185.358 1898.94 185.943C1900.54 186.674 1901.27 188.428 1900.69 189.89Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1883.77 177.465C1883.33 178.634 1881.87 179.365 1880.71 178.78C1879.54 178.342 1878.81 176.88 1879.39 175.71C1879.83 174.541 1881.29 173.81 1882.46 174.395C1883.62 174.833 1884.21 176.295 1883.77 177.465Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1866.41 218.687C1865.68 220.441 1863.79 221.318 1862.04 220.733C1860.29 220.003 1859.41 218.102 1859.99 216.348C1860.72 214.594 1862.62 213.717 1864.37 214.302C1866.12 214.886 1867 216.933 1866.41 218.687Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1887.56 236.375C1887.12 237.69 1885.52 238.421 1884.21 237.836C1882.89 237.398 1882.16 235.79 1882.75 234.474C1883.18 233.159 1884.79 232.428 1886.1 233.012C1887.41 233.597 1888.14 235.059 1887.56 236.375Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905.91 241.172C1907.99 240.942 1909.49 239.065 1909.26 236.979C1909.03 234.892 1907.16 233.387 1905.08 233.616C1903 233.846 1901.5 235.723 1901.72 237.809C1901.95 239.896 1903.83 241.401 1905.91 241.172Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1900.54 204.946L1915.42 210.647L1918.33 226.873L1908.56 234.62",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888 215.471L1890.62 231.405L1902 235.79",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1922.13 204.946L1915.42 210.647",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882.02 179.219L1882.89 183.019",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865.68 215.179L1872.98 209.77",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.62 231.404L1887.27 233.597",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875.89 15.6452C1875.89 15.6452 1865.83 6.14361 1864.81 5.12036C1863.64 4.09711 1862.91 2.34296 1862.62 0.00410883C1862.33 -2.33475 1860.43 -9.78985 1855.62 -14.3214C1850.66 -18.9991 1836.07 -21.9227 1825.43 -10.5207C1814.63 0.881178 1821.93 11.6984 1824.84 14.3296C1827.76 17.107 1831.12 17.9841 1831.7 20.7615C1832.28 23.685 1832.43 27.3395 1833.3 28.2166C1834.18 28.9474 1836.51 26.0239 1837.53 26.7548C1838.55 27.4857 1843.22 30.5554 1844.53 31.5787C1845.85 32.6019 1847.01 32.4557 1848.91 30.5554C1850.81 28.6551 1854.74 25.293 1856.64 27.0471C1858.54 28.8013 1861.89 32.0172 1861.89 32.0172",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.8 8.04382L1815.66 6.87439",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.65 -1.01929L1814.78 -0.580753",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1840.45 14.6219C1838.7 13.1601 1836.37 15.4989 1835.35 13.891C1834.18 12.283 1831.55 12.4292 1830.97 10.8212C1830.39 9.35943 1826.89 8.19 1827.62 6.1435C1828.34 3.95083 1824.99 3.21993 1826.89 0.881076C1828.64 -1.45778 1826.59 -2.62721 1828.49 -4.67371C1830.39 -6.7202 1829.8 -9.05906 1832.28 -9.20524C1834.76 -9.35142 1835.2 -13.4444 1837.68 -11.8365C1840.16 -10.2285 1840.45 -13.7368 1842.05 -12.7135C1843.51 -11.5441 1847.6 -12.7135 1848.91 -10.0823C1850.22 -7.4511 1853.14 -8.18199 1852.56 -5.84313C1851.97 -3.50428 1856.2 -3.65045 1855.04 -0.726885C1854.01 2.19668 1856.79 3.80465 1854.45 5.70497C1852.12 7.60529 1853.28 10.8212 1850.81 11.4059C1848.33 11.9906 1847.74 15.0604 1845.7 14.4757C1843.8 14.0371 1843.51 17.1069 1840.45 14.6219Z",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1837.24 10.3828C1839.43 8.48244 1839.14 7.02066 1837.68 5.26652C1836.22 3.51238 1835.64 2.63531 1836.95 0.296451C1838.12 -2.0424 1839.87 -3.94272 1839.28 -6.1354C1838.85 -8.32808 1838.41 -11.3978 1838.41 -11.3978",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.68 0.00402832C1832.14 1.75817 1836.22 1.31963 1836.22 1.31963",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1832.14 5.85107C1833.74 6.87432 1835.05 5.85107 1837.1 5.85107",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1847.6 8.33621C1843.8 5.85118 1842.49 0.2964 1847.45 -2.33481C1852.41 -4.81985 1849.35 -9.49756 1849.35 -9.49756",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.8 3.07365C1838.12 2.05041 1842.2 0.588621 1843.95 2.34276",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.26 6.28967C1843.51 7.16674 1842.05 9.79796 1841.91 12.283",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.72 6.28959C1850.66 5.70488 1848.18 4.38927 1849.64 1.75806",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1868.45 280.959C1868.45 280.959 1857.66 274.966 1856.49 274.235C1855.33 273.504 1853.72 273.358 1851.53 273.796C1849.35 274.089 1842.64 274.673 1837.24 271.604C1831.99 268.68 1825.28 256.986 1832.14 244.561C1838.99 232.135 1850.22 235.498 1853.28 237.252C1856.49 239.006 1858.1 241.637 1860.72 241.345C1863.35 241.052 1866.56 240.175 1867.58 240.614C1868.45 241.052 1866.56 243.976 1867.58 244.707C1868.45 245.438 1872.39 248.654 1873.7 249.384C1874.87 250.262 1875.02 251.285 1874 253.477C1872.97 255.67 1871.08 259.909 1873.12 261.079C1875.16 262.248 1878.81 264.295 1878.81 264.295",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843.51 225.265L1844.39 231.405",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1835.64 227.604L1837.82 232.72",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.18 232.866L1830.68 237.398",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.34 240.906L1826.45 243.83",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1818.28 250.408L1823.97 251.139",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1818.13 260.348L1823.82 259.617",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.49 269.119L1826.01 266.634",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1857.95 250.7C1856.2 249.531 1857.51 247.046 1855.91 246.461C1854.31 245.876 1853.58 243.537 1852.12 243.537C1850.66 243.537 1848.76 240.76 1847.16 241.929C1845.55 243.099 1843.95 240.468 1842.49 242.66C1841.03 244.853 1839.43 243.391 1838.26 245.584C1837.1 247.776 1834.91 247.923 1835.35 250.115C1835.93 252.308 1832.57 253.77 1834.62 255.524C1836.66 257.132 1833.74 258.448 1835.05 259.471C1836.51 260.494 1836.66 264.295 1839.28 264.587C1841.91 264.879 1842.05 267.657 1843.95 266.634C1845.7 265.464 1846.72 269.119 1849.06 267.364C1851.24 265.61 1853.43 267.657 1854.45 265.172C1855.47 262.687 1858.54 262.833 1858.39 260.494C1858.24 258.155 1860.58 256.84 1859.56 255.378C1858.24 253.624 1860.87 252.6 1857.95 250.7Z",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.29 248.946C1852.26 251.285 1850.81 251.577 1849.06 250.846C1847.16 250.115 1846.28 249.823 1844.53 251.577C1842.93 253.185 1841.76 255.232 1839.72 255.378C1837.68 255.524 1835.05 256.109 1835.05 256.109",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.14 248.507C1840.45 249.677 1839.87 253.916 1841.18 254.501",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1842.64 246.169C1844.53 247.046 1845.26 250.554 1845.26 250.554",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1848.03 246.022C1849.35 247.046 1848.91 248.507 1849.35 250.262",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1854.45 258.448C1851.39 255.816 1846.14 256.255 1845.26 261.225C1844.39 266.195 1839.72 264.879 1839.72 264.879",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1846.87 250.7C1846.28 252.016 1846.14 255.963 1848.18 256.986",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.97 257.132C1852.26 255.378 1854.16 253.331 1856.2 252.6",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.22 260.64C1837.68 258.886 1840.01 257.863 1843.37 258.886",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1854.31 264.441C1852.99 261.956 1851.1 260.202 1849.35 262.248",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1852.99 65.1996C1852.99 65.1996 1857.37 59.2063 1858.1 58.1831C1858.39 57.7445 1859.26 57.5984 1860.14 58.3293C1861.31 59.2063 1860.58 60.5219 1860.58 60.5219C1860.58 60.5219 1879.83 74.7012 1881.29 75.7245C1882.75 76.7477 1883.33 79.0866 1881.58 81.4255C1879.83 83.7643 1877.5 83.7643 1876.33 82.7411C1875.02 81.864 1855.62 67.5385 1855.62 67.5385C1855.62 67.5385 1854.74 68.7079 1853.43 67.6847C1852.41 66.8076 1852.7 65.7844 1852.99 65.1996Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1857.95 64.9072L1856.06 67.5384",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1858.54 67.0999L1857.51 68.5616",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1861.16 67.2461L1859.26 69.8773",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1861.74 69.4388L1860.72 70.9006",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.37 69.585L1862.47 72.2162",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.95 71.7776L1863.93 73.2394",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885.37 75.2859C1885.37 75.2859 1896.17 60.5219 1897.19 59.0601C1898.21 57.5984 1897.77 53.6515 1894.42 52.9206C1891.06 52.1898 1872.83 48.9738 1872.83 48.9738L1864.81 43.1267C1864.81 43.1267 1865.24 41.8111 1864.08 40.934C1863.2 40.3493 1862.33 40.6416 1862.04 41.0802C1861.74 41.5187 1857.22 47.6582 1856.64 48.3891C1856.35 48.8276 1856.49 49.5585 1857.22 50.1433C1858.39 51.0203 1859.41 49.9971 1859.41 49.9971C1859.41 49.9971 1866.12 54.9671 1866.56 55.2595C1866.85 55.5519 1872.54 66.2229 1872.54 66.2229",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.95 43.2728L1863.06 45.7579",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1866.56 44.4423L1865.54 45.7579",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1868.45 45.9041L1866.7 48.3891",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870.2 47.0734L1869.18 48.389",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1884.21 51.3126C1885.08 52.3359 1885.23 62.276 1880.41 69.7311",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1822.51 37.8643L1839.14 66.0767L1845.41 62.5684L1828.93 33.9175L1821.78 29.8245L1822.51 37.8643Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828.93 33.9175C1828.93 33.9175 1827.62 37.2796 1822.51 37.7181",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.51 61.6913L1842.78 58.3292",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1829.37 351.417H1879.98V301.424L1829.37 351.417ZM1871.37 342.208H1852.26L1871.37 323.351V342.208Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.18 312.387H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874.43 316.627H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.18 320.427H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874.43 324.813H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.18 328.613H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874.43 332.852H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.18 336.799H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874.43 341.038H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.18 344.839H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1935.84 340.892C1935.84 340.892 1933.8 327.005 1933.5 325.397C1933.21 323.936 1933.8 322.035 1934.96 319.843C1936.13 317.65 1939.34 310.633 1938.32 303.763C1937.3 296.893 1927.52 285.198 1911.63 287.537C1895.73 289.876 1894.85 303.178 1895.44 307.125C1896.02 311.218 1898.21 313.995 1896.89 316.627C1895.58 319.258 1893.25 322.328 1893.39 323.497C1893.54 324.666 1897.33 323.789 1897.77 325.105C1898.06 326.274 1899.96 331.829 1900.4 333.437C1900.83 335.045 1901.85 335.63 1904.62 335.337C1907.4 335.045 1912.65 334.753 1913.08 337.384C1913.52 340.015 1914.11 344.693 1914.11 344.693",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1886.83 292.215L1893.1 295.577",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1892.37 284.76L1897.04 289.145",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1901.27 277.889L1904.77 283.298",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.21 274.82L1913.23 281.544",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1907.98 317.65C1907.54 315.311 1904.19 315.75 1904.33 313.849C1904.48 311.949 1902.29 310.195 1902.73 308.733C1903.17 307.125 1901.12 304.055 1903.02 302.886C1904.92 301.57 1902.73 298.939 1905.65 298.208C1908.56 297.477 1907.54 295.285 1910.46 294.846C1913.38 294.408 1914.4 292.215 1916.44 293.531C1918.48 294.992 1921.4 292.069 1922.42 294.846C1923.44 297.624 1925.92 294.992 1926.36 296.893C1926.79 298.793 1930.88 300.401 1930.15 303.324C1929.42 306.248 1932.34 307.564 1930.44 309.025C1928.54 310.487 1931.9 312.972 1929.27 314.726C1926.65 316.481 1927.82 319.404 1924.75 319.55C1921.69 319.696 1920.52 322.912 1918.19 321.743C1915.86 320.574 1913.52 322.766 1912.21 321.012C1911.04 319.112 1908.85 321.451 1907.98 317.65Z",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1907.98 312.095C1910.9 311.949 1911.63 310.487 1911.63 308.294C1911.63 305.956 1911.77 304.932 1914.11 303.763C1916.58 302.74 1919.06 302.155 1919.94 300.108C1920.96 298.062 1922.56 295.431 1922.56 295.431",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1913.23 296.893C1913.96 298.647 1918.63 299.67 1918.77 301.424",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.29 299.67C1909.44 302.009 1912.94 304.201 1912.94 304.201",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1906.96 305.225C1907.54 306.979 1909.29 307.125 1911.04 308.295",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917.61 316.919C1916.15 312.534 1918.63 307.125 1924.17 308.294C1929.71 309.464 1930.29 303.763 1930.29 303.763",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.36 305.956C1913.96 305.956 1918.19 307.271 1918.48 309.903",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917.17 313.849C1915.27 313.411 1912.36 314.58 1910.6 316.48",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedBg);
export default __webpack_public_path__ + "static/media/featuredBG.e6e4a936eb148bcc8c66f3f100393b01.svg";
export { ForwardRef as ReactComponent };